export const companySearchMap: Record<string, string> = {
  // === AyeSearch entries ===
  ayesearch: "/companies/ayesearch",
  "aye search": "/companies/ayesearch",
  "aye-search": "/companies/ayesearch",
  "ayesearch app": "/companies/ayesearch",
  "ayesearch website": "/companies/ayesearch",
  "aye search engine": "/companies/ayesearch",
  "aye ai search": "/companies/ayesearch",

  // === TubeTok entries ===
  tubetok: "/companies/tubetok",
  "tube tok": "/companies/tubetok",
  "tube-tok": "/companies/tubetok",
  "tubetok app": "/companies/tubetok",
  "tubetok website": "/companies/tubetok",

  // ============================================================
  // === Aikiepedia (ID: -2) ===
  // ============================================================
  aikiepedia: "/companies/aikiepedia",
  "aiki epedia": "/companies/aikiepedia",
  "aiki-epedia": "/companies/aikiepedia",
  "aikiepedia app": "/companies/aikiepedia",
  "aikiepedia website": "/companies/aikiepedia",
  "aiki wiki": "/companies/aikiepedia",
  "aiki knowledge": "/companies/aikiepedia",

  // ============================================================
  // === ADocs (ID: -3) ===
  // ============================================================
  adocs: "/companies/adocs",
  "a docs": "/companies/adocs",
  "a-docs": "/companies/adocs",
  "adocs app": "/companies/adocs",
  "adocs website": "/companies/adocs",
  "adocs editor": "/companies/adocs",
  "adocs document": "/companies/adocs",

  // ============================================================
  // === ANote (ID: -4) ===
  // ============================================================
  anote: "/companies/anote",
  "a note": "/companies/anote",
  "a-note": "/companies/anote",
  "anote app": "/companies/anote",
  "anote website": "/companies/anote",
  "anote notes": "/companies/anote",
  "anote notepad": "/companies/anote",

  // ============================================================
  // === AMail (ID: -5) ===
  // ============================================================
  amail: "/companies/amail",
  "a mail": "/companies/amail",
  "a-mail": "/companies/amail",
  "amail app": "/companies/amail",
  "amail website": "/companies/amail",
  "amail email": "/companies/amail",
  "amail inbox": "/companies/amail",

  // ============================================================
  // === ADrive (ID: -6) ===
  // ============================================================
  adrive: "/companies/adrive",
  "a drive": "/companies/adrive",
  "a-drive": "/companies/adrive",
  "adrive app": "/companies/adrive",
  "adrive website": "/companies/adrive",
  "adrive storage": "/companies/adrive",
  "adrive cloud": "/companies/adrive",

  // ============================================================
  // === MeChat (ID: -7) ===
  // ============================================================
  mechat: "/companies/mechat",
  "me chat": "/companies/mechat",
  "me-chat": "/companies/mechat",
  "mechat app": "/companies/mechat",
  "mechat website": "/companies/mechat",
  "mechat messenger": "/companies/mechat",
  "mechat chat": "/companies/mechat",

  nvidia: "/companies/nvidia",
  "nvidia-corp": "/companies/nvidia",

  apple: "/companies/apple",
  "apple-inc": "/companies/apple",

  alphabet: "/companies/alphabet",
  google: "/companies/alphabet",
  "google-inc": "/companies/alphabet",

  microsoft: "/companies/microsoft",
  msft: "/companies/microsoft",

  amazon: "/companies/amazon",
  "amazon-com": "/companies/amazon",

  meta: "/companies/meta",
  facebook: "/companies/meta",

  tesla: "/companies/tesla",
  "tesla-motors": "/companies/tesla",

  "berkshire-hathaway": "/companies/berkshire-hathaway",
  walmart: "/companies/walmart",

  jpmorgan: "/companies/jpmorgan-chase",
  "jpmorgan-chase": "/companies/jpmorgan-chase",

  cencora: "/companies/cencora",
  amerisourcebergen: "/companies/cencora",
  "amerisource bergen": "/companies/cencora",

  // === All companies from your JSON (organized by slug) ===

  // Major US / Global Companies
  "unitedhealth-group": "/companies/unitedhealth-group",
  unitedhealth: "/companies/unitedhealth-group",
  "cvs-health": "/companies/cvs-health",

  /* mckesson */
  mckesson: "/companies/mckesson",
  "mckesson corp": "/companies/mckesson",
  "mckesson corporation": "/companies/mckesson",
  "mckesson texas": "/companies/mckesson",
  "mckesson irving": "/companies/mckesson",

  /* pharmaceutical distribution */
  "mckesson pharma": "/companies/mckesson",
  "mckesson pharmaceutical": "/companies/mckesson",
  "mckesson drug distribution": "/companies/mckesson",

  /* healthcare it */
  "mckesson health it": "/companies/mckesson",
  "mckesson healthcare it": "/companies/mckesson",
  "mckesson technology": "/companies/mckesson",

  /* medical supplies */
  "mckesson medical": "/companies/mckesson",
  "mckesson medical supplies": "/companies/mckesson",

  /* ticker lookups */
  mck: "/companies/mckesson",
  "mck stock": "/companies/mckesson",
  "mckesson stock": "/companies/mckesson",
  /* mckesson */

  "exxon-mobil": "/companies/exxon-mobil",
  exxon: "/companies/exxon-mobil",
  exxonmobil: "/companies/exxon-mobil",
  costco: "/companies/costco",
  /* chevron */
  chevron: "/companies/chevron",
  "chevron corporation": "/companies/chevron",
  "chevron corp": "/companies/chevron",
  "chevron oil": "/companies/chevron",
  "chevron energy": "/companies/chevron",
  "chevron gas": "/companies/chevron",
  "chevron usa": "/companies/chevron",
  "chevron company": "/companies/chevron",
  cvx: "/companies/chevron",
  "chevron stock": "/companies/chevron",
  "chevron petroleum": "/companies/chevron",
  "chevron texaco": "/companies/chevron",
  "chevron global": "/companies/chevron",
  /* chevron */

  "cardinal-health": "/companies/cardinal-health",
  "home-depot": "/companies/home-depot",
  kroger: "/companies/kroger",
  "walgreens-boots-alliance": "/companies/walgreens",
  walgreens: "/companies/walgreens",
  ford: "/companies/ford",
  /* general-motors */
  "general-motors": "/companies/general-motors",
  gm: "/companies/general-motors",
  "gm motors": "/companies/general-motors",
  "general motors": "/companies/general-motors",
  "gm detroit": "/companies/general-motors",
  "gm vehicles": "/companies/general-motors",
  "gm chevrolet": "/companies/general-motors",
  "gm cadillac": "/companies/general-motors",
  "gm buick": "/companies/general-motors",
  "gm gmc": "/companies/general-motors",
  "gm stock": "/companies/general-motors",
  /* general-motors */

  "bank-of-america": "/companies/bank-of-america",
  "goldman-sachs": "/companies/goldman-sachs",
  "morgan-stanley": "/companies/morgan-stanley",
  intel: "/companies/intel",
  /* netflix */
  netflix: "/companies/netflix",
  "netflix inc": "/companies/netflix",
  "netflix company": "/companies/netflix",
  "netflix streaming": "/companies/netflix",
  "netflix service": "/companies/netflix",
  "netflix originals": "/companies/netflix",
  "netflix tv": "/companies/netflix",
  "netflix movies": "/companies/netflix",
  nflx: "/companies/netflix",
  "netflix stock": "/companies/netflix",
  "netflix usa": "/companies/netflix",
  "netflix global": "/companies/netflix",
  /* netflix */

  /* adobe */
  adobe: "/companies/adobe",
  "adobe inc": "/companies/adobe",
  "adobe systems": "/companies/adobe",
  "adobe san jose": "/companies/adobe",
  "adobe california": "/companies/adobe",

  /* creative cloud */
  "adobe creative cloud": "/companies/adobe",
  "creative cloud": "/companies/adobe",
  "adobe cc": "/companies/adobe",

  /* photoshop */
  photoshop: "/companies/adobe",
  "adobe photoshop": "/companies/adobe",

  /* illustrator */
  illustrator: "/companies/adobe",
  "adobe illustrator": "/companies/adobe",

  /* general creative tools */
  "adobe creative": "/companies/adobe",
  "adobe design": "/companies/adobe",
  "adobe software": "/companies/adobe",

  /* ticker lookups */
  adbe: "/companies/adobe",
  "adbe stock": "/companies/adobe",
  "adobe stock": "/companies/adobe",
  /* adobe */

  /* salesforce */
  salesforce: "/companies/salesforce",
  "sales force": "/companies/salesforce",
  "salesforce inc": "/companies/salesforce",
  "salesforce corporation": "/companies/salesforce",
  "salesforce san francisco": "/companies/salesforce",
  "salesforce california": "/companies/salesforce",

  /* crm */
  "salesforce crm": "/companies/salesforce",
  "sf crm": "/companies/salesforce",
  "salesforce customer management": "/companies/salesforce",

  /* cloud platform */
  "salesforce cloud": "/companies/salesforce",
  "salesforce cloud platform": "/companies/salesforce",
  "salesforce platform": "/companies/salesforce",

  /* slack */
  "salesforce slack": "/companies/salesforce",
  "slack salesforce": "/companies/salesforce",

  /* ticker lookups */
  crm: "/companies/salesforce",
  "crm stock": "/companies/salesforce",
  "salesforce stock": "/companies/salesforce",
  /* salesforce */

  /* pepsico */
  pepsico: "/companies/pepsico",
  "pepsi co": "/companies/pepsico",
  "pepsi-co": "/companies/pepsico",
  "pepsico inc": "/companies/pepsico",
  "pepsico corporation": "/companies/pepsico",
  "pepsico company": "/companies/pepsico",
  pepsi: "/companies/pepsico",
  "pepsi company": "/companies/pepsico",
  "pepsi corporation": "/companies/pepsico",
  "pepsi brand": "/companies/pepsico",
  "pepsi drinks": "/companies/pepsico",
  "pepsi beverages": "/companies/pepsico",
  "pepsi snacks": "/companies/pepsico",
  "pepsi food": "/companies/pepsico",
  "pepsi global": "/companies/pepsico",
  "pepsico usa": "/companies/pepsico",
  pep: "/companies/pepsico",
  "pep stock": "/companies/pepsico",
  "pepsico stock": "/companies/pepsico",
  /* pepsico */

  "coca-cola": "/companies/coca-cola",

  /* pfizer */
  pfizer: "/companies/pfizer",
  "pfizer inc": "/companies/pfizer",
  "pfizer corporation": "/companies/pfizer",
  "pfizer new york": "/companies/pfizer",
  "pfizer nyc": "/companies/pfizer",

  /* vaccines */
  "pfizer vaccine": "/companies/pfizer",
  "pfizer vaccines": "/companies/pfizer",
  "pfizer covid vaccine": "/companies/pfizer",

  /* pharmaceuticals */
  "pfizer pharma": "/companies/pfizer",
  "pfizer pharmaceuticals": "/companies/pfizer",
  "pfizer medicine": "/companies/pfizer",

  /* ticker lookups */
  pfe: "/companies/pfizer",
  "pfe stock": "/companies/pfizer",
  "pfizer stock": "/companies/pfizer",
  /* pfizer */

  /* cisco */
  cisco: "/companies/cisco",
  "cisco systems": "/companies/cisco",
  "cisco system": "/companies/cisco",
  "cisco inc": "/companies/cisco",
  "cisco corporation": "/companies/cisco",
  "cisco networking": "/companies/cisco",
  "cisco hardware": "/companies/cisco",
  "cisco routers": "/companies/cisco",
  "cisco switches": "/companies/cisco",
  "cisco security": "/companies/cisco",
  csco: "/companies/cisco",
  "cisco stock": "/companies/cisco",
  "cisco usa": "/companies/cisco",
  /* cisco */

  oracle: "/companies/oracle",
  /* qualcomm */
  qualcomm: "/companies/qualcomm",
  "qualcomm inc": "/companies/qualcomm",
  "qualcomm incorporated": "/companies/qualcomm",
  "qualcomm company": "/companies/qualcomm",
  "qualcomm corporation": "/companies/qualcomm",
  "qualcomm technologies": "/companies/qualcomm",
  "qualcomm tech": "/companies/qualcomm",
  "qualcomm semiconductor": "/companies/qualcomm",
  "qualcomm chips": "/companies/qualcomm",
  "qualcomm processors": "/companies/qualcomm",
  "qualcomm snapdragon": "/companies/qualcomm",
  snapdragon: "/companies/qualcomm",
  "snapdragon chips": "/companies/qualcomm",
  "snapdragon processors": "/companies/qualcomm",
  qcom: "/companies/qualcomm",
  "qcom stock": "/companies/qualcomm",
  "qualcomm stock": "/companies/qualcomm",
  "qualcomm san diego": "/companies/qualcomm",
  /* qualcomm */

  broadcom: "/companies/broadcom",
  ibm: "/companies/ibm",
  atandt: "/companies/att",
  att: "/companies/att",
  /* verizon */
  verizon: "/companies/verizon",
  "verizon wireless": "/companies/verizon",
  "verizon communications": "/companies/verizon",
  "verizon communications inc": "/companies/verizon",
  "verizon corp": "/companies/verizon",
  "verizon corporation": "/companies/verizon",
  "verizon company": "/companies/verizon",
  "verizon new york": "/companies/verizon",
  "verizon nyc": "/companies/verizon",
  "verizon broadband": "/companies/verizon",
  "verizon internet": "/companies/verizon",
  "verizon 5g": "/companies/verizon",
  "verizon mobile": "/companies/verizon",
  vz: "/companies/verizon",
  "vz stock": "/companies/verizon",
  "verizon stock": "/companies/verizon",
  /* verizon */

  /* comcast */
  comcast: "/companies/comcast",
  "comcast corporation": "/companies/comcast",
  "comcast philly": "/companies/comcast",
  "comcast philadelphia": "/companies/comcast",
  "comcast pennsylvania": "/companies/comcast",

  /* xfinity */
  xfinity: "/companies/comcast",
  "xfinity internet": "/companies/comcast",
  "xfinity mobile": "/companies/comcast",
  "xfinity tv": "/companies/comcast",
  "xfinity home": "/companies/comcast",

  /* nbcuniversal */
  nbcuniversal: "/companies/comcast",
  "nbc universal": "/companies/comcast",
  nbc: "/companies/comcast",
  "nbc news": "/companies/comcast",
  "nbc tv": "/companies/comcast",
  "universal studios": "/companies/comcast",

  /* sky */
  sky: "/companies/comcast",
  "sky tv": "/companies/comcast",
  "sky media": "/companies/comcast",

  /* media & technology */
  "comcast media": "/companies/comcast",
  "comcast technology": "/companies/comcast",
  "comcast broadband": "/companies/comcast",
  "comcast cable": "/companies/comcast",

  /* ticker lookups */
  cmcsa: "/companies/comcast",
  "cmcsa stock": "/companies/comcast",
  "comcast stock": "/companies/comcast",
  /* comcast */

  /* disney */
  disney: "/companies/disney",
  "walt disney": "/companies/disney",
  "the walt disney company": "/companies/disney",
  "walt disney company": "/companies/disney",
  "disney company": "/companies/disney",
  "disney corp": "/companies/disney",
  "disney corporation": "/companies/disney",
  "disney inc": "/companies/disney",
  "disney burbank": "/companies/disney",
  "disney california": "/companies/disney",

  /* entertainment divisions */
  "disney entertainment": "/companies/disney",
  "disney media": "/companies/disney",
  "disney studios": "/companies/disney",
  "walt disney studios": "/companies/disney",

  /* streaming + networks */
  "disney plus": "/companies/disney",
  "disney+": "/companies/disney",
  espn: "/companies/disney",
  "espn network": "/companies/disney",

  /* major subsidiaries */
  marvel: "/companies/disney",
  "marvel studios": "/companies/disney",
  pixar: "/companies/disney",
  "pixar animation": "/companies/disney",
  lucasfilm: "/companies/disney",
  "star wars": "/companies/disney",
  "20th century studios": "/companies/disney",
  "national geographic": "/companies/disney",

  /* parks + resorts */
  "disney parks": "/companies/disney",
  "disney world": "/companies/disney",
  disneyland: "/companies/disney",

  /* ticker lookups */
  dis: "/companies/disney",
  "dis stock": "/companies/disney",
  "disney stock": "/companies/disney",
  /* disney */

  /* nike */
  nike: "/companies/nike",
  "nike inc": "/companies/nike",
  "nike shoes": "/companies/nike",
  "nike apparel": "/companies/nike",
  "nike sports": "/companies/nike",
  "nike beaverton": "/companies/nike",
  nke: "/companies/nike",
  "nke stock": "/companies/nike",
  "nike stock": "/companies/nike",
  /* nike */

  starbucks: "/companies/starbucks",

  /* mcdonalds */
  mcdonalds: "/companies/mcdonalds",
  "mc donalds": "/companies/mcdonalds",
  "mcdonald's": "/companies/mcdonalds",
  "mc donald's": "/companies/mcdonalds",
  "mcdonalds corporation": "/companies/mcdonalds",
  "mcdonald's corporation": "/companies/mcdonalds",
  "mcdonalds corp": "/companies/mcdonalds",
  "mcdonald's corp": "/companies/mcdonalds",
  "mcdonalds company": "/companies/mcdonalds",
  "mcdonald's company": "/companies/mcdonalds",
  "mcdonalds usa": "/companies/mcdonalds",
  "mcdonalds chicago": "/companies/mcdonalds",
  "mcdonalds fast food": "/companies/mcdonalds",
  "mcdonalds burgers": "/companies/mcdonalds",
  "mcdonalds restaurant": "/companies/mcdonalds",
  "mcdonalds franchise": "/companies/mcdonalds",
  "mcdonalds global": "/companies/mcdonalds",
  mcd: "/companies/mcdonalds",
  "mcd stock": "/companies/mcdonalds",
  "mcdonalds stock": "/companies/mcdonalds",
  /* mcdonalds */

  chipotle: "/companies/chipotle",
  target: "/companies/target",
  /* lowes */
  lowes: "/companies/lowes",
  "lowe's": "/companies/lowes",
  "lowes home improvement": "/companies/lowes",
  "lowe's home improvement": "/companies/lowes",
  "lowes mooresville": "/companies/lowes",
  "lowes north carolina": "/companies/lowes",

  /* home improvement */
  "lowes home": "/companies/lowes",
  "lowes home store": "/companies/lowes",
  "lowes remodeling": "/companies/lowes",

  /* appliances */
  "lowes appliances": "/companies/lowes",
  "lowes fridge": "/companies/lowes",
  "lowes washer": "/companies/lowes",
  "lowes dryer": "/companies/lowes",

  /* tools */
  "lowes tools": "/companies/lowes",
  "lowes power tools": "/companies/lowes",
  "lowes hardware": "/companies/lowes",

  /* building materials */
  "lowes lumber": "/companies/lowes",
  "lowes building materials": "/companies/lowes",

  /* ticker lookups */
  low: "/companies/lowes",
  "low stock": "/companies/lowes",
  "lowes stock": "/companies/lowes",
  /* lowes */

  /* delta-electronics */
  "delta-electronics": "/companies/delta-electronics",
  "delta electronics": "/companies/delta-electronics",
  delta: "/companies/delta-electronics",
  "delta inc": "/companies/delta-electronics",
  "delta electronics inc": "/companies/delta-electronics",
  "delta electronics corporation": "/companies/delta-electronics",
  "delta taiwan": "/companies/delta-electronics",
  "delta taipei": "/companies/delta-electronics",

  /* power + thermal management */
  "delta power": "/companies/delta-electronics",
  "delta power supply": "/companies/delta-electronics",
  "delta power supplies": "/companies/delta-electronics",
  "delta thermal": "/companies/delta-electronics",
  "delta cooling": "/companies/delta-electronics",
  "delta thermal management": "/companies/delta-electronics",

  /* automation + industrial systems */
  "delta automation": "/companies/delta-electronics",
  "delta industrial automation": "/companies/delta-electronics",
  "delta industrial": "/companies/delta-electronics",
  "delta plc": "/companies/delta-electronics",
  "delta drives": "/companies/delta-electronics",
  "delta servo": "/companies/delta-electronics",

  /* renewable + infrastructure */
  "delta renewable": "/companies/delta-electronics",
  "delta solar": "/companies/delta-electronics",
  "delta energy systems": "/companies/delta-electronics",
  "delta networking": "/companies/delta-electronics",
  "delta infrastructure": "/companies/delta-electronics",

  /* ticker lookups */
  2308: "/companies/delta-electronics",
  "2308 stock": "/companies/delta-electronics",
  "delta electronics stock": "/companies/delta-electronics",
  /* delta-electronics */

  "american-airlines": "/companies/american-airlines",
  "united-airlines": "/companies/united-airlines",
  southwest: "/companies/southwest",
  boeing: "/companies/boeing",

  /* lockheed-martin */
  "lockheed-martin": "/companies/lockheed-martin",
  "lockheed martin": "/companies/lockheed-martin",
  lockheed: "/companies/lockheed-martin",
  "lockheed martin corp": "/companies/lockheed-martin",
  "lockheed martin corporation": "/companies/lockheed-martin",
  "lockheed bethesda": "/companies/lockheed-martin",
  "lockheed maryland": "/companies/lockheed-martin",

  /* aerospace */
  "lockheed aerospace": "/companies/lockheed-martin",
  "lockheed space": "/companies/lockheed-martin",
  "lockheed space systems": "/companies/lockheed-martin",

  /* defense systems */
  "lockheed defense": "/companies/lockheed-martin",
  "lockheed defense systems": "/companies/lockheed-martin",
  "lockheed military": "/companies/lockheed-martin",

  /* aircraft */
  "lockheed aircraft": "/companies/lockheed-martin",
  "lockheed jets": "/companies/lockheed-martin",
  "lockheed f35": "/companies/lockheed-martin",
  f35: "/companies/lockheed-martin",
  "f-35": "/companies/lockheed-martin",

  /* missiles */
  "lockheed missiles": "/companies/lockheed-martin",
  "lockheed missile systems": "/companies/lockheed-martin",

  /* ticker lookups */
  lmt: "/companies/lockheed-martin",
  "lmt stock": "/companies/lockheed-martin",
  "lockheed martin stock": "/companies/lockheed-martin",
  /* lockheed-martin */

  raytheon: "/companies/raytheon",

  /* northrop-grumman */
  "northrop-grumman": "/companies/northrop-grumman",
  "northrop grumman": "/companies/northrop-grumman",
  northrop: "/companies/northrop-grumman",
  grumman: "/companies/northrop-grumman",
  "northrop defense": "/companies/northrop-grumman",
  "northrop aerospace": "/companies/northrop-grumman",
  "northrop cybersecurity": "/companies/northrop-grumman",
  noc: "/companies/northrop-grumman",
  "noc stock": "/companies/northrop-grumman",
  /* northrop-grumman */

  "general-electric": "/companies/general-electric",

  "3m": "/companies/3m",
  caterpillar: "/companies/caterpillar",
  deere: "/companies/deere",
  ups: "/companies/ups",
  /* fedex */
  fedex: "/companies/fedex",
  "fed ex": "/companies/fedex",
  "federal express": "/companies/fedex",
  "fedex corporation": "/companies/fedex",
  "fedex memphis": "/companies/fedex",
  "fedex tennessee": "/companies/fedex",

  /* shipping */
  "fedex shipping": "/companies/fedex",
  "fedex delivery": "/companies/fedex",
  "fedex express": "/companies/fedex",

  /* logistics */
  "fedex logistics": "/companies/fedex",
  "fedex supply chain": "/companies/fedex",

  /* freight */
  "fedex freight": "/companies/fedex",
  "fedex ground": "/companies/fedex",

  /* ticker lookups */
  fdx: "/companies/fedex",
  "fdx stock": "/companies/fedex",
  "fedex stock": "/companies/fedex",
  /* fedex */

  /* honeywell */
  honeywell: "/companies/honeywell",
  "honeywell inc": "/companies/honeywell",
  "honeywell corporation": "/companies/honeywell",
  "honeywell charlotte": "/companies/honeywell",
  "honeywell north carolina": "/companies/honeywell",

  /* aerospace */
  "honeywell aerospace": "/companies/honeywell",
  "honeywell aircraft systems": "/companies/honeywell",
  "honeywell avionics": "/companies/honeywell",

  /* industrial automation */
  "honeywell industrial": "/companies/honeywell",
  "honeywell industrial automation": "/companies/honeywell",
  "honeywell automation": "/companies/honeywell",

  /* building technologies */
  "honeywell building": "/companies/honeywell",
  "honeywell building technologies": "/companies/honeywell",
  "honeywell hvac": "/companies/honeywell",

  /* safety + productivity */
  "honeywell safety": "/companies/honeywell",
  "honeywell productivity": "/companies/honeywell",

  /* ticker lookups */
  hon: "/companies/honeywell",
  "hon stock": "/companies/honeywell",
  "honeywell stock": "/companies/honeywell",
  /* honeywell */

  abbvie: "/companies/abbvie",
  merck: "/companies/merck",
  "eli-lilly": "/companies/eli-lilly",
  "bristol-myers": "/companies/bristol-myers",
  "american-express": "/companies/american-express",
  visa: "/companies/visa",
  mastercard: "/companies/mastercard",
  paypal: "/companies/paypal",
  block: "/companies/block",
  square: "/companies/block",

  /* airbnb */
  airbnb: "/companies/airbnb",
  "air bnb": "/companies/airbnb",
  "airbnb rentals": "/companies/airbnb",
  "airbnb experiences": "/companies/airbnb",
  "airbnb san francisco": "/companies/airbnb",
  abnb: "/companies/airbnb",
  "abnb stock": "/companies/airbnb",
  /* airbnb */

  /* uber */
  uber: "/companies/uber",
  "uber inc": "/companies/uber",
  "uber technologies": "/companies/uber",
  "uber technologies inc": "/companies/uber",
  "uber san francisco": "/companies/uber",
  "uber california": "/companies/uber",

  /* ride-hailing */
  "uber ride": "/companies/uber",
  "uber rides": "/companies/uber",
  "uber ride sharing": "/companies/uber",
  "uber rideshare": "/companies/uber",
  "uber taxi": "/companies/uber",

  /* delivery */
  "uber eats": "/companies/uber",
  "uber delivery": "/companies/uber",
  "uber food": "/companies/uber",
  "uber food delivery": "/companies/uber",

  /* mobility + services */
  "uber mobility": "/companies/uber",
  "uber driver": "/companies/uber",
  "uber drivers": "/companies/uber",
  "uber app": "/companies/uber",

  /* ticker lookups */
  uberstock: "/companies/uber",
  "uber stock": "/companies/uber",
  "uber ticker": "/companies/uber",
  /* uber */

  lyft: "/companies/lyft",
  /* doordash */
  doordash: "/companies/doordash",
  "door dash": "/companies/doordash",
  "doordash inc": "/companies/doordash",
  "doordash delivery": "/companies/doordash",
  "doordash food": "/companies/doordash",
  "doordash logistics": "/companies/doordash",
  "doordash san francisco": "/companies/doordash",
  dash: "/companies/doordash",
  "dash stock": "/companies/doordash",
  "doordash stock": "/companies/doordash",
  /* doordash */

  ebay: "/companies/ebay",
  etsy: "/companies/etsy",
  /* shopify */
  shopify: "/companies/shopify",
  "shopify inc": "/companies/shopify",
  "shopify canada": "/companies/shopify",
  "shopify ottawa": "/companies/shopify",

  /* ecommerce */
  "shopify ecommerce": "/companies/shopify",
  "shopify e-commerce": "/companies/shopify",
  "shopify online store": "/companies/shopify",
  "shopify store": "/companies/shopify",
  "shopify platform": "/companies/shopify",

  /* merchants + sellers */
  "shopify merchants": "/companies/shopify",
  "shopify sellers": "/companies/shopify",
  "shopify business": "/companies/shopify",

  /* ticker lookups */
  shop: "/companies/shopify",
  "shop stock": "/companies/shopify",
  "shopify stock": "/companies/shopify",
  /* shopify */

  zoom: "/companies/zoom",
  slack: "/companies/slack",
  dropbox: "/companies/dropbox",
  snowflake: "/companies/snowflake",
  palantir: "/companies/palantir",
  twilio: "/companies/twilio",
  /* datadog */
  datadog: "/companies/datadog",
  "data dog": "/companies/datadog",
  "datadog monitoring": "/companies/datadog",
  "datadog apm": "/companies/datadog",
  "datadog logs": "/companies/datadog",
  "datadog cloud": "/companies/datadog",
  ddog: "/companies/datadog",
  "ddog stock": "/companies/datadog",
  "datadog stock": "/companies/datadog",
  /* datadog */

  /* cloudflare */
  cloudflare: "/companies/cloudflare",
  "cloud flare": "/companies/cloudflare",
  "cloudflare inc": "/companies/cloudflare",
  "cloudflare cdn": "/companies/cloudflare",
  "cloudflare security": "/companies/cloudflare",
  "cloudflare edge": "/companies/cloudflare",
  "cloudflare san francisco": "/companies/cloudflare",
  net: "/companies/cloudflare",
  "net stock": "/companies/cloudflare",
  "cloudflare stock": "/companies/cloudflare",
  /* cloudflare */

  /* spotify */
  spotify: "/companies/spotify",
  "spotify app": "/companies/spotify",
  "spotify music": "/companies/spotify",
  "spotify streaming": "/companies/spotify",
  "spotify sweden": "/companies/spotify",
  "spotify stockholm": "/companies/spotify",
  "spotify podcasts": "/companies/spotify",
  spot: "/companies/spotify",
  "spot stock": "/companies/spotify",
  "spotify stock": "/companies/spotify",
  /* spotify */

  /* warner-bros-discovery */
  "warner-bros-discovery": "/companies/warner-bros-discovery",
  "warner bros discovery": "/companies/warner-bros-discovery",
  wbd: "/companies/warner-bros-discovery",
  "wbd inc": "/companies/warner-bros-discovery",
  "warner bros": "/companies/warner-bros-discovery",
  "warner discovery": "/companies/warner-bros-discovery",
  "wbd streaming": "/companies/warner-bros-discovery",
  "wbd media": "/companies/warner-bros-discovery",
  "wbd entertainment": "/companies/warner-bros-discovery",
  "wbd stock": "/companies/warner-bros-discovery",
  /* warner-bros-discovery */

  paramount: "/companies/paramount",
  fox: "/companies/fox",
  /* sony */
  sony: "/companies/sony",
  "sony corp": "/companies/sony",
  "sony corporation": "/companies/sony",
  "sony japan": "/companies/sony",
  "sony tokyo": "/companies/sony",

  /* playstation */
  "sony playstation": "/companies/sony",
  playstation: "/companies/sony",
  ps: "/companies/sony",
  ps5: "/companies/sony",
  ps4: "/companies/sony",
  "sony gaming": "/companies/sony",

  /* electronics */
  "sony electronics": "/companies/sony",
  "sony tv": "/companies/sony",
  "sony cameras": "/companies/sony",
  "sony audio": "/companies/sony",

  /* music & entertainment */
  "sony music": "/companies/sony",
  "sony entertainment": "/companies/sony",
  "sony pictures": "/companies/sony",
  "sony films": "/companies/sony",

  /* ticker lookups */
  "sony stock": "/companies/sony",
  "sony corp stock": "/companies/sony",
  /* sony */

  samsung: "/companies/samsung",
  lg: "/companies/lg",
  panasonic: "/companies/panasonic",
  /* siemens-ag */
  "siemens-ag": "/companies/siemens-ag",
  "siemens ag": "/companies/siemens-ag",
  siemens: "/companies/siemens-ag",
  "siemens germany": "/companies/siemens-ag",
  "siemens company": "/companies/siemens-ag",
  "siemens corporation": "/companies/siemens-ag",
  "siemens industrial": "/companies/siemens-ag",
  "siemens automation": "/companies/siemens-ag",
  "siemens electrification": "/companies/siemens-ag",
  "siemens digital": "/companies/siemens-ag",
  "siemens infrastructure": "/companies/siemens-ag",
  sie: "/companies/siemens-ag",
  "sie stock": "/companies/siemens-ag",
  "siemens stock": "/companies/siemens-ag",
  "siemens ag stock": "/companies/siemens-ag",
  /* siemens-ag */

  sap: "/companies/sap",
  tencent: "/companies/tencent",
  alibaba: "/companies/alibaba",
  bytedance: "/companies/bytedance",
  stripe: "/companies/stripe",
  spacex: "/companies/spacex",
  openai: "/companies/openai",
  anthropic: "/companies/anthropic",
  databricks: "/companies/databricks",
  "epic-games": "/companies/epic-games",
  unity: "/companies/unity",
  roblox: "/companies/roblox",
  "electronic-arts": "/companies/electronic-arts",
  ea: "/companies/electronic-arts",
  "activision-blizzard": "/companies/activision-blizzard",
  "take-two": "/companies/take-two",
  nintendo: "/companies/nintendo",
  capcom: "/companies/capcom",
  "square-enix": "/companies/square-enix",
  "bandai-namco": "/companies/bandai-namco",
  ubisoft: "/companies/ubisoft",
  "cd-projekt": "/companies/cd-projekt",
  "riot-games": "/companies/riot-games",
  valve: "/companies/valve",
  discord: "/companies/discord",
  reddit: "/companies/reddit",
  pinterest: "/companies/pinterest",
  snap: "/companies/snap",
  "x-twitter": "/companies/x-twitter",
  x: "/companies/x-twitter",
  twitter: "/companies/x-twitter",
  tiktok: "/companies/tiktok",
  notion: "/companies/notion",
  figma: "/companies/figma",
  autodesk: "/companies/autodesk",
  amd: "/companies/amd",
  micron: "/companies/micron",
  "texas-instruments": "/companies/texas-instruments",
  asml: "/companies/asml",
  tsmc: "/companies/tsmc",
  "applied-materials": "/companies/applied-materials",
  /* servicenow */
  servicenow: "/companies/servicenow",
  "service now": "/companies/servicenow",
  "servicenow inc": "/companies/servicenow",
  "servicenow santa clara": "/companies/servicenow",
  "servicenow california": "/companies/servicenow",

  /* workflow automation */
  "servicenow workflow": "/companies/servicenow",
  "servicenow workflows": "/companies/servicenow",
  "servicenow automation": "/companies/servicenow",
  "servicenow enterprise workflow": "/companies/servicenow",

  /* it service management */
  "servicenow itsm": "/companies/servicenow",
  "servicenow it service management": "/companies/servicenow",
  "servicenow it": "/companies/servicenow",

  /* platform */
  "servicenow platform": "/companies/servicenow",
  "servicenow cloud": "/companies/servicenow",
  "servicenow digital workflow": "/companies/servicenow",

  /* product-specific */
  "servicenow it workflow": "/companies/servicenow",
  "it workflow platform": "/companies/servicenow",

  /* ticker lookups */
  now: "/companies/servicenow",
  "now stock": "/companies/servicenow",
  "servicenow stock": "/companies/servicenow",
  /* servicenow */

  atlassian: "/companies/atlassian",
  /* crowdstrike */
  crowdstrike: "/companies/crowdstrike",
  "crowdstrike inc": "/companies/crowdstrike",
  "crowdstrike holdings": "/companies/crowdstrike",
  "crowdstrike austin": "/companies/crowdstrike",
  "crowdstrike texas": "/companies/crowdstrike",

  /* falcon platform */
  "crowdstrike falcon": "/companies/crowdstrike",
  "falcon platform": "/companies/crowdstrike",
  "falcon endpoint": "/companies/crowdstrike",

  /* endpoint security */
  "crowdstrike endpoint": "/companies/crowdstrike",
  "crowdstrike endpoint security": "/companies/crowdstrike",
  "crowdstrike edr": "/companies/crowdstrike",
  "crowdstrike xdr": "/companies/crowdstrike",

  /* cybersecurity */
  "crowdstrike cybersecurity": "/companies/crowdstrike",
  "crowdstrike cyber security": "/companies/crowdstrike",
  "crowdstrike threat detection": "/companies/crowdstrike",

  /* incident response */
  "crowdstrike ir": "/companies/crowdstrike",
  "crowdstrike incident response": "/companies/crowdstrike",

  /* ticker lookups */
  crwd: "/companies/crowdstrike",
  "crwd stock": "/companies/crowdstrike",
  "crowdstrike stock": "/companies/crowdstrike",
  /* crowdstrike */

  okta: "/companies/okta",
  zscaler: "/companies/zscaler",
  mongodb: "/companies/mongodb",
  github: "/companies/github",
  gitlab: "/companies/gitlab",
  redhat: "/companies/redhat",
  vmware: "/companies/vmware",
  juniper: "/companies/juniper",

  /* fortinet */
  fortinet: "/companies/fortinet",
  "fortinet security": "/companies/fortinet",
  "fortinet firewall": "/companies/fortinet",
  "fortinet cybersecurity": "/companies/fortinet",
  "fortinet sunnyvale": "/companies/fortinet",
  "fortinet california": "/companies/fortinet",
  ftnt: "/companies/fortinet",
  "ftnt stock": "/companies/fortinet",
  "fortinet stock": "/companies/fortinet",
  /* fortinet */

  /* palo-alto */
  "palo-alto": "/companies/palo-alto",
  "palo alto": "/companies/palo-alto",
  "palo alto networks": "/companies/palo-alto",
  panw: "/companies/palo-alto",
  "palo alto corp": "/companies/palo-alto",
  "palo alto corporation": "/companies/palo-alto",
  "palo alto inc": "/companies/palo-alto",
  "palo alto santa clara": "/companies/palo-alto",
  "palo alto california": "/companies/palo-alto",

  /* cybersecurity platforms */
  "palo alto cybersecurity": "/companies/palo-alto",
  "palo alto security": "/companies/palo-alto",
  "palo alto firewall": "/companies/palo-alto",
  "palo alto firewalls": "/companies/palo-alto",
  "palo alto next gen firewall": "/companies/palo-alto",
  "palo alto ngfw": "/companies/palo-alto",

  /* SASE + cloud security */
  "palo alto sase": "/companies/palo-alto",
  "palo alto prisma": "/companies/palo-alto",
  "prisma cloud": "/companies/palo-alto",
  "prisma access": "/companies/palo-alto",

  /* endpoint + xdr */
  "palo alto cortex": "/companies/palo-alto",
  "cortex xdr": "/companies/palo-alto",
  "cortex xsoar": "/companies/palo-alto",

  /* ticker lookups */
  "panw stock": "/companies/palo-alto",
  "palo alto stock": "/companies/palo-alto",
  /* palo-alto */

  splunk: "/companies/splunk",
  elastic: "/companies/elastic",
  /* robinhood */
  robinhood: "/companies/robinhood",
  "robin hood": "/companies/robinhood",
  "robinhood app": "/companies/robinhood",
  "robinhood trading": "/companies/robinhood",
  "robinhood stocks": "/companies/robinhood",
  "robinhood menlo park": "/companies/robinhood",
  hood: "/companies/robinhood",
  "hood stock": "/companies/robinhood",
  "robinhood stock": "/companies/robinhood",
  /* robinhood */

  coinbase: "/companies/coinbase",
  /* western-digital */
  "western-digital": "/companies/western-digital",
  "western digital": "/companies/western-digital",
  wdc: "/companies/western-digital",
  "western digital corp": "/companies/western-digital",
  "western digital corporation": "/companies/western-digital",
  "western digital inc": "/companies/western-digital",
  "western digital san jose": "/companies/western-digital",
  "western digital california": "/companies/western-digital",

  /* storage hardware */
  "western digital hard drive": "/companies/western-digital",
  "western digital hard drives": "/companies/western-digital",
  "western digital hdd": "/companies/western-digital",
  "western digital ssd": "/companies/western-digital",
  "western digital solid state": "/companies/western-digital",
  "western digital storage": "/companies/western-digital",
  "wd storage": "/companies/western-digital",

  /* WD brand shorthand */
  wd: "/companies/western-digital",
  "wd hdd": "/companies/western-digital",
  "wd ssd": "/companies/western-digital",
  "wd black": "/companies/western-digital",
  "wd blue": "/companies/western-digital",
  "wd red": "/companies/western-digital",
  "wd gold": "/companies/western-digital",

  /* ticker lookups */
  "wdc stock": "/companies/western-digital",
  "western digital stock": "/companies/western-digital",
  /* western-digital */

  /* seagate */
  seagate: "/companies/seagate",
  "seagate technology": "/companies/seagate",
  "seagate tech": "/companies/seagate",
  "seagate inc": "/companies/seagate",
  "seagate corporation": "/companies/seagate",
  "seagate dublin": "/companies/seagate",
  "seagate ireland": "/companies/seagate",

  /* storage hardware */
  "seagate hard drive": "/companies/seagate",
  "seagate hard drives": "/companies/seagate",
  "seagate hdd": "/companies/seagate",
  "seagate ssd": "/companies/seagate",
  "seagate solid state": "/companies/seagate",
  "seagate storage": "/companies/seagate",
  "seagate external drive": "/companies/seagate",
  "seagate external hdd": "/companies/seagate",

  /* product families */
  "seagate barracuda": "/companies/seagate",
  "seagate ironwolf": "/companies/seagate",
  "seagate skyhawk": "/companies/seagate",
  "seagate exos": "/companies/seagate",

  /* ticker lookups */
  stx: "/companies/seagate",
  "stx stock": "/companies/seagate",
  "seagate stock": "/companies/seagate",
  /* seagate */

  hp: "/companies/hp",
  dell: "/companies/dell",
  lenovo: "/companies/lenovo",
  huawei: "/companies/huawei",
  xiaomi: "/companies/xiaomi",
  oppo: "/companies/oppo",
  vivo: "/companies/vivo",
  dji: "/companies/dji",

  // === African Companies ===
  "seplat-energy": "/companies/seplat-energy",
  "nigerian-breweries": "/companies/nigerian-breweries",
  "nestle-nigeria": "/companies/nestle-nigeria",
  "julius-berger": "/companies/julius-berger",
  "air-peace": "/companies/air-peace",
  naspers: "/companies/naspers",
  sonatrach: "/companies/sonatrach",
  sasol: "/companies/sasol",
  shoprite: "/companies/shoprite",
  "standard-bank": "/companies/standard-bank-group",
  sanlam: "/companies/sanlam",
  "ocp-group": "/companies/ocp-group",
  "attijariwafa-bank": "/companies/attijariwafa-bank",
  "maroc-telecom": "/companies/maroc-telecom",
  "commercial-international-bank": "/companies/commercial-international-bank",
  "national-oil-corporation": "/companies/national-oil-corporation",
  "managem-group": "/companies/managem-group",
  safaricom: "/companies/safaricom",
  "equity-group": "/companies/equity-group-holdings",
  sonangol: "/companies/sonangol",
  "ethiopian-airlines": "/companies/ethiopian-airlines",
  "kcb-group": "/companies/kcb-group",
  "pacific-holdings": "/companies/pacific-holdings-limited",
  "fbn-holdings": "/companies/fbn-holdings",

  // === Newly Added Companies (Latest Batch) ===
  volkswagen: "/companies/volkswagen",
  vw: "/companies/volkswagen",

  nestle: "/companies/nestle",

  /* citigroup */
  citigroup: "/companies/citigroup",
  "citi group": "/companies/citigroup",
  citi: "/companies/citigroup",
  "citi bank": "/companies/citigroup",
  citibank: "/companies/citigroup",
  "citibank usa": "/companies/citigroup",
  "citibank na": "/companies/citigroup",
  "citi financial": "/companies/citigroup",
  "citi holdings": "/companies/citigroup",
  "citi corporation": "/companies/citigroup",
  "citi inc": "/companies/citigroup",
  "citi services": "/companies/citigroup",
  "citi credit": "/companies/citigroup",
  "citi cards": "/companies/citigroup",
  "citi wealth": "/companies/citigroup",
  "citi investment": "/companies/citigroup",
  "citi global": "/companies/citigroup",
  "citi nyc": "/companies/citigroup",
  c: "/companies/citigroup",
  "c stock": "/companies/citigroup",
  "citigroup stock": "/companies/citigroup",
  /* citigroup */

  /*hsbc usa hsba china -look into this */

  hsbc: "/companies/hsbc",
  "hsbc bank": "/companies/hsbc",
  "hsbc holdings": "/companies/hsbc",
  "hsbc uk": "/companies/hsbc",
  "hsbc china": "/companies/hsbc",
  "hsbc usa": "/companies/hsbc",
  "hongkong and shanghai banking corporation": "/companies/hsbc",
  "hong kong shanghai bank": "/companies/hsbc",
  "hong kong and shanghai bank": "/companies/hsbc",
  "0005": "/companies/hsbc",
  "hsbc stock": "/companies/hsbc",

  /*hsbc usa hsba china -look into this */

  /* barclays */
  barclays: "/companies/barclays",
  "barclays bank": "/companies/barclays",
  "barclays uk": "/companies/barclays",
  "barclays london": "/companies/barclays",
  "barclays investment banking": "/companies/barclays",
  "barclays corporate banking": "/companies/barclays",
  "barclays wealth": "/companies/barclays",
  bcs: "/companies/barclays",
  "bcs stock": "/companies/barclays",
  "barclays stock": "/companies/barclays",
  /* barclays */

  /* bp */
  bp: "/companies/bp",
  "bp plc": "/companies/bp",
  "bp oil": "/companies/bp",
  "bp gas": "/companies/bp",
  "bp energy": "/companies/bp",
  "bp london": "/companies/bp",
  "bp uk": "/companies/bp",
  "bp petroleum": "/companies/bp",
  "bp stations": "/companies/bp",
  "bp refining": "/companies/bp",
  "bp stock": "/companies/bp",
  /* bp */

  /* totalenergies */
  totalenergies: "/companies/totalenergies",
  "total energies": "/companies/totalenergies",
  "totalenergies se": "/companies/totalenergies",
  "total energies se": "/companies/totalenergies",

  /* legacy names */
  total: "/companies/totalenergies",
  "total sa": "/companies/totalenergies",
  "total s.a.": "/companies/totalenergies",
  "total france": "/companies/totalenergies",

  /* energy sector queries */
  "totalenergies oil": "/companies/totalenergies",
  "totalenergies gas": "/companies/totalenergies",
  "totalenergies lng": "/companies/totalenergies",
  "totalenergies renewable": "/companies/totalenergies",
  "totalenergies renewables": "/companies/totalenergies",
  "totalenergies energy": "/companies/totalenergies",
  "totalenergies electricity": "/companies/totalenergies",
  "totalenergies petrochemicals": "/companies/totalenergies",

  /* geographic queries */
  "totalenergies paris": "/companies/totalenergies",
  "totalenergies france": "/companies/totalenergies",

  /* ticker lookups */
  tte: "/companies/totalenergies",
  "tte stock": "/companies/totalenergies",
  "totalenergies stock": "/companies/totalenergies",
  /* totalenergies */

  /* eni */
  eni: "/companies/eni",
  "eni italy": "/companies/eni",
  "eni rome": "/companies/eni",
  "eni energy": "/companies/eni",
  "eni oil": "/companies/eni",
  "eni gas": "/companies/eni",
  "eni refining": "/companies/eni",
  "eni petrochemicals": "/companies/eni",
  "eni renewables": "/companies/eni",
  e: "/companies/eni",
  "e stock": "/companies/eni",
  "eni stock": "/companies/eni",
  /* eni */

  /* airbus */
  airbus: "/companies/airbus",
  "airbus se": "/companies/airbus",
  "airbus group": "/companies/airbus",
  "airbus industries": "/companies/airbus",
  "airbus france": "/companies/airbus",
  "airbus toulouse": "/companies/airbus",

  /* commercial aircraft */
  "airbus commercial": "/companies/airbus",
  "airbus aircraft": "/companies/airbus",
  "airbus planes": "/companies/airbus",
  "airbus a320": "/companies/airbus",
  "airbus a330": "/companies/airbus",
  "airbus a350": "/companies/airbus",
  "airbus a380": "/companies/airbus",

  /* helicopters */
  "airbus helicopters": "/companies/airbus",
  "airbus heli": "/companies/airbus",
  "airbus rotorcraft": "/companies/airbus",

  /* defense + military */
  "airbus defense": "/companies/airbus",
  "airbus defence": "/companies/airbus",
  "airbus military": "/companies/airbus",
  "airbus a400m": "/companies/airbus",

  /* space systems */
  "airbus space": "/companies/airbus",
  "airbus space systems": "/companies/airbus",
  "airbus satellites": "/companies/airbus",

  /* ticker lookups */
  air: "/companies/airbus",
  "air stock": "/companies/airbus",
  "airbus stock": "/companies/airbus",
  /* airbus */

  rtx: "/companies/rtx",

  roche: "/companies/roche",

  /*  novartis  */
  novartis: "/companies/novartis",
  "novartis ag": "/companies/novartis",
  "novartis pharma": "/companies/novartis",
  "novartis company": "/companies/novartis",
  "novartis switzerland": "/companies/novartis",
  nvs: "/companies/novartis",
  "novartis stock": "/companies/novartis",
  "novartis oncology": "/companies/novartis",

  /*  novartis  */
  /*astrazeneca */

  astrazeneca: "/companies/astrazeneca",
  "astra zeneca": "/companies/astrazeneca",
  azn: "/companies/astrazeneca",
  "astrazeneca plc": "/companies/astrazeneca",
  "astrazeneca company": "/companies/astrazeneca",
  "astrazeneca pharma": "/companies/astrazeneca",
  "astrazeneca uk": "/companies/astrazeneca",
  "astrazeneca stock": "/companies/astrazeneca",

  /*astrazeneca */
  /* sanofi */
  sanofi: "/companies/sanofi",
  "sanofi france": "/companies/sanofi",
  "sanofi paris": "/companies/sanofi",
  "sanofi aventis": "/companies/sanofi",
  "sanofi synthelabo": "/companies/sanofi",

  /* prescription medicines */
  "sanofi medicines": "/companies/sanofi",
  "sanofi pharma": "/companies/sanofi",
  "sanofi pharmaceuticals": "/companies/sanofi",

  /* vaccines */
  "sanofi vaccines": "/companies/sanofi",
  "sanofi pasteur": "/companies/sanofi",

  /* diabetes treatments */
  "sanofi diabetes": "/companies/sanofi",
  "sanofi insulin": "/companies/sanofi",

  /* oncology drugs */
  "sanofi oncology": "/companies/sanofi",
  "sanofi cancer": "/companies/sanofi",

  /* rare disease treatments */
  "sanofi rare disease": "/companies/sanofi",
  "sanofi rare diseases": "/companies/sanofi",
  "sanofi genzyme": "/companies/sanofi",

  /* consumer healthcare */
  "sanofi consumer health": "/companies/sanofi",
  "sanofi consumer healthcare": "/companies/sanofi",

  /* ticker lookups */
  san: "/companies/sanofi",
  "san stock": "/companies/sanofi",
  "sanofi stock": "/companies/sanofi",
  /* sanofi */

  /* unilever */
  unilever: "/companies/unilever",
  "unilever plc": "/companies/unilever",
  "unilever nv": "/companies/unilever",
  "unilever london": "/companies/unilever",
  "unilever rotterdam": "/companies/unilever",
  "unilever uk": "/companies/unilever",
  "unilever netherlands": "/companies/unilever",

  /* food + beverages */
  "unilever food": "/companies/unilever",
  "unilever foods": "/companies/unilever",
  "unilever beverages": "/companies/unilever",

  /* personal care */
  "unilever personal care": "/companies/unilever",
  "unilever skincare": "/companies/unilever",
  "unilever haircare": "/companies/unilever",

  /* home care */
  "unilever home care": "/companies/unilever",
  "unilever cleaning": "/companies/unilever",
  "unilever detergents": "/companies/unilever",

  /* beauty + wellness */
  "unilever beauty": "/companies/unilever",
  "unilever wellness": "/companies/unilever",
  "unilever beauty and wellness": "/companies/unilever",

  /* consumer goods */
  "unilever consumer goods": "/companies/unilever",
  "unilever products": "/companies/unilever",

  /* ticker lookups */
  ulvr: "/companies/unilever",
  "ulvr stock": "/companies/unilever",
  "unilever stock": "/companies/unilever",
  /* unilever */

  vodafone: "/companies/vodafone",

  /* dhl-group-deutsche-post */
  "dhl-group-deutsche-post": "/companies/dhl-group-deutsche-post",
  "dhl group": "/companies/dhl-group-deutsche-post",
  "deutsche post": "/companies/dhl-group-deutsche-post",
  dhl: "/companies/dhl-group-deutsche-post",
  "dhl logistics": "/companies/dhl-group-deutsche-post",
  "dhl express": "/companies/dhl-group-deutsche-post",
  "dhl freight": "/companies/dhl-group-deutsche-post",
  "dhl bonn": "/companies/dhl-group-deutsche-post",
  "dhl.de": "/companies/dhl-group-deutsche-post",
  "dhl stock": "/companies/dhl-group-deutsche-post",
  /* dhl-group-deutsche-post */

  maersk: "/companies/maersk",

  aws: "/companies/aws",

  /* blackrock */
  blackrock: "/companies/blackrock",
  "blackrock inc": "/companies/blackrock",
  "blackrock incorporated": "/companies/blackrock",
  "blackrock group": "/companies/blackrock",
  "blackrock new york": "/companies/blackrock",
  "blackrock nyc": "/companies/blackrock",

  /* asset management */
  "blackrock asset management": "/companies/blackrock",
  "blackrock investments": "/companies/blackrock",
  "blackrock investment management": "/companies/blackrock",
  "blackrock advisory": "/companies/blackrock",
  "blackrock institutional": "/companies/blackrock",

  /* iShares ETFs */
  ishares: "/companies/blackrock",
  "ishares etf": "/companies/blackrock",
  "ishares etfs": "/companies/blackrock",
  "blackrock ishares": "/companies/blackrock",

  /* risk management + analytics */
  "blackrock risk management": "/companies/blackrock",
  "blackrock risk": "/companies/blackrock",
  "blackrock aladdin": "/companies/blackrock",
  "aladdin platform": "/companies/blackrock",

  /* ticker lookups */
  blk: "/companies/blackrock",
  "blk stock": "/companies/blackrock",
  "blackrock stock": "/companies/blackrock",
  /* blackrock */

  /* lvmh */
  lvmh: "/companies/lvmh",
  "lvmh moët hennessy louis vuitton": "/companies/lvmh",
  "lvmh moet hennessy louis vuitton": "/companies/lvmh",
  "moet hennessy louis vuitton": "/companies/lvmh",
  "louis vuitton group": "/companies/lvmh",
  "lvmh group": "/companies/lvmh",
  mc: "/companies/lvmh",
  "lvmh stock": "/companies/lvmh",
  "lvmh france": "/companies/lvmh",

  /* lvmh */

  /* novo-nordisk */
  "novo-nordisk": "/companies/novo-nordisk",
  "novo nordisk": "/companies/novo-nordisk",
  novonordisk: "/companies/novo-nordisk",
  "novo nordic": "/companies/novo-nordisk",
  "novo-nordic": "/companies/novo-nordisk",
  "novo nordisk pharma": "/companies/novo-nordisk",
  "novo nordisk pharmaceuticals": "/companies/novo-nordisk",
  "novo nordisk denmark": "/companies/novo-nordisk",
  "novo nordisk bagsvaerd": "/companies/novo-nordisk",
  "novo nordisk diabetes": "/companies/novo-nordisk",
  "novo nordisk obesity": "/companies/novo-nordisk",
  "novo nordisk insulin": "/companies/novo-nordisk",
  "novo nordisk glp-1": "/companies/novo-nordisk",
  "novo nordisk ozempic": "/companies/novo-nordisk",
  "novo nordisk wegovy": "/companies/novo-nordisk",
  ozempic: "/companies/novo-nordisk",
  wegovy: "/companies/novo-nordisk",
  "novo nordisk hormone": "/companies/novo-nordisk",
  "novo nordisk growth hormone": "/companies/novo-nordisk",
  "novo nordisk rare disease": "/companies/novo-nordisk",
  "novo nordisk stock": "/companies/novo-nordisk",
  "novo-b": "/companies/novo-nordisk",
  "novo b": "/companies/novo-nordisk",
  "novo b stock": "/companies/novo-nordisk",
  /* novo-nordisk */

  "wells-fargo": "/companies/wells-fargo",
  wells: "/companies/wells-fargo",

  /* industrial and comercial bank of china */
  icbc: "/companies/icbc",
  "industrial and commercial bank of china": "/companies/icbc",
  "industrial & commercial bank of china": "/companies/icbc",
  "industrial commercial bank of china": "/companies/icbc",
  "icbc bank": "/companies/icbc",
  "china icbc": "/companies/icbc",
  "icbc china": "/companies/icbc",
  "1398": "/companies/icbc",

  /* industrial and comercial bank of china */

  "china-construction-bank": "/companies/china-construction-bank",
  ccb: "/companies/china-construction-bank",
  "china construction bank": "/companies/china-construction-bank",
  "china construction": "/companies/china-construction-bank",

  /* pdd-holdings */
  "pdd-holdings": "/companies/pdd-holdings",
  "pdd holdings": "/companies/pdd-holdings",
  pdd: "/companies/pdd-holdings",
  "pdd group": "/companies/pdd-holdings",
  "pdd dublin": "/companies/pdd-holdings",
  "pdd ireland": "/companies/pdd-holdings",

  /* pinduoduo */
  pinduoduo: "/companies/pdd-holdings",
  "pin duo duo": "/companies/pdd-holdings",

  "pdd pinduoduo": "/companies/pdd-holdings",

  /* temu */
  temu: "/companies/pdd-holdings",
  "temu app": "/companies/pdd-holdings",
  "temu shopping": "/companies/pdd-holdings",

  /* ecommerce + marketplaces */
  "pdd ecommerce": "/companies/pdd-holdings",
  "pdd e-commerce": "/companies/pdd-holdings",
  "pdd marketplace": "/companies/pdd-holdings",
  "pdd online retail": "/companies/pdd-holdings",
  "pdd digital marketplace": "/companies/pdd-holdings",

  /* agriculture + distribution */
  "pdd agriculture": "/companies/pdd-holdings",
  "pdd agri commerce": "/companies/pdd-holdings",
  "pdd agricultural platform": "/companies/pdd-holdings",

  /* ticker lookups */
  "pdd stock": "/companies/pdd-holdings",
  "pdd ticker": "/companies/pdd-holdings",
  /* pdd-holdings */

  /* meituan */
  meituan: "/companies/meituan",
  "mei tuan": "/companies/meituan",
  "meituan china": "/companies/meituan",
  "meituan beijing": "/companies/meituan",
  "meituan delivery": "/companies/meituan",
  "meituan food": "/companies/meituan",
  "meituan travel": "/companies/meituan",
  "meituan retail": "/companies/meituan",
  "3690.hk": "/companies/meituan",
  "meituan stock": "/companies/meituan",
  "3690 stock": "/companies/meituan",
  /* meituan */

  /* accenture */
  accenture: "/companies/accenture",
  "accenture plc": "/companies/accenture",
  "accenture dublin": "/companies/accenture",
  "accenture ireland": "/companies/accenture",

  /* management consulting */
  "accenture consulting": "/companies/accenture",
  "accenture management consulting": "/companies/accenture",

  /* technology consulting */
  "accenture technology": "/companies/accenture",
  "accenture tech consulting": "/companies/accenture",

  /* digital transformation */
  "accenture digital": "/companies/accenture",
  "accenture digital transformation": "/companies/accenture",

  /* cloud services */
  "accenture cloud": "/companies/accenture",
  "accenture cloud services": "/companies/accenture",

  /* outsourcing */
  "accenture outsourcing": "/companies/accenture",
  "accenture bpo": "/companies/accenture",

  /* ai & data analytics */
  "accenture ai": "/companies/accenture",
  "accenture data": "/companies/accenture",
  "accenture analytics": "/companies/accenture",

  /* ticker lookups */
  acn: "/companies/accenture",
  "acn stock": "/companies/accenture",
  "accenture stock": "/companies/accenture",
  /* accenture */

  /* intuit */
  intuit: "/companies/intuit",
  "intuit inc": "/companies/intuit",
  "intuit mountain view": "/companies/intuit",
  "intuit california": "/companies/intuit",

  /* tax preparation */
  "intuit tax": "/companies/intuit",
  "intuit tax software": "/companies/intuit",
  turbotax: "/companies/intuit",
  "turbo tax": "/companies/intuit",

  /* small business accounting */
  quickbooks: "/companies/intuit",
  "quick books": "/companies/intuit",
  "intuit quickbooks": "/companies/intuit",
  "intuit accounting": "/companies/intuit",
  "intuit small business": "/companies/intuit",

  /* personal finance */
  "intuit personal finance": "/companies/intuit",
  mint: "/companies/intuit",
  "mint app": "/companies/intuit",

  /* credit monitoring */
  "credit karma": "/companies/intuit",
  "intuit credit karma": "/companies/intuit",

  /* financial management platforms */
  "intuit finance": "/companies/intuit",
  "intuit financial tools": "/companies/intuit",

  /* ticker lookups */
  intu: "/companies/intuit",
  "intu stock": "/companies/intuit",
  "intuit stock": "/companies/intuit",
  /* intuit */

  /* sk-hynix */
  "sk-hynix": "/companies/sk-hynix",
  "sk hynix": "/companies/sk-hynix",
  skhynix: "/companies/sk-hynix",
  hynix: "/companies/sk-hynix",
  "hynix semiconductor": "/companies/sk-hynix",
  "sk hynix inc": "/companies/sk-hynix",
  "sk hynix korea": "/companies/sk-hynix",
  "sk hynix company": "/companies/sk-hynix",
  "sk hynix stock": "/companies/sk-hynix",
  "000660": "/companies/sk-hynix",
  "sk hynix memory": "/companies/sk-hynix",
  "sk hynix dram": "/companies/sk-hynix",
  "sk hynix hbm": "/companies/sk-hynix",
  /* sk-hynix */

  /* bhp-group */
  "bhp-group": "/companies/bhp-group",
  "bhp group": "/companies/bhp-group",
  bhp: "/companies/bhp-group",
  "bhp ltd": "/companies/bhp-group",
  "bhp limited": "/companies/bhp-group",
  "bhp plc": "/companies/bhp-group",
  "bhp group ltd": "/companies/bhp-group",
  "bhp group limited": "/companies/bhp-group",
  "bhp group plc": "/companies/bhp-group",
  "bhp billiton": "/companies/bhp-group",
  "bhp billiton ltd": "/companies/bhp-group",
  "bhp billiton limited": "/companies/bhp-group",
  "bhp billiton plc": "/companies/bhp-group",
  "bhp mining": "/companies/bhp-group",
  "bhp australia": "/companies/bhp-group",
  "bhp melbourne": "/companies/bhp-group",
  "bhp iron ore": "/companies/bhp-group",
  "bhp copper": "/companies/bhp-group",
  "bhp coal": "/companies/bhp-group",
  "bhp nickel": "/companies/bhp-group",
  "bhp petroleum": "/companies/bhp-group",
  bhpax: "/companies/bhp-group",
  "bhp stock": "/companies/bhp-group",
  "bhp asx": "/companies/bhp-group",
  "bhp lse": "/companies/bhp-group",
  /* bhp-group */

  /* rio-tinto */
  "rio-tinto": "/companies/rio-tinto",
  "rio tinto": "/companies/rio-tinto",
  riotinto: "/companies/rio-tinto",
  "rio tinto mining": "/companies/rio-tinto",
  "rio tinto iron ore": "/companies/rio-tinto",
  "rio tinto aluminum": "/companies/rio-tinto",
  "rio tinto copper": "/companies/rio-tinto",
  "rio tinto diamonds": "/companies/rio-tinto",
  "rio tinto london": "/companies/rio-tinto",
  "rio tinto uk": "/companies/rio-tinto",
  rio: "/companies/rio-tinto",
  "rio stock": "/companies/rio-tinto",
  /* rio-tinto */

  glencore: "/companies/glencore",

  /* bank-of-china */

  "bank-of-china": "/companies/bank-of-china",
  "bank of china": "/companies/bank-of-china",
  boc: "/companies/bank-of-china",
  "boc bank": "/companies/bank-of-china",
  "bank of china limited": "/companies/bank-of-china",
  "bank of china ltd": "/companies/bank-of-china",
  "china bank": "/companies/bank-of-china",
  "3988": "/companies/bank-of-china",
  "bank of china stock": "/companies/bank-of-china",

  /* bank-of-china */
  /*  agbc */
  "agricultural-bank-of-china": "/companies/agricultural-bank-of-china",
  abc: "/companies/agricultural-bank-of-china",
  "agricultural bank of china": "/companies/agricultural-bank-of-china",
  "agricultural bank": "/companies/agricultural-bank-of-china",
  "abc bank": "/companies/agricultural-bank-of-china",
  agbank: "/companies/agricultural-bank-of-china",

  /*  agbc */

  /* reliance-industries */
  "reliance-industries": "/companies/reliance-industries",
  "reliance industries": "/companies/reliance-industries",
  reliance: "/companies/reliance-industries",
  "reliance ltd": "/companies/reliance-industries",
  "reliance limited": "/companies/reliance-industries",
  "reliance industries ltd": "/companies/reliance-industries",
  "reliance industries limited": "/companies/reliance-industries",
  ril: "/companies/reliance-industries",
  "ril india": "/companies/reliance-industries",
  "ril stock": "/companies/reliance-industries",
  "reliance stock": "/companies/reliance-industries",
  "reliance nse": "/companies/reliance-industries",
  "reliance bse": "/companies/reliance-industries",
  "reliance mumbai": "/companies/reliance-industries",
  "reliance india": "/companies/reliance-industries",
  "reliance petrochemicals": "/companies/reliance-industries",
  "reliance refining": "/companies/reliance-industries",
  "reliance oil": "/companies/reliance-industries",
  "reliance retail": "/companies/reliance-industries",
  "reliance jio": "/companies/reliance-industries",
  jio: "/companies/reliance-industries",
  "jio telecom": "/companies/reliance-industries",
  "jio india": "/companies/reliance-industries",
  /* reliance-industries */

  /* tata-consultancy-services */
  "tata-consultancy-services": "/companies/tata-consultancy-services",
  tcs: "/companies/tata-consultancy-services",
  "tata consultancy services": "/companies/tata-consultancy-services",
  "tcs india": "/companies/tata-consultancy-services",
  "tcs mumbai": "/companies/tata-consultancy-services",
  "tcs it services": "/companies/tata-consultancy-services",
  "tcs consulting": "/companies/tata-consultancy-services",
  "tcs digital": "/companies/tata-consultancy-services",
  "tcs cloud": "/companies/tata-consultancy-services",
  "tcs business solutions": "/companies/tata-consultancy-services",
  "tcs stock": "/companies/tata-consultancy-services",
  "tcs.ns": "/companies/tata-consultancy-services",
  /* tata-consultancy-services */

  infosys: "/companies/infosys",

  asus: "/companies/asus",
  "sk-telecom": "/companies/sk-telecom",
  "tencent-music": "/companies/tencent-music",
  /* enel */
  enel: "/companies/enel",
  "enel italy": "/companies/enel",
  "enel rome": "/companies/enel",
  "enel group": "/companies/enel",
  "enel energia": "/companies/enel",

  /* electricity generation */
  "enel electricity": "/companies/enel",
  "enel power": "/companies/enel",
  "enel power generation": "/companies/enel",

  /* renewable energy */
  "enel renewable": "/companies/enel",
  "enel renewables": "/companies/enel",
  "enel green power": "/companies/enel",
  "enel solar": "/companies/enel",
  "enel wind": "/companies/enel",

  /* energy distribution */
  "enel distribution": "/companies/enel",
  "enel energy distribution": "/companies/enel",

  /* natural gas */
  "enel gas": "/companies/enel",
  "enel natural gas": "/companies/enel",

  /* energy infrastructure */
  "enel infrastructure": "/companies/enel",
  "enel energy infrastructure": "/companies/enel",

  /* ticker lookups */
  "enel stock": "/companies/enel",
  "enel spa stock": "/companies/enel",
  /* enel */

  iberdrola: "/companies/iberdrola",
  edf: "/companies/edf",

  "china-mobile": "/companies/china-mobile",
  /* china-telecom */
  "china-telecom": "/companies/china-telecom",
  "china telecom": "/companies/china-telecom",
  "china telecom corp": "/companies/china-telecom",
  "china telecom beijing": "/companies/china-telecom",
  "china telecom mobile": "/companies/china-telecom",
  "china telecom broadband": "/companies/china-telecom",
  "china telecom cloud": "/companies/china-telecom",
  "0728.hk": "/companies/china-telecom",
  "china telecom stock": "/companies/china-telecom",
  "728 stock": "/companies/china-telecom",
  /* china-telecom */

  /* mondelez-international */
  "mondelez-international": "/companies/mondelez-international",
  "mondelez international": "/companies/mondelez-international",
  mondelez: "/companies/mondelez-international",
  "mondelez snacks": "/companies/mondelez-international",
  "mondelez chocolate": "/companies/mondelez-international",
  "mondelez cookies": "/companies/mondelez-international",
  "mondelez biscuits": "/companies/mondelez-international",
  "mondelez gum": "/companies/mondelez-international",
  "mondelez chicago": "/companies/mondelez-international",
  mdlz: "/companies/mondelez-international",
  "mdlz stock": "/companies/mondelez-international",
  "mondelez stock": "/companies/mondelez-international",
  /* mondelez-international */

  "kraft-heinz": "/companies/kraft-heinz",

  /* axa */
  axa: "/companies/axa",
  "axa sa": "/companies/axa",
  "axa france": "/companies/axa",
  "axa paris": "/companies/axa",

  /* life insurance */
  "axa life": "/companies/axa",
  "axa life insurance": "/companies/axa",

  /* health insurance */
  "axa health": "/companies/axa",
  "axa health insurance": "/companies/axa",

  /* property & casualty */
  "axa p&c": "/companies/axa",
  "axa property": "/companies/axa",
  "axa casualty": "/companies/axa",
  "axa property and casualty": "/companies/axa",

  /* asset management */
  "axa investment managers": "/companies/axa",
  "axa asset management": "/companies/axa",
  "axa im": "/companies/axa",

  /* retirement solutions */
  "axa retirement": "/companies/axa",
  "axa pension": "/companies/axa",

  /* commercial insurance */
  "axa commercial": "/companies/axa",
  "axa business insurance": "/companies/axa",

  /* ticker lookups */
  "cs.pa": "/companies/axa",
  cs: "/companies/axa",
  "cs stock": "/companies/axa",
  "axa stock": "/companies/axa",
  /* axa */

  metlife: "/companies/metlife",

  /* loreal */
  loreal: "/companies/loreal",
  "l'oreal": "/companies/loreal",
  "loreal paris": "/companies/loreal",
  "l oreal": "/companies/loreal",
  "loreal sa": "/companies/loreal",
  "loreal group": "/companies/loreal",
  "loreal company": "/companies/loreal",
  "loreal cosmetics": "/companies/loreal",
  "loreal beauty": "/companies/loreal",
  "loreal makeup": "/companies/loreal",
  "loreal skincare": "/companies/loreal",
  "loreal haircare": "/companies/loreal",
  or: "/companies/loreal",
  "or stock": "/companies/loreal",
  "loreal stock": "/companies/loreal",
  "loreal france": "/companies/loreal",
  /* loreal */

  /* unicredit */
  unicredit: "/companies/unicredit",
  "unicredit bank": "/companies/unicredit",
  "unicredit group": "/companies/unicredit",
  "unicredit italy": "/companies/unicredit",
  "unicredit milan": "/companies/unicredit",

  /* retail banking */
  "unicredit retail": "/companies/unicredit",
  "unicredit retail banking": "/companies/unicredit",

  /* corporate banking */
  "unicredit corporate": "/companies/unicredit",
  "unicredit corporate banking": "/companies/unicredit",
  "unicredit business banking": "/companies/unicredit",

  /* investment banking */
  "unicredit investment": "/companies/unicredit",
  "unicredit investment banking": "/companies/unicredit",
  "unicredit capital markets": "/companies/unicredit",

  /* asset management */
  "unicredit asset management": "/companies/unicredit",
  "unicredit am": "/companies/unicredit",

  /* financial services */
  "unicredit financial services": "/companies/unicredit",
  "unicredit finance": "/companies/unicredit",

  /* ticker lookups */
  ucg: "/companies/unicredit",
  "ucg stock": "/companies/unicredit",
  "unicredit stock": "/companies/unicredit",
  /* unicredit */

  /* santander */
  santander: "/companies/santander",
  "banco santander": "/companies/santander",
  "santander bank": "/companies/santander",
  "santander group": "/companies/santander",
  "santander spain": "/companies/santander",
  "santander madrid": "/companies/santander",
  "santander sa": "/companies/santander",
  "santander s.a.": "/companies/santander",

  /* banking services */
  "santander retail banking": "/companies/santander",
  "santander corporate banking": "/companies/santander",
  "santander investment banking": "/companies/santander",
  "santander wealth management": "/companies/santander",
  "santander consumer finance": "/companies/santander",

  /* regional variants */
  "santander europe": "/companies/santander",
  "santander eurozone": "/companies/santander",
  "santander global": "/companies/santander",

  /* ticker lookups */
  // san: "/companies/santander",
  // "san stock": "/companies/santander",
  "santander stock": "/companies/santander",
  /* santander */

  /* abb */
  abb: "/companies/abb",
  "abb ltd": "/companies/abb",
  "abb l.t.d.": "/companies/abb",
  "abb group": "/companies/abb",
  "abb corporation": "/companies/abb",
  "abb company": "/companies/abb",
  "abb switzerland": "/companies/abb",
  "abb swiss": "/companies/abb",
  "abb zurich": "/companies/abb",

  /* robotics + automation */
  "abb robotics": "/companies/abb",
  "abb robot": "/companies/abb",
  "abb automation": "/companies/abb",
  "abb industrial automation": "/companies/abb",
  "abb motion": "/companies/abb",
  "abb drives": "/companies/abb",
  "abb electric drives": "/companies/abb",

  /* electrification + power */
  "abb electrification": "/companies/abb",
  "abb power": "/companies/abb",
  "abb power grids": "/companies/abb",
  "abb grid solutions": "/companies/abb",

  /* ticker lookups */
  abbn: "/companies/abb",
  "abbn stock": "/companies/abb",
  "abb stock": "/companies/abb",
  /* abb */

  orange: "/companies/orange",
  /* enbridge */
  enbridge: "/companies/enbridge",
  "enbridge inc": "/companies/enbridge",
  "enbridge canada": "/companies/enbridge",
  "enbridge calgary": "/companies/enbridge",

  /* oil pipelines */
  "enbridge oil": "/companies/enbridge",
  "enbridge oil pipelines": "/companies/enbridge",
  "enbridge crude pipelines": "/companies/enbridge",

  /* natural gas pipelines */
  "enbridge gas": "/companies/enbridge",
  "enbridge natural gas": "/companies/enbridge",
  "enbridge gas pipelines": "/companies/enbridge",

  /* gas distribution */
  "enbridge gas distribution": "/companies/enbridge",
  "enbridge utilities": "/companies/enbridge",

  /* renewable energy */
  "enbridge renewable": "/companies/enbridge",
  "enbridge renewable energy": "/companies/enbridge",
  "enbridge wind": "/companies/enbridge",
  "enbridge solar": "/companies/enbridge",

  /* energy infrastructure */
  "enbridge infrastructure": "/companies/enbridge",
  "enbridge energy infrastructure": "/companies/enbridge",

  /* ticker lookups */
  enb: "/companies/enbridge",
  "enb stock": "/companies/enbridge",
  "enbridge stock": "/companies/enbridge",
  /* enbridge */

  bmw: "/companies/bmw",
  "mercedes-benz": "/companies/mercedes-benz",
  hyundai: "/companies/hyundai",

  /* lam reasearch */
  "lam-research": "/companies/lam-research",
  "lam research": "/companies/lam-research",
  lam: "/companies/lam-research",
  lrcx: "/companies/lam-research",
  lamresearch: "/companies/lam-research",
  "lam semiconductor": "/companies/lam-research",

  /* contemporary amperex */
  catl: "/companies/catl",
  "contemporary amperex technology": "/companies/catl",
  "contemporary amperex": "/companies/catl",
  "catl battery": "/companies/catl",
  "catl batteries": "/companies/catl",
  "catl china": "/companies/catl",
  "300750": "/companies/catl",
  "catl stock": "/companies/catl",

  /* contemporary amperex*/
  /* petrochina*/
  petrochina: "/companies/petrochina",
  "petro china": "/companies/petrochina",
  cnpc: "/companies/petrochina",
  "china national petroleum corporation": "/companies/petrochina",
  "china petroleum": "/companies/petrochina",
  "petrochina company": "/companies/petrochina",
  "0857": "/companies/petrochina",
  "petrochina stock": "/companies/petrochina",
  "petrochina china": "/companies/petrochina",

  /* petrochina*/

  /* philip-morris-international */
  "philip-morris-international": "/companies/philip-morris-international",
  "philip morris international": "/companies/philip-morris-international",
  "philip morris": "/companies/philip-morris-international",
  pmi: "/companies/philip-morris-international",
  pm: "/companies/philip-morris-international",
  "philip morris company": "/companies/philip-morris-international",
  "philip morris usa": "/companies/philip-morris-international",
  "philip morris stock": "/companies/philip-morris-international",
  "philip morris tobacco": "/companies/philip-morris-international",

  /* philip-morris-international */
  /* kweichow-moutai*/
  "kweichow-moutai": "/companies/kweichow-moutai",
  "kweichow moutai": "/companies/kweichow-moutai",
  moutai: "/companies/kweichow-moutai",
  maotai: "/companies/kweichow-moutai",
  kweichow: "/companies/kweichow-moutai",
  "moutai china": "/companies/kweichow-moutai",
  "600519": "/companies/kweichow-moutai",
  "kweichow moutai stock": "/companies/kweichow-moutai",
  "moutai liquor": "/companies/kweichow-moutai",

  /* kweichow-moutai*/
  /* shell*/
  shell: "/companies/shell",
  "royal dutch shell": "/companies/shell",
  "shell plc": "/companies/shell",
  "shell company": "/companies/shell",
  "shell oil": "/companies/shell",
  "shell energy": "/companies/shell",
  "shell gas": "/companies/shell",
  shel: "/companies/shell",
  "shell stock": "/companies/shell",

  /* shell*/
  /* international-holding-company */
  "international-holding-company": "/companies/international-holding-company",
  "international holding company": "/companies/international-holding-company",
  ihc: "/companies/international-holding-company",
  "ihc uae": "/companies/international-holding-company",
  "ihc abu dhabi": "/companies/international-holding-company",
  "ihc adx": "/companies/international-holding-company",
  "ihc stock": "/companies/international-holding-company",
  "international holding": "/companies/international-holding-company",
  "international holdings": "/companies/international-holding-company",
  "ihc group": "/companies/international-holding-company",
  "international holding company uae":
    "/companies/international-holding-company",
  "international holding company abu dhabi":
    "/companies/international-holding-company",
  "international holding co": "/companies/international-holding-company",
  "international holding co.": "/companies/international-holding-company",
  "adx ihc": "/companies/international-holding-company",
  /* international-holding-company */

  /* kla-corporation */
  "kla-corporation": "/companies/kla-corporation",
  "kla corporation": "/companies/kla-corporation",
  kla: "/companies/kla-corporation",
  "kla corp": "/companies/kla-corporation",
  "kla inc": "/companies/kla-corporation",
  "kla semiconductor": "/companies/kla-corporation",
  "kla systems": "/companies/kla-corporation",
  "kla inspection": "/companies/kla-corporation",
  "kla metrology": "/companies/kla-corporation",
  klac: "/companies/kla-corporation",
  "klac stock": "/companies/kla-corporation",
  "kla stock": "/companies/kla-corporation",
  "kla usa": "/companies/kla-corporation",
  "kla equipment": "/companies/kla-corporation",
  /* kla-corporation */

  /* linde */
  linde: "/companies/linde",
  "linde plc": "/companies/linde",
  "linde ag": "/companies/linde",
  "linde group": "/companies/linde",
  "linde company": "/companies/linde",
  "linde corporation": "/companies/linde",
  "linde engineering": "/companies/linde",
  "linde gases": "/companies/linde",
  "linde industrial gases": "/companies/linde",
  "linde medical gases": "/companies/linde",
  "linde hydrogen": "/companies/linde",
  "linde hydrogen solutions": "/companies/linde",
  lin: "/companies/linde",
  "lin stock": "/companies/linde",
  "linde stock": "/companies/linde",
  "linde ireland": "/companies/linde",
  /* linde */

  /* arm-holdings */
  "arm-holdings": "/companies/arm-holdings",
  "arm holdings": "/companies/arm-holdings",
  arm: "/companies/arm-holdings",
  "arm ltd": "/companies/arm-holdings",
  "arm limited": "/companies/arm-holdings",
  "arm company": "/companies/arm-holdings",
  "arm architecture": "/companies/arm-holdings",
  "arm processors": "/companies/arm-holdings",
  "arm chips": "/companies/arm-holdings",
  "arm cpu": "/companies/arm-holdings",
  "arm semiconductor": "/companies/arm-holdings",
  "arm uk": "/companies/arm-holdings",
  "arm cambridge": "/companies/arm-holdings",
  armh: "/companies/arm-holdings",
  "armh stock": "/companies/arm-holdings",
  "arm stock": "/companies/arm-holdings",
  "arm nasdaq": "/companies/arm-holdings",
  /* arm-holdings */

  /* toyota */
  toyota: "/companies/toyota",
  "toyota motor": "/companies/toyota",
  "toyota motor corporation": "/companies/toyota",
  "toyota corp": "/companies/toyota",
  "toyota corporation": "/companies/toyota",
  "toyota japan": "/companies/toyota",
  "toyota global": "/companies/toyota",
  "toyota motors": "/companies/toyota",
  "toyota vehicles": "/companies/toyota",
  "toyota cars": "/companies/toyota",
  "toyota automotive": "/companies/toyota",
  "toyota hybrid": "/companies/toyota",
  "toyota electric": "/companies/toyota",
  "toyota ev": "/companies/toyota",
  "toyota suv": "/companies/toyota",
  "toyota trucks": "/companies/toyota",
  "toyota city": "/companies/toyota",
  "toyota aichi": "/companies/toyota",
  "toyota company": "/companies/toyota",
  "toyota motor co": "/companies/toyota",
  "toyota motor co.": "/companies/toyota",
  "toyota tse": "/companies/toyota",
  "toyota nyse": "/companies/toyota",
  "toyota stock": "/companies/toyota",
  "7203": "/companies/toyota",
  tm: "/companies/toyota",
  "tm stock": "/companies/toyota",
  /* toyota */
  /* softbank-group */
  "softbank-group": "/companies/softbank-group",
  "softbank group": "/companies/softbank-group",
  softbank: "/companies/softbank-group",
  "softbank corp": "/companies/softbank-group",
  "softbank corporation": "/companies/softbank-group",
  "softbank group corp": "/companies/softbank-group",
  "softbank group corp.": "/companies/softbank-group",
  "softbank japan": "/companies/softbank-group",
  "softbank holdings": "/companies/softbank-group",
  "softbank investment": "/companies/softbank-group",
  "softbank ventures": "/companies/softbank-group",
  "softbank ai": "/companies/softbank-group",
  "softbank robotics": "/companies/softbank-group",
  "softbank telecom": "/companies/softbank-group",
  "softbank mobile": "/companies/softbank-group",
  "softbank tokyo": "/companies/softbank-group",
  "softbank group japan": "/companies/softbank-group",
  "9984": "/companies/softbank-group",
  "9984 stock": "/companies/softbank-group",
  "softbank stock": "/companies/softbank-group",
  /* softbank-group */

  /* prosus */
  prosus: "/companies/prosus",
  "prosus nv": "/companies/prosus",
  "prosus n.v.": "/companies/prosus",
  "prosus group": "/companies/prosus",
  "prosus company": "/companies/prosus",
  "prosus holding": "/companies/prosus",
  "prosus holdings": "/companies/prosus",
  "prosus investments": "/companies/prosus",
  "prosus tech": "/companies/prosus",
  "prosus technology": "/companies/prosus",
  "prosus internet": "/companies/prosus",
  "prosus global": "/companies/prosus",
  "prosus amsterdam": "/companies/prosus",
  "prosus netherlands": "/companies/prosus",
  prx: "/companies/prosus",
  "prx stock": "/companies/prosus",
  "prosus stock": "/companies/prosus",
  /* prosus */

  /* commonwealth-bank-of-australia */
  "commonwealth-bank-of-australia": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank of australia": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank": "/companies/commonwealth-bank-of-australia",
  commbank: "/companies/commonwealth-bank-of-australia",
  "comm bank": "/companies/commonwealth-bank-of-australia",
  cba: "/companies/commonwealth-bank-of-australia",
  "cba bank": "/companies/commonwealth-bank-of-australia",
  "cba australia": "/companies/commonwealth-bank-of-australia",
  "cba stock": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank australia": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank au": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank sydney": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank nsw": "/companies/commonwealth-bank-of-australia",
  "commbank australia": "/companies/commonwealth-bank-of-australia",
  "commbank au": "/companies/commonwealth-bank-of-australia",
  "commbank sydney": "/companies/commonwealth-bank-of-australia",
  "commbank nsw": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank loans": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank credit": "/companies/commonwealth-bank-of-australia",
  "commonwealth bank wealth": "/companies/commonwealth-bank-of-australia",
  /* commonwealth-bank-of-australia */
  /* t-mobile-us */
  "t-mobile-us": "/companies/t-mobile-us",
  "t mobile us": "/companies/t-mobile-us",
  tmobile: "/companies/t-mobile-us",
  "t-mobile": "/companies/t-mobile-us",
  "t mobile": "/companies/t-mobile-us",
  "t-mobile usa": "/companies/t-mobile-us",
  "t mobile usa": "/companies/t-mobile-us",
  "t-mobile united states": "/companies/t-mobile-us",
  "t mobile united states": "/companies/t-mobile-us",
  tmus: "/companies/t-mobile-us",
  "tmus stock": "/companies/t-mobile-us",
  "t-mobile stock": "/companies/t-mobile-us",
  "t mobile stock": "/companies/t-mobile-us",
  "t-mobile 5g": "/companies/t-mobile-us",
  "t mobile 5g": "/companies/t-mobile-us",
  "t-mobile wireless": "/companies/t-mobile-us",
  "t mobile wireless": "/companies/t-mobile-us",
  "t-mobile internet": "/companies/t-mobile-us",
  "t mobile internet": "/companies/t-mobile-us",
  "t-mobile home internet": "/companies/t-mobile-us",
  "t mobile home internet": "/companies/t-mobile-us",
  "t-mobile bellevue": "/companies/t-mobile-us",
  "t mobile bellevue": "/companies/t-mobile-us",
  /* t-mobile-us */

  /* hermes */
  hermes: "/companies/hermes",
  hermès: "/companies/hermes",
  "hermes international": "/companies/hermes",
  "hermès international": "/companies/hermes",
  "hermes paris": "/companies/hermes",
  "hermès paris": "/companies/hermes",
  "hermes france": "/companies/hermes",
  "hermès france": "/companies/hermes",
  "hermes fashion": "/companies/hermes",
  "hermes luxury": "/companies/hermes",
  "hermes leather": "/companies/hermes",
  "hermes handbags": "/companies/hermes",
  "hermes bags": "/companies/hermes",
  "hermes birkin": "/companies/hermes",
  "hermes kelly": "/companies/hermes",
  "hermes scarves": "/companies/hermes",
  "hermes perfume": "/companies/hermes",
  rms: "/companies/hermes",
  "rms stock": "/companies/hermes",
  "hermes stock": "/companies/hermes",
  /* hermes */
  /* mitsubishi-ufj-financial-group */
  "mitsubishi-ufj-financial-group": "/companies/mitsubishi-ufj-financial-group",
  "mitsubishi ufj financial group": "/companies/mitsubishi-ufj-financial-group",
  mufg: "/companies/mitsubishi-ufj-financial-group",
  "mufg bank": "/companies/mitsubishi-ufj-financial-group",
  "mufg group": "/companies/mitsubishi-ufj-financial-group",
  "mufg japan": "/companies/mitsubishi-ufj-financial-group",
  "mufg tokyo": "/companies/mitsubishi-ufj-financial-group",
  "mitsubishi ufj": "/companies/mitsubishi-ufj-financial-group",
  "mitsubishi ufj bank": "/companies/mitsubishi-ufj-financial-group",
  "mitsubishi ufj group": "/companies/mitsubishi-ufj-financial-group",
  "mitsubishi bank": "/companies/mitsubishi-ufj-financial-group",
  "ufj bank": "/companies/mitsubishi-ufj-financial-group",
  "ufj group": "/companies/mitsubishi-ufj-financial-group",
  "mitsubishi financial": "/companies/mitsubishi-ufj-financial-group",
  "mitsubishi financial group": "/companies/mitsubishi-ufj-financial-group",
  8306: "/companies/mitsubishi-ufj-financial-group",
  "8306 stock": "/companies/mitsubishi-ufj-financial-group",
  "mufg stock": "/companies/mitsubishi-ufj-financial-group",
  /* mitsubishi-ufj-financial-group */

  /* analog-devices */
  "analog-devices": "/companies/analog-devices",
  "analog devices": "/companies/analog-devices",
  adi: "/companies/analog-devices",
  "adi inc": "/companies/analog-devices",
  "analog devices inc": "/companies/analog-devices",
  "analog devices incorporated": "/companies/analog-devices",
  "analog devices company": "/companies/analog-devices",
  "analog devices corporation": "/companies/analog-devices",
  "analog devices semiconductor": "/companies/analog-devices",
  "analog devices chips": "/companies/analog-devices",
  "analog devices converters": "/companies/analog-devices",
  "analog devices adc": "/companies/analog-devices",
  "analog devices dac": "/companies/analog-devices",
  "analog devices dsp": "/companies/analog-devices",
  "analog devices power": "/companies/analog-devices",
  "analog devices sensors": "/companies/analog-devices",
  "analog devices rf": "/companies/analog-devices",
  "analog devices microwave": "/companies/analog-devices",
  "analog devices wilmington": "/companies/analog-devices",
  "analog devices massachusetts": "/companies/analog-devices",
  "adi stock": "/companies/analog-devices",
  "analog devices stock": "/companies/analog-devices",
  /* analog-devices */
  /* sandisk */
  sandisk: "/companies/sandisk",
  "san disk": "/companies/sandisk",
  "sandisk corp": "/companies/sandisk",
  "sandisk corporation": "/companies/sandisk",
  "sandisk inc": "/companies/sandisk",
  "sandisk company": "/companies/sandisk",
  "sandisk storage": "/companies/sandisk",
  "sandisk memory": "/companies/sandisk",
  "sandisk flash": "/companies/sandisk",
  "sandisk flash memory": "/companies/sandisk",
  "sandisk ssd": "/companies/sandisk",
  "sandisk solid state": "/companies/sandisk",
  "sandisk usb": "/companies/sandisk",
  "sandisk usb drive": "/companies/sandisk",
  "sandisk memory card": "/companies/sandisk",
  "sandisk sd card": "/companies/sandisk",
  "sandisk microsd": "/companies/sandisk",
  "sandisk milpitas": "/companies/sandisk",
  "sandisk california": "/companies/sandisk",
  sndk: "/companies/sandisk",
  "sndk stock": "/companies/sandisk",
  "sandisk stock": "/companies/sandisk",
  /* sandisk */

  /* nextera-energy */
  "nextera-energy": "/companies/nextera-energy",
  "next era energy": "/companies/nextera-energy",
  nextera: "/companies/nextera-energy",
  "nextera energy": "/companies/nextera-energy",
  "nextera energy inc": "/companies/nextera-energy",
  "nextera energy company": "/companies/nextera-energy",
  "nextera energy corporation": "/companies/nextera-energy",

  /* renewable energy queries */
  "nextera renewable": "/companies/nextera-energy",
  "nextera renewables": "/companies/nextera-energy",
  "nextera wind": "/companies/nextera-energy",
  "nextera solar": "/companies/nextera-energy",
  "nextera energy storage": "/companies/nextera-energy",

  /* utility + FPL */
  "florida power and light": "/companies/nextera-energy",
  fpl: "/companies/nextera-energy",
  "fpl energy": "/companies/nextera-energy",

  /* geographic */
  "nextera juno beach": "/companies/nextera-energy",
  "nextera florida": "/companies/nextera-energy",

  /* ticker lookups */
  nee: "/companies/nextera-energy",
  "nee stock": "/companies/nextera-energy",
  "nextera stock": "/companies/nextera-energy",
  /* nextera-energy */

  /* inditex */
  inditex: "/companies/inditex",
  "indi tex": "/companies/inditex",
  "industria de diseño textil": "/companies/inditex",
  "industria de diseno textil": "/companies/inditex",
  "inditex sa": "/companies/inditex",
  "inditex s.a.": "/companies/inditex",
  "inditex spain": "/companies/inditex",
  "inditex arteixo": "/companies/inditex",
  "inditex galicia": "/companies/inditex",

  /* fashion group queries */
  "inditex fashion": "/companies/inditex",
  "inditex apparel": "/companies/inditex",
  "inditex clothing": "/companies/inditex",
  "inditex retail": "/companies/inditex",

  /* brand family associations */
  zara: "/companies/inditex",
  "zara home": "/companies/inditex",
  bershka: "/companies/inditex",
  pullbear: "/companies/inditex",
  "pull&bear": "/companies/inditex",
  "pull and bear": "/companies/inditex",
  "massimo dutti": "/companies/inditex",
  stradivarius: "/companies/inditex",
  oysho: "/companies/inditex",

  /* ticker lookups */
  itx: "/companies/inditex",
  "itx stock": "/companies/inditex",
  "inditex stock": "/companies/inditex",
  /* inditex */

  /* mediatek */
  mediatek: "/companies/mediatek",
  "media tek": "/companies/mediatek",
  "mediatek inc": "/companies/mediatek",
  "mediatek incorporated": "/companies/mediatek",
  "mediatek company": "/companies/mediatek",
  "mediatek corporation": "/companies/mediatek",
  "mediatek taiwan": "/companies/mediatek",
  "mediatek hsinchu": "/companies/mediatek",

  /* chipset + SoC queries */
  "mediatek soc": "/companies/mediatek",
  "mediatek chip": "/companies/mediatek",
  "mediatek chipset": "/companies/mediatek",
  "mediatek processor": "/companies/mediatek",
  "mediatek mobile chip": "/companies/mediatek",
  "mediatek smartphone chip": "/companies/mediatek",
  "mediatek dimensity": "/companies/mediatek",
  dimensity: "/companies/mediatek",

  /* connectivity + consumer electronics */
  "mediatek 5g": "/companies/mediatek",
  "mediatek wifi": "/companies/mediatek",
  "mediatek wifi chip": "/companies/mediatek",
  "mediatek tv chip": "/companies/mediatek",
  "mediatek smart tv": "/companies/mediatek",
  "mediatek iot": "/companies/mediatek",

  /* ticker lookups */
  2454: "/companies/mediatek",
  "2454 stock": "/companies/mediatek",
  "mediatek stock": "/companies/mediatek",
  /* mediatek */

  /* foxconn-industrial-internet */
  "foxconn-industrial-internet": "/companies/foxconn-industrial-internet",
  "foxconn industrial internet": "/companies/foxconn-industrial-internet",
  fii: "/companies/foxconn-industrial-internet",
  "fii foxconn": "/companies/foxconn-industrial-internet",
  "foxconn fii": "/companies/foxconn-industrial-internet",
  "foxconn internet": "/companies/foxconn-industrial-internet",
  "foxconn industrial": "/companies/foxconn-industrial-internet",

  /* chinese / regional queries */
  "foxconn china": "/companies/foxconn-industrial-internet",
  "foxconn shenzhen": "/companies/foxconn-industrial-internet",
  "fii china": "/companies/foxconn-industrial-internet",
  "fii shenzhen": "/companies/foxconn-industrial-internet",

  /* industrial internet + automation */
  "industrial internet": "/companies/foxconn-industrial-internet",
  "industrial internet of things": "/companies/foxconn-industrial-internet",
  "foxconn iot": "/companies/foxconn-industrial-internet",
  "fii iot": "/companies/foxconn-industrial-internet",
  "fii automation": "/companies/foxconn-industrial-internet",
  "foxconn automation": "/companies/foxconn-industrial-internet",
  "fii smart manufacturing": "/companies/foxconn-industrial-internet",
  "foxconn smart manufacturing": "/companies/foxconn-industrial-internet",

  /* cloud + AI */
  "fii cloud": "/companies/foxconn-industrial-internet",
  "foxconn cloud": "/companies/foxconn-industrial-internet",
  "fii ai": "/companies/foxconn-industrial-internet",
  "foxconn ai": "/companies/foxconn-industrial-internet",

  /* ticker lookups */
  601138: "/companies/foxconn-industrial-internet",
  "601138 stock": "/companies/foxconn-industrial-internet",
  "fii stock": "/companies/foxconn-industrial-internet",
  "foxconn industrial internet stock": "/companies/foxconn-industrial-internet",
  /* foxconn-industrial-internet */

  /* schneider-electric */
  "schneider-electric": "/companies/schneider-electric",
  "schneider electric": "/companies/schneider-electric",
  schneider: "/companies/schneider-electric",
  "schneider electric se": "/companies/schneider-electric",
  "schneider se": "/companies/schneider-electric",
  "schneider france": "/companies/schneider-electric",
  "schneider rueil malmaison": "/companies/schneider-electric",
  "schneider rueil-malmaison": "/companies/schneider-electric",

  /* energy management */
  "schneider energy": "/companies/schneider-electric",
  "schneider energy management": "/companies/schneider-electric",
  "schneider power": "/companies/schneider-electric",
  "schneider electrical distribution": "/companies/schneider-electric",
  "schneider electrical": "/companies/schneider-electric",

  /* automation + industrial systems */
  "schneider automation": "/companies/schneider-electric",
  "schneider industrial automation": "/companies/schneider-electric",
  "schneider plc": "/companies/schneider-electric",
  "schneider control systems": "/companies/schneider-electric",
  "schneider building management": "/companies/schneider-electric",
  "schneider bms": "/companies/schneider-electric",

  /* digital transformation */
  "schneider digital": "/companies/schneider-electric",
  "schneider iot": "/companies/schneider-electric",
  "schneider smart systems": "/companies/schneider-electric",

  /* renewable + sustainability */
  "schneider renewable": "/companies/schneider-electric",
  "schneider green energy": "/companies/schneider-electric",
  "schneider sustainability": "/companies/schneider-electric",

  /* ticker lookups */
  su: "/companies/schneider-electric",
  "su stock": "/companies/schneider-electric",
  "schneider stock": "/companies/schneider-electric",
  /* schneider-electric */

  /* siemens-energy */
  "siemens-energy": "/companies/siemens-energy",
  "siemens energy": "/companies/siemens-energy",
  "siemens energy ag": "/companies/siemens-energy",
  "siemens ag energy": "/companies/siemens-energy",
  "siemens power": "/companies/siemens-energy",
  "siemens germany energy": "/companies/siemens-energy",
  "siemens munich": "/companies/siemens-energy",

  /* turbines + generation */
  "siemens gas turbine": "/companies/siemens-energy",
  "siemens gas turbines": "/companies/siemens-energy",
  "siemens steam turbine": "/companies/siemens-energy",
  "siemens steam turbines": "/companies/siemens-energy",
  "siemens power generation": "/companies/siemens-energy",

  /* grid + transmission */
  "siemens grid": "/companies/siemens-energy",
  "siemens grid technology": "/companies/siemens-energy",
  "siemens transmission": "/companies/siemens-energy",
  "siemens hvdc": "/companies/siemens-energy",

  /* renewable + hydrogen */
  "siemens wind": "/companies/siemens-energy",
  "siemens wind power": "/companies/siemens-energy",
  "siemens hydrogen": "/companies/siemens-energy",
  "siemens hydrogen energy": "/companies/siemens-energy",

  /* ticker lookups */
  enr: "/companies/siemens-energy",
  "enr stock": "/companies/siemens-energy",
  "siemens energy stock": "/companies/siemens-energy",
  /* siemens-energy */
  /* toronto-dominion-bank */
  "toronto-dominion-bank": "/companies/toronto-dominion-bank",
  "toronto dominion bank": "/companies/toronto-dominion-bank",
  "toronto dominion": "/companies/toronto-dominion-bank",
  "td bank": "/companies/toronto-dominion-bank",
  "td bank group": "/companies/toronto-dominion-bank",
  "td group": "/companies/toronto-dominion-bank",
  "td canada trust": "/companies/toronto-dominion-bank",
  "td canada": "/companies/toronto-dominion-bank",
  "td toronto": "/companies/toronto-dominion-bank",
  "td canada bank": "/companies/toronto-dominion-bank",

  /* banking services */
  "td personal banking": "/companies/toronto-dominion-bank",
  "td commercial banking": "/companies/toronto-dominion-bank",
  "td wealth": "/companies/toronto-dominion-bank",
  "td wealth management": "/companies/toronto-dominion-bank",
  "td insurance": "/companies/toronto-dominion-bank",
  "td investments": "/companies/toronto-dominion-bank",

  /* geographic */

  "td ontario": "/companies/toronto-dominion-bank",

  /* ticker lookups */
  td: "/companies/toronto-dominion-bank",
  "td stock": "/companies/toronto-dominion-bank",
  "toronto dominion stock": "/companies/toronto-dominion-bank",
  /* toronto-dominion-bank */

  /* arista-networks */
  "arista-networks": "/companies/arista-networks",
  "arista networks": "/companies/arista-networks",
  arista: "/companies/arista-networks",
  "arista inc": "/companies/arista-networks",
  "arista networks inc": "/companies/arista-networks",
  "arista santa clara": "/companies/arista-networks",
  "arista california": "/companies/arista-networks",

  /* cloud networking + data center */
  "arista cloud": "/companies/arista-networks",
  "arista cloud networking": "/companies/arista-networks",
  "arista data center": "/companies/arista-networks",
  "arista datacenter": "/companies/arista-networks",
  "arista dc switches": "/companies/arista-networks",
  "arista spine switches": "/companies/arista-networks",
  "arista leaf switches": "/companies/arista-networks",

  /* switching + routing */
  "arista switch": "/companies/arista-networks",
  "arista switches": "/companies/arista-networks",
  "arista routing": "/companies/arista-networks",
  "arista routers": "/companies/arista-networks",
  "arista layer 3": "/companies/arista-networks",

  /* EOS / software-driven networking */
  "arista eos": "/companies/arista-networks",
  eos: "/companies/arista-networks",
  "arista network os": "/companies/arista-networks",
  "arista nos": "/companies/arista-networks",
  "arista software defined": "/companies/arista-networks",
  "arista sdn": "/companies/arista-networks",

  /* ticker lookups */
  anet: "/companies/arista-networks",
  "anet stock": "/companies/arista-networks",
  "arista stock": "/companies/arista-networks",
  /* arista-networks */

  /* amgen */
  amgen: "/companies/amgen",
  "amgen inc": "/companies/amgen",
  "amgen incorporated": "/companies/amgen",
  "amgen company": "/companies/amgen",
  "amgen corporation": "/companies/amgen",
  "amgen thousand oaks": "/companies/amgen",
  "amgen california": "/companies/amgen",

  /* biotech + therapeutics */
  "amgen biotech": "/companies/amgen",
  "amgen biopharma": "/companies/amgen",
  "amgen pharmaceuticals": "/companies/amgen",
  "amgen oncology": "/companies/amgen",
  "amgen cancer": "/companies/amgen",
  "amgen cardiovascular": "/companies/amgen",
  "amgen inflammation": "/companies/amgen",
  "amgen bone health": "/companies/amgen",
  "amgen nephrology": "/companies/amgen",
  "amgen neuroscience": "/companies/amgen",

  /* drug / therapy queries */
  "amgen drugs": "/companies/amgen",
  "amgen treatments": "/companies/amgen",
  "amgen therapies": "/companies/amgen",

  /* ticker lookups */
  amgn: "/companies/amgen",
  "amgn stock": "/companies/amgen",
  "amgen stock": "/companies/amgen",
  /* amgen */

  /* thermo-fisher-scientific */
  "thermo-fisher-scientific": "/companies/thermo-fisher-scientific",
  "thermo fisher scientific": "/companies/thermo-fisher-scientific",
  "thermo fisher": "/companies/thermo-fisher-scientific",
  "thermo scientific": "/companies/thermo-fisher-scientific",
  "thermo fisher inc": "/companies/thermo-fisher-scientific",
  "thermo fisher corporation": "/companies/thermo-fisher-scientific",
  "thermo fisher company": "/companies/thermo-fisher-scientific",
  "thermo waltham": "/companies/thermo-fisher-scientific",

  /* scientific instruments + lab equipment */
  "thermo fisher instruments": "/companies/thermo-fisher-scientific",
  "thermo fisher lab equipment": "/companies/thermo-fisher-scientific",
  "thermo fisher laboratory": "/companies/thermo-fisher-scientific",
  "thermo fisher reagents": "/companies/thermo-fisher-scientific",
  "thermo fisher consumables": "/companies/thermo-fisher-scientific",
  "thermo fisher diagnostics": "/companies/thermo-fisher-scientific",

  /* life sciences + biotech */
  "thermo fisher life sciences": "/companies/thermo-fisher-scientific",
  "thermo fisher biotech": "/companies/thermo-fisher-scientific",
  "thermo fisher genomics": "/companies/thermo-fisher-scientific",
  "thermo fisher proteomics": "/companies/thermo-fisher-scientific",

  /* software + research tools */
  "thermo fisher software": "/companies/thermo-fisher-scientific",
  "thermo fisher research tools": "/companies/thermo-fisher-scientific",

  /* ticker lookups */
  tmo: "/companies/thermo-fisher-scientific",
  "tmo stock": "/companies/thermo-fisher-scientific",
  "thermo fisher stock": "/companies/thermo-fisher-scientific",
  /* thermo-fisher-scientific */
  /* tjx-companies */
  "tjx-companies": "/companies/tjx-companies",
  "tjx companies": "/companies/tjx-companies",
  tjx: "/companies/tjx-companies",
  "tjx inc": "/companies/tjx-companies",
  "tjx corporation": "/companies/tjx-companies",
  "tjx framingham": "/companies/tjx-companies",
  "tjx massachusetts": "/companies/tjx-companies",

  /* major retail chains */
  "t.j. maxx": "/companies/tjx-companies",
  "tj maxx": "/companies/tjx-companies",
  marshalls: "/companies/tjx-companies",
  homegoods: "/companies/tjx-companies",
  "home goods": "/companies/tjx-companies",
  homesense: "/companies/tjx-companies",
  "tk maxx": "/companies/tjx-companies",
  "t k maxx": "/companies/tjx-companies",
  winners: "/companies/tjx-companies",

  /* retail categories */
  "tjx apparel": "/companies/tjx-companies",
  "tjx clothing": "/companies/tjx-companies",
  "tjx home goods": "/companies/tjx-companies",
  "tjx accessories": "/companies/tjx-companies",
  "tjx footwear": "/companies/tjx-companies",
  "tjx discount stores": "/companies/tjx-companies",
  "tjx off price": "/companies/tjx-companies",
  "tjx off-price": "/companies/tjx-companies",

  /* ticker lookups */
  "tjx stock": "/companies/tjx-companies",
  "tjx companies stock": "/companies/tjx-companies",
  /* tjx-companies */

  /* amphenol */
  amphenol: "/companies/amphenol",
  "amphenol corporation": "/companies/amphenol",
  "amphenol corp": "/companies/amphenol",
  "amphenol inc": "/companies/amphenol",
  "amphenol company": "/companies/amphenol",
  "amphenol wallingford": "/companies/amphenol",
  "amphenol connecticut": "/companies/amphenol",

  /* connectors + interconnect systems */
  "amphenol connectors": "/companies/amphenol",
  "amphenol connector": "/companies/amphenol",
  "amphenol interconnect": "/companies/amphenol",
  "amphenol interconnect systems": "/companies/amphenol",
  "amphenol wiring": "/companies/amphenol",
  "amphenol cable": "/companies/amphenol",

  /* fiber optics + antennas + sensors */
  "amphenol fiber": "/companies/amphenol",
  "amphenol fiber optic": "/companies/amphenol",
  "amphenol antennas": "/companies/amphenol",
  "amphenol antenna": "/companies/amphenol",
  "amphenol sensors": "/companies/amphenol",
  "amphenol sensor": "/companies/amphenol",

  /* industry verticals */
  "amphenol aerospace": "/companies/amphenol",
  "amphenol automotive": "/companies/amphenol",
  "amphenol industrial": "/companies/amphenol",
  "amphenol military": "/companies/amphenol",

  /* ticker lookups */
  aph: "/companies/amphenol",
  "aph stock": "/companies/amphenol",
  "amphenol stock": "/companies/amphenol",
  /* amphenol */

  /* applovin */
  applovin: "/companies/applovin",
  "app lovin": "/companies/applovin",
  "applovin corporation": "/companies/applovin",
  "applovin corp": "/companies/applovin",
  "applovin inc": "/companies/applovin",
  "applovin palo alto": "/companies/applovin",
  "applovin california": "/companies/applovin",

  /* ad tech + monetization */
  "applovin ads": "/companies/applovin",
  "applovin advertising": "/companies/applovin",
  "applovin ad network": "/companies/applovin",
  "applovin ad networks": "/companies/applovin",
  "applovin monetization": "/companies/applovin",
  "applovin mediation": "/companies/applovin",
  "applovin max": "/companies/applovin",
  "max mediation": "/companies/applovin",

  /* analytics + app growth */
  "applovin analytics": "/companies/applovin",
  "applovin marketing": "/companies/applovin",
  "applovin app growth": "/companies/applovin",
  "applovin growth platform": "/companies/applovin",
  "applovin software": "/companies/applovin",

  /* developer tools */
  "applovin sdk": "/companies/applovin",
  "applovin developer": "/companies/applovin",
  "applovin dev tools": "/companies/applovin",

  /* ticker lookups */
  app: "/companies/applovin",
  "app stock": "/companies/applovin",
  "applovin stock": "/companies/applovin",
  /* applovin */

  /* gilead-sciences */
  "gilead-sciences": "/companies/gilead-sciences",
  "gilead sciences": "/companies/gilead-sciences",
  gilead: "/companies/gilead-sciences",
  "gilead inc": "/companies/gilead-sciences",
  "gilead corporation": "/companies/gilead-sciences",
  "gilead foster city": "/companies/gilead-sciences",
  "gilead california": "/companies/gilead-sciences",

  /* antiviral + infectious disease */
  "gilead hiv": "/companies/gilead-sciences",
  "gilead hiv treatments": "/companies/gilead-sciences",
  "gilead hepatitis": "/companies/gilead-sciences",
  "gilead hep c": "/companies/gilead-sciences",
  "gilead hep b": "/companies/gilead-sciences",
  "gilead antiviral": "/companies/gilead-sciences",
  "gilead antivirals": "/companies/gilead-sciences",

  /* oncology + cell therapy */
  "gilead oncology": "/companies/gilead-sciences",
  "gilead cancer": "/companies/gilead-sciences",
  "gilead cell therapy": "/companies/gilead-sciences",
  "gilead immunotherapy": "/companies/gilead-sciences",

  /* inflammation + immunology */
  "gilead inflammation": "/companies/gilead-sciences",
  "gilead immunology": "/companies/gilead-sciences",

  /* ticker lookups */
  gild: "/companies/gilead-sciences",
  "gild stock": "/companies/gilead-sciences",
  "gilead stock": "/companies/gilead-sciences",
  /* gilead-sciences */

  /* allianz-se */
  "allianz-se": "/companies/allianz-se",
  "allianz se": "/companies/allianz-se",
  allianz: "/companies/allianz-se",
  "allianz group": "/companies/allianz-se",
  "allianz ag": "/companies/allianz-se",
  "allianz germany": "/companies/allianz-se",
  "allianz munich": "/companies/allianz-se",

  /* insurance categories */
  "allianz insurance": "/companies/allianz-se",
  "allianz life insurance": "/companies/allianz-se",
  "allianz health insurance": "/companies/allianz-se",
  "allianz property insurance": "/companies/allianz-se",
  "allianz casualty insurance": "/companies/allianz-se",
  "allianz p&c": "/companies/allianz-se",
  "allianz p and c": "/companies/allianz-se",

  /* asset management + retirement */
  "allianz asset management": "/companies/allianz-se",
  "allianz investments": "/companies/allianz-se",
  "allianz investment management": "/companies/allianz-se",
  "allianz retirement": "/companies/allianz-se",
  "allianz pension": "/companies/allianz-se",

  /* subsidiaries / brands */
  "allianz global investors": "/companies/allianz-se",
  "allianz gi": "/companies/allianz-se",
  pimco: "/companies/allianz-se",

  /* ticker lookups */
  alv: "/companies/allianz-se",
  "alv stock": "/companies/allianz-se",
  "allianz stock": "/companies/allianz-se",
  /* allianz-se */

  /* intuitive-surgical */
  "intuitive-surgical": "/companies/intuitive-surgical",
  "intuitive surgical": "/companies/intuitive-surgical",
  intuitive: "/companies/intuitive-surgical",
  "intuitive inc": "/companies/intuitive-surgical",
  "intuitive corporation": "/companies/intuitive-surgical",
  "intuitive sunnyvale": "/companies/intuitive-surgical",
  "intuitive california": "/companies/intuitive-surgical",

  /* da Vinci surgical system */
  "da vinci": "/companies/intuitive-surgical",
  "da vinci robot": "/companies/intuitive-surgical",
  "da vinci surgical": "/companies/intuitive-surgical",
  "da vinci surgical system": "/companies/intuitive-surgical",
  "davinci system": "/companies/intuitive-surgical",
  "davinci robot": "/companies/intuitive-surgical",

  /* vinci */
  vinci: "/companies/vinci",
  "vinci construction": "/companies/vinci",
  "vinci infrastructure": "/companies/vinci",
  "vinci energy": "/companies/vinci",
  "vinci france": "/companies/vinci",
  "vinci nanterre": "/companies/vinci",
  "dg.pa": "/companies/vinci",
  "vinci stock": "/companies/vinci",
  /* vinci */

  /* robotic-assisted surgery */
  "intuitive robotics": "/companies/intuitive-surgical",
  "intuitive robotic surgery": "/companies/intuitive-surgical",
  "intuitive surgical robots": "/companies/intuitive-surgical",
  "robotic surgery platform": "/companies/intuitive-surgical",
  "robot-assisted surgery": "/companies/intuitive-surgical",

  /* instruments + imaging + digital surgery */
  "intuitive surgical instruments": "/companies/intuitive-surgical",
  "intuitive imaging": "/companies/intuitive-surgical",
  "intuitive digital surgery": "/companies/intuitive-surgical",
  "intuitive surgery software": "/companies/intuitive-surgical",

  /* ticker lookups */
  isrg: "/companies/intuitive-surgical",
  "isrg stock": "/companies/intuitive-surgical",
  "intuitive surgical stock": "/companies/intuitive-surgical",
  /* intuitive-surgical */

  /* cnooc */
  cnooc: "/companies/cnooc",
  "cnooc limited": "/companies/cnooc",
  "cnooc ltd": "/companies/cnooc",
  "cnooc china": "/companies/cnooc",
  "cnooc beijing": "/companies/cnooc",
  "china national offshore oil": "/companies/cnooc",
  "china national offshore oil corporation": "/companies/cnooc",

  /* oil & gas */
  "cnooc oil": "/companies/cnooc",
  "cnooc crude oil": "/companies/cnooc",
  "cnooc natural gas": "/companies/cnooc",
  "cnooc gas": "/companies/cnooc",
  "cnooc offshore": "/companies/cnooc",
  "cnooc offshore drilling": "/companies/cnooc",
  "cnooc exploration": "/companies/cnooc",
  "cnooc petroleum": "/companies/cnooc",

  /* energy + production */
  "cnooc energy": "/companies/cnooc",
  "cnooc energy production": "/companies/cnooc",
  "cnooc development": "/companies/cnooc",

  /* ticker lookups */
  "0883": "/companies/cnooc",
  "0883 stock": "/companies/cnooc",
  "cnooc stock": "/companies/cnooc",
  /* cnooc */

  /* ping-an-insurance */
  "ping-an-insurance": "/companies/ping-an-insurance",
  "ping an insurance": "/companies/ping-an-insurance",
  "ping an": "/companies/ping-an-insurance",
  "ping an group": "/companies/ping-an-insurance",
  "ping an china": "/companies/ping-an-insurance",
  "ping an shenzhen": "/companies/ping-an-insurance",
  "ping an guangdong": "/companies/ping-an-insurance",

  /* insurance categories */
  "ping an life insurance": "/companies/ping-an-insurance",
  "ping an health insurance": "/companies/ping-an-insurance",
  "ping an property insurance": "/companies/ping-an-insurance",
  "ping an p&c": "/companies/ping-an-insurance",
  "ping an p and c": "/companies/ping-an-insurance",

  /* banking + financial services */
  "ping an bank": "/companies/ping-an-insurance",
  "ping an banking": "/companies/ping-an-insurance",
  "ping an financial": "/companies/ping-an-insurance",
  "ping an finance": "/companies/ping-an-insurance",
  "ping an asset management": "/companies/ping-an-insurance",
  "ping an investments": "/companies/ping-an-insurance",

  /* healthcare + technology */
  "ping an healthcare": "/companies/ping-an-insurance",
  "ping an healthtech": "/companies/ping-an-insurance",
  "ping an good doctor": "/companies/ping-an-insurance",
  "ping an technology": "/companies/ping-an-insurance",

  /* ticker lookups */
  "2318": "/companies/ping-an-insurance",
  "2318 stock": "/companies/ping-an-insurance",
  "601318": "/companies/ping-an-insurance",
  "601318 stock": "/companies/ping-an-insurance",
  "ping an stock": "/companies/ping-an-insurance",
  /* ping-an-insurance */
  /* union-pacific-corporation */
  "union-pacific-corporation": "/companies/union-pacific-corporation",
  "union pacific corporation": "/companies/union-pacific-corporation",
  "union pacific": "/companies/union-pacific-corporation",
  "union pacific railroad": "/companies/union-pacific-corporation",
  "union pacific railway": "/companies/union-pacific-corporation",
  "union pacific rail": "/companies/union-pacific-corporation",
  "union pacific omaha": "/companies/union-pacific-corporation",
  "union pacific nebraska": "/companies/union-pacific-corporation",

  /* freight + intermodal + logistics */
  "union pacific freight": "/companies/union-pacific-corporation",
  "union pacific freight rail": "/companies/union-pacific-corporation",
  "union pacific intermodal": "/companies/union-pacific-corporation",
  "union pacific bulk": "/companies/union-pacific-corporation",
  "union pacific shipping": "/companies/union-pacific-corporation",
  "union pacific logistics": "/companies/union-pacific-corporation",

  /* industry shorthand */
  "up railroad": "/companies/union-pacific-corporation",
  "up rail": "/companies/union-pacific-corporation",
  "up freight": "/companies/union-pacific-corporation",
  "up logistics": "/companies/union-pacific-corporation",

  /* ticker lookups */
  unp: "/companies/union-pacific-corporation",
  "unp stock": "/companies/union-pacific-corporation",
  "union pacific stock": "/companies/union-pacific-corporation",
  /* union-pacific-corporation */

  /* corning */
  corning: "/companies/corning",
  "corning incorporated": "/companies/corning",
  "corning inc": "/companies/corning",
  "corning company": "/companies/corning",
  "corning new york": "/companies/corning",
  "corning ny": "/companies/corning",

  /* specialty glass */
  "corning glass": "/companies/corning",
  "corning specialty glass": "/companies/corning",
  "corning gorilla glass": "/companies/corning",
  "gorilla glass": "/companies/corning",

  /* fiber optics + telecom */
  "corning fiber": "/companies/corning",
  "corning fiber optics": "/companies/corning",
  "corning optical": "/companies/corning",
  "corning optical fiber": "/companies/corning",
  "corning telecom": "/companies/corning",

  /* display technologies */
  "corning display": "/companies/corning",
  "corning display glass": "/companies/corning",
  "corning lcd glass": "/companies/corning",

  /* automotive + life sciences */
  "corning automotive": "/companies/corning",
  "corning automotive glass": "/companies/corning",
  "corning life sciences": "/companies/corning",
  "corning labware": "/companies/corning",

  /* ticker lookups */
  glw: "/companies/corning",
  "glw stock": "/companies/corning",
  "corning stock": "/companies/corning",
  /* corning */
  /* charles-schwab */
  "charles-schwab": "/companies/charles-schwab",
  "charles schwab": "/companies/charles-schwab",
  schwab: "/companies/charles-schwab",
  "schwab corp": "/companies/charles-schwab",
  "schwab corporation": "/companies/charles-schwab",
  "schwab inc": "/companies/charles-schwab",
  "schwab westlake": "/companies/charles-schwab",
  "schwab texas": "/companies/charles-schwab",

  /* brokerage + trading */
  "schwab brokerage": "/companies/charles-schwab",
  "schwab trading": "/companies/charles-schwab",
  "schwab stocks": "/companies/charles-schwab",
  "schwab investing": "/companies/charles-schwab",

  /* wealth management + advisory */
  "schwab wealth management": "/companies/charles-schwab",
  "schwab wealth": "/companies/charles-schwab",
  "schwab advisory": "/companies/charles-schwab",
  "schwab financial advisor": "/companies/charles-schwab",

  /* banking + retirement */
  "schwab bank": "/companies/charles-schwab",
  "schwab banking": "/companies/charles-schwab",
  "schwab retirement": "/companies/charles-schwab",
  "schwab ira": "/companies/charles-schwab",

  /* ticker lookups */
  schw: "/companies/charles-schwab",
  "schw stock": "/companies/charles-schwab",
  "schwab stock": "/companies/charles-schwab",
  /* charles-schwab */

  /* deutsche-telekom */
  "deutsche-telekom": "/companies/deutsche-telekom",
  "deutsche telekom": "/companies/deutsche-telekom",
  telekom: "/companies/deutsche-telekom",
  "telekom germany": "/companies/deutsche-telekom",
  "deutsche telekom ag": "/companies/deutsche-telekom",
  "dt ag": "/companies/deutsche-telekom",
  "deutsche telekom bonn": "/companies/deutsche-telekom",
  "deutsche telekom nrw": "/companies/deutsche-telekom",

  /* mobile + broadband */
  "telekom mobile": "/companies/deutsche-telekom",
  "telekom 5g": "/companies/deutsche-telekom",
  "telekom cellular": "/companies/deutsche-telekom",
  "telekom broadband": "/companies/deutsche-telekom",
  "telekom internet": "/companies/deutsche-telekom",
  "telekom fixed line": "/companies/deutsche-telekom",

  /* IT + enterprise services */
  "telekom it": "/companies/deutsche-telekom",
  "telekom it services": "/companies/deutsche-telekom",
  "telekom cloud": "/companies/deutsche-telekom",
  "telekom enterprise": "/companies/deutsche-telekom",

  /* T‑Mobile global references */
  "t mobile europe": "/companies/deutsche-telekom",
  "t mobile germany": "/companies/deutsche-telekom",
  "tmobile de": "/companies/deutsche-telekom",

  /* ticker lookups */
  dte: "/companies/deutsche-telekom",
  "dte stock": "/companies/deutsche-telekom",
  "deutsche telekom stock": "/companies/deutsche-telekom",
  /* deutsche-telekom */

  /* southern-copper */
  "southern-copper": "/companies/southern-copper",
  "southern copper": "/companies/southern-copper",
  "southern copper corp": "/companies/southern-copper",
  "southern copper corporation": "/companies/southern-copper",
  "southern copper phoenix": "/companies/southern-copper",
  "southern copper arizona": "/companies/southern-copper",

  /* mining + metals */
  "southern copper mining": "/companies/southern-copper",
  "southern copper mines": "/companies/southern-copper",
  "southern copper smelting": "/companies/southern-copper",
  "southern copper refining": "/companies/southern-copper",

  /* commodities */
  "southern copper copper": "/companies/southern-copper",
  "southern copper molybdenum": "/companies/southern-copper",
  "southern copper silver": "/companies/southern-copper",
  "southern copper zinc": "/companies/southern-copper",

  /* regional operations */
  "southern copper peru": "/companies/southern-copper",
  "southern copper mexico": "/companies/southern-copper",

  /* ticker lookups */
  scco: "/companies/southern-copper",
  "scco stock": "/companies/southern-copper",
  "southern copper stock": "/companies/southern-copper",
  /* southern-copper */

  /* tokyo-electron */
  "tokyo-electron": "/companies/tokyo-electron",
  "tokyo electron": "/companies/tokyo-electron",
  tel: "/companies/tokyo-electron",
  "tokyo electron ltd": "/companies/tokyo-electron",
  "tokyo electron limited": "/companies/tokyo-electron",
  "tokyo electron japan": "/companies/tokyo-electron",
  "tokyo electron tokyo": "/companies/tokyo-electron",

  /* semiconductor equipment */
  "tokyo electron semiconductor": "/companies/tokyo-electron",
  "tokyo electron equipment": "/companies/tokyo-electron",
  "tokyo electron fab equipment": "/companies/tokyo-electron",
  "tokyo electron wafer equipment": "/companies/tokyo-electron",

  /* etching systems */
  "tokyo electron etch": "/companies/tokyo-electron",
  "tokyo electron etching": "/companies/tokyo-electron",
  "tel etch": "/companies/tokyo-electron",

  /* deposition systems */
  "tokyo electron deposition": "/companies/tokyo-electron",
  "tel deposition": "/companies/tokyo-electron",
  "tel pvd": "/companies/tokyo-electron",
  "tel cvd": "/companies/tokyo-electron",

  /* cleaning systems */
  "tokyo electron cleaning": "/companies/tokyo-electron",
  "tel cleaning": "/companies/tokyo-electron",

  /* flat panel display equipment */
  "tokyo electron fpd": "/companies/tokyo-electron",
  "tokyo electron display": "/companies/tokyo-electron",

  /* ticker lookups */
  "8035": "/companies/tokyo-electron",
  "8035 stock": "/companies/tokyo-electron",
  "tokyo electron stock": "/companies/tokyo-electron",
  /* tokyo-electron */

  /* cm-bank */
  "cm-bank": "/companies/cm-bank",
  "cm bank": "/companies/cm-bank",
  cmb: "/companies/cm-bank",
  "cmb china": "/companies/cm-bank",
  "china merchants bank": "/companies/cm-bank",
  "china merchants": "/companies/cm-bank",
  "cmb shenzhen": "/companies/cm-bank",
  "cmb guangdong": "/companies/cm-bank",

  /* retail + corporate banking */
  "cmb retail banking": "/companies/cm-bank",
  "cmb corporate banking": "/companies/cm-bank",
  "cmb banking": "/companies/cm-bank",
  "cmb bank services": "/companies/cm-bank",

  /* wealth management + credit cards */
  "cmb wealth": "/companies/cm-bank",
  "cmb wealth management": "/companies/cm-bank",
  "cmb credit card": "/companies/cm-bank",
  "cmb credit cards": "/companies/cm-bank",

  /* financial services */
  "cmb financial services": "/companies/cm-bank",
  "cmb finance": "/companies/cm-bank",

  /* ticker lookups */
  "3968": "/companies/cm-bank",
  "3968 stock": "/companies/cm-bank",
  "cmb stock": "/companies/cm-bank",
  "china merchants bank stock": "/companies/cm-bank",
  /* cm-bank */

  /* welltower */
  welltower: "/companies/welltower",
  "well tower": "/companies/welltower",
  "welltower inc": "/companies/welltower",
  "welltower corporation": "/companies/welltower",
  "welltower toledo": "/companies/welltower",
  "welltower ohio": "/companies/welltower",

  /* healthcare real estate */
  "welltower healthcare": "/companies/welltower",
  "welltower healthcare real estate": "/companies/welltower",
  "welltower medical": "/companies/welltower",
  "welltower medical office": "/companies/welltower",
  "welltower medical offices": "/companies/welltower",

  /* senior housing + post-acute */
  "welltower senior housing": "/companies/welltower",
  "welltower senior living": "/companies/welltower",
  "welltower assisted living": "/companies/welltower",
  "welltower post acute": "/companies/welltower",
  "welltower post-acute": "/companies/welltower",

  /* property investment */
  "welltower real estate": "/companies/welltower",
  "welltower reit": "/companies/welltower",
  "welltower property": "/companies/welltower",
  "welltower properties": "/companies/welltower",

  /* ticker lookups */
  well: "/companies/welltower",
  "well stock": "/companies/welltower",
  "welltower stock": "/companies/welltower",
  /* welltower */

  /* blackstone-group */
  "blackstone-group": "/companies/blackstone-group",
  "blackstone group": "/companies/blackstone-group",
  blackstone: "/companies/blackstone-group",
  "blackstone inc": "/companies/blackstone-group",
  "blackstone corporation": "/companies/blackstone-group",
  "blackstone nyc": "/companies/blackstone-group",
  "blackstone new york": "/companies/blackstone-group",

  /* private equity */
  "blackstone private equity": "/companies/blackstone-group",
  "blackstone pe": "/companies/blackstone-group",
  "blackstone buyout": "/companies/blackstone-group",

  /* real estate */
  "blackstone real estate": "/companies/blackstone-group",
  "blackstone reit": "/companies/blackstone-group",
  "blackstone property": "/companies/blackstone-group",

  /* credit + insurance */
  "blackstone credit": "/companies/blackstone-group",
  "blackstone insurance": "/companies/blackstone-group",
  "blackstone credit solutions": "/companies/blackstone-group",

  /* hedge fund solutions */
  "blackstone hedge fund": "/companies/blackstone-group",
  "blackstone hedge funds": "/companies/blackstone-group",
  "blackstone baas": "/companies/blackstone-group",

  /* infrastructure */
  "blackstone infrastructure": "/companies/blackstone-group",
  "blackstone infra": "/companies/blackstone-group",

  /* ticker lookups */
  bx: "/companies/blackstone-group",
  "bx stock": "/companies/blackstone-group",
  "blackstone stock": "/companies/blackstone-group",
  /* blackstone-group */

  /* zhongji-innolight */
  "zhongji-innolight": "/companies/zhongji-innolight",
  "zhongji innolight": "/companies/zhongji-innolight",
  innolight: "/companies/zhongji-innolight",
  "innolight china": "/companies/zhongji-innolight",
  "innolight suzhou": "/companies/zhongji-innolight",
  "zhongji innolight china": "/companies/zhongji-innolight",

  /* optical transceivers */
  "innolight transceivers": "/companies/zhongji-innolight",
  "innolight optical transceivers": "/companies/zhongji-innolight",
  "innolight optics": "/companies/zhongji-innolight",
  "innolight optical modules": "/companies/zhongji-innolight",

  /* data center + cloud */
  "innolight data center": "/companies/zhongji-innolight",
  "innolight datacenter": "/companies/zhongji-innolight",
  "innolight cloud": "/companies/zhongji-innolight",
  "innolight cloud infrastructure": "/companies/zhongji-innolight",

  /* telecom + networking */
  "innolight telecom": "/companies/zhongji-innolight",
  "innolight telecommunications": "/companies/zhongji-innolight",
  "innolight networking": "/companies/zhongji-innolight",
  "innolight ai networking": "/companies/zhongji-innolight",

  /* ticker lookups */
  "300308": "/companies/zhongji-innolight",
  "300308 stock": "/companies/zhongji-innolight",
  "innolight stock": "/companies/zhongji-innolight",
  /* zhongji-innolight */

  /* marvell-technology */
  "marvell-technology": "/companies/marvell-technology",
  "marvell technology": "/companies/marvell-technology",
  marvell: "/companies/marvell-technology",
  "marvell inc": "/companies/marvell-technology",
  "marvell semiconductor": "/companies/marvell-technology",
  "marvell santa clara": "/companies/marvell-technology",
  "marvell california": "/companies/marvell-technology",

  /* semiconductors + data infrastructure */
  "marvell semiconductors": "/companies/marvell-technology",
  "marvell chips": "/companies/marvell-technology",
  "marvell data infrastructure": "/companies/marvell-technology",
  "marvell data center": "/companies/marvell-technology",

  /* networking */
  "marvell networking": "/companies/marvell-technology",
  "marvell networking chips": "/companies/marvell-technology",
  "marvell ethernet": "/companies/marvell-technology",
  "marvell switch chips": "/companies/marvell-technology",

  /* storage controllers */
  "marvell storage": "/companies/marvell-technology",
  "marvell storage controllers": "/companies/marvell-technology",
  "marvell hdd controllers": "/companies/marvell-technology",
  "marvell ssd controllers": "/companies/marvell-technology",

  /* cloud + AI processors */
  "marvell cloud": "/companies/marvell-technology",
  "marvell ai": "/companies/marvell-technology",
  "marvell ai processors": "/companies/marvell-technology",
  "marvell cloud processors": "/companies/marvell-technology",

  /* ticker lookups */
  mrvl: "/companies/marvell-technology",
  "mrvl stock": "/companies/marvell-technology",
  "marvell stock": "/companies/marvell-technology",
  /* marvell-technology */

  /* ubs */
  ubs: "/companies/ubs",
  "ubs group": "/companies/ubs",
  "ubs ag": "/companies/ubs",
  "ubs bank": "/companies/ubs",
  "ubs zurich": "/companies/ubs",
  "ubs switzerland": "/companies/ubs",

  /* wealth management */
  "ubs wealth": "/companies/ubs",
  "ubs wealth management": "/companies/ubs",
  "ubs private wealth": "/companies/ubs",

  /* investment banking */
  "ubs investment banking": "/companies/ubs",
  "ubs ib": "/companies/ubs",
  "ubs capital markets": "/companies/ubs",

  /* asset management */
  "ubs asset management": "/companies/ubs",
  "ubs am": "/companies/ubs",

  /* personal banking */
  "ubs personal banking": "/companies/ubs",
  "ubs retail banking": "/companies/ubs",

  /* financial advisory */
  "ubs advisory": "/companies/ubs",
  "ubs financial advisory": "/companies/ubs",

  /* ticker lookups */
  "ubs stock": "/companies/ubs",
  "ubs ticker": "/companies/ubs",
  /* ubs */
  /* abbott-laboratories */
  "abbott-laboratories": "/companies/abbott-laboratories",
  "abbott laboratories": "/companies/abbott-laboratories",
  abbott: "/companies/abbott-laboratories",
  "abbott inc": "/companies/abbott-laboratories",
  "abbott corporation": "/companies/abbott-laboratories",
  "abbott abbott park": "/companies/abbott-laboratories",
  "abbott illinois": "/companies/abbott-laboratories",

  /* medical devices */
  "abbott medical": "/companies/abbott-laboratories",
  "abbott medical devices": "/companies/abbott-laboratories",
  "abbott devices": "/companies/abbott-laboratories",

  /* diagnostics */
  "abbott diagnostics": "/companies/abbott-laboratories",
  "abbott diagnostic": "/companies/abbott-laboratories",
  "abbott testing": "/companies/abbott-laboratories",

  /* nutrition */
  "abbott nutrition": "/companies/abbott-laboratories",
  "abbott nutritional products": "/companies/abbott-laboratories",
  "abbott ensure": "/companies/abbott-laboratories",
  "abbott pedialyte": "/companies/abbott-laboratories",

  /* branded generics */
  "abbott generics": "/companies/abbott-laboratories",
  "abbott branded generics": "/companies/abbott-laboratories",

  /* healthcare tech */
  "abbott healthcare": "/companies/abbott-laboratories",
  "abbott health tech": "/companies/abbott-laboratories",

  /* ticker lookups */
  abt: "/companies/abbott-laboratories",
  "abt stock": "/companies/abbott-laboratories",
  "abbott stock": "/companies/abbott-laboratories",
  /* abbott-laboratories */
  /* fast-retailing */
  "fast-retailing": "/companies/fast-retailing",
  "fast retailing": "/companies/fast-retailing",
  "fast retailing co": "/companies/fast-retailing",
  "fast retailing company": "/companies/fast-retailing",
  "fast retailing japan": "/companies/fast-retailing",
  "fast retailing yamaguchi": "/companies/fast-retailing",

  /* uniqlo */
  uniqlo: "/companies/fast-retailing",
  "uniqlo japan": "/companies/fast-retailing",
  "uniqlo global": "/companies/fast-retailing",
  "uniqlo clothing": "/companies/fast-retailing",
  "uniqlo apparel": "/companies/fast-retailing",

  /* fashion + apparel */
  "fast retailing apparel": "/companies/fast-retailing",
  "fast retailing clothing": "/companies/fast-retailing",
  "fast retailing fashion": "/companies/fast-retailing",
  "fast retailing outerwear": "/companies/fast-retailing",

  /* global  */
  "fast retailing brands": "/companies/fast-retailing",
  "fast retailing global": "/companies/fast-retailing",

  /* ticker lookups */
  "9983": "/companies/fast-retailing",
  "9983 stock": "/companies/fast-retailing",
  "fast retailing stock": "/companies/fast-retailing",
  /* fast-retailing */
  /* china-shenhua-energy */
  "china-shenhua-energy": "/companies/china-shenhua-energy",
  "china shenhua energy": "/companies/china-shenhua-energy",
  "china shenhua": "/companies/china-shenhua-energy",
  "shenhua energy": "/companies/china-shenhua-energy",
  "shenhua group": "/companies/china-shenhua-energy",
  "shenhua beijing": "/companies/china-shenhua-energy",
  "shenhua china": "/companies/china-shenhua-energy",

  /* coal mining */
  "shenhua coal": "/companies/china-shenhua-energy",
  "shenhua coal mining": "/companies/china-shenhua-energy",
  "china shenhua coal": "/companies/china-shenhua-energy",

  /* power generation */
  "shenhua power": "/companies/china-shenhua-energy",
  "shenhua electricity": "/companies/china-shenhua-energy",
  "shenhua electric power": "/companies/china-shenhua-energy",

  /* railway transportation */
  "shenhua railway": "/companies/china-shenhua-energy",
  "shenhua rail": "/companies/china-shenhua-energy",
  "shenhua transport": "/companies/china-shenhua-energy",

  /* coal chemicals */
  "shenhua chemicals": "/companies/china-shenhua-energy",
  "shenhua coal chemicals": "/companies/china-shenhua-energy",

  /* integrated energy */
  "shenhua energy services": "/companies/china-shenhua-energy",
  "shenhua integrated energy": "/companies/china-shenhua-energy",

  /* ticker lookups */
  "601088": "/companies/china-shenhua-energy",
  "601088 stock": "/companies/china-shenhua-energy",
  "shenhua stock": "/companies/china-shenhua-energy",
  /* china-shenhua-energy */

  /* safran */
  safran: "/companies/safran",
  "safran group": "/companies/safran",
  "safran sa": "/companies/safran",
  "safran france": "/companies/safran",
  "safran paris": "/companies/safran",

  /* aircraft engines */
  "safran engines": "/companies/safran",
  "safran aircraft engines": "/companies/safran",
  "safran propulsion": "/companies/safran",
  "safran propulsion systems": "/companies/safran",

  /* aerospace equipment */
  "safran aerospace": "/companies/safran",
  "safran aerospace equipment": "/companies/safran",
  "safran avionics": "/companies/safran",

  /* defense systems */
  "safran defense": "/companies/safran",
  "safran defense systems": "/companies/safran",
  "safran military": "/companies/safran",

  /* high‑tech components */
  "safran components": "/companies/safran",
  "safran aerospace components": "/companies/safran",

  /* ticker lookups */
  saf: "/companies/safran",
  "saf stock": "/companies/safran",
  "safran stock": "/companies/safran",
  /* safran */

  /* conocophillips */
  conocophillips: "/companies/conocophillips",
  "conoco phillips": "/companies/conocophillips",
  "conocophillips inc": "/companies/conocophillips",
  "conocophillips corporation": "/companies/conocophillips",
  "conocophillips houston": "/companies/conocophillips",
  "conocophillips texas": "/companies/conocophillips",

  /* crude oil */
  "conocophillips oil": "/companies/conocophillips",
  "conocophillips crude oil": "/companies/conocophillips",
  "conoco oil": "/companies/conocophillips",

  /* natural gas */
  "conocophillips gas": "/companies/conocophillips",
  "conocophillips natural gas": "/companies/conocophillips",
  "conoco gas": "/companies/conocophillips",

  /* lng */
  "conocophillips lng": "/companies/conocophillips",
  "conoco lng": "/companies/conocophillips",

  /* exploration + production */
  "conocophillips exploration": "/companies/conocophillips",
  "conocophillips energy exploration": "/companies/conocophillips",
  "conocophillips upstream": "/companies/conocophillips",

  /* transportation */
  "conocophillips transportation": "/companies/conocophillips",
  "conocophillips pipelines": "/companies/conocophillips",

  /* ticker lookups */
  cop: "/companies/conocophillips",
  "cop stock": "/companies/conocophillips",
  "conocophillips stock": "/companies/conocophillips",
  /* conocophillips */

  /* hitachi */
  hitachi: "/companies/hitachi",
  "hitachi ltd": "/companies/hitachi",
  "hitachi japan": "/companies/hitachi",
  "hitachi tokyo": "/companies/hitachi",
  "hitachi corporation": "/companies/hitachi",

  /* information technology */
  "hitachi it": "/companies/hitachi",
  "hitachi information technology": "/companies/hitachi",
  "hitachi digital systems": "/companies/hitachi",

  /* industrial equipment */
  "hitachi industrial": "/companies/hitachi",
  "hitachi industrial equipment": "/companies/hitachi",
  "hitachi machinery": "/companies/hitachi",

  /* mobility + railway */
  "hitachi rail": "/companies/hitachi",
  "hitachi railway": "/companies/hitachi",
  "hitachi mobility": "/companies/hitachi",

  /* energy systems */
  "hitachi energy": "/companies/hitachi",
  "hitachi energy solutions": "/companies/hitachi",
  "hitachi power systems": "/companies/hitachi",

  /* infrastructure */
  "hitachi infrastructure": "/companies/hitachi",
  "hitachi infrastructure systems": "/companies/hitachi",

  /* ticker lookups */
  "6501": "/companies/hitachi",
  "6501 stock": "/companies/hitachi",
  "hitachi stock": "/companies/hitachi",
  /* hitachi */

  /* rolls-royce-holdings */
  "rolls-royce-holdings": "/companies/rolls-royce-holdings",
  "rolls royce holdings": "/companies/rolls-royce-holdings",
  "rolls-royce": "/companies/rolls-royce-holdings",
  "rolls royce": "/companies/rolls-royce-holdings",
  "rolls royce group": "/companies/rolls-royce-holdings",
  "rolls royce uk": "/companies/rolls-royce-holdings",
  "rolls royce london": "/companies/rolls-royce-holdings",

  /* aircraft engines */
  "rolls royce engines": "/companies/rolls-royce-holdings",
  "rolls royce aircraft engines": "/companies/rolls-royce-holdings",
  "rolls royce jet engines": "/companies/rolls-royce-holdings",

  /* jet propulsion */
  "rolls royce propulsion": "/companies/rolls-royce-holdings",
  "rolls royce jet propulsion": "/companies/rolls-royce-holdings",

  /* marine systems */
  "rolls royce marine": "/companies/rolls-royce-holdings",
  "rolls royce marine propulsion": "/companies/rolls-royce-holdings",

  /* defense systems */
  "rolls royce defense": "/companies/rolls-royce-holdings",
  "rolls royce defence": "/companies/rolls-royce-holdings",
  "rolls royce military": "/companies/rolls-royce-holdings",

  /* energy + power generation */
  "rolls royce energy": "/companies/rolls-royce-holdings",
  "rolls royce power systems": "/companies/rolls-royce-holdings",

  /* ticker lookups */
  rr: "/companies/rolls-royce-holdings",
  "rr stock": "/companies/rolls-royce-holdings",
  "rolls royce stock": "/companies/rolls-royce-holdings",
  /* rolls-royce-holdings */

  /* sumitomo-mitsui-financial-group */
  "sumitomo-mitsui-financial-group":
    "/companies/sumitomo-mitsui-financial-group",
  "sumitomo mitsui financial group":
    "/companies/sumitomo-mitsui-financial-group",
  smfg: "/companies/sumitomo-mitsui-financial-group",
  "smfg japan": "/companies/sumitomo-mitsui-financial-group",
  "smfg tokyo": "/companies/sumitomo-mitsui-financial-group",

  /* smbc (core banking subsidiary) */
  smbc: "/companies/sumitomo-mitsui-financial-group",
  "smbc bank": "/companies/sumitomo-mitsui-financial-group",
  "sumitomo mitsui banking corporation":
    "/companies/sumitomo-mitsui-financial-group",

  /* commercial banking */
  "smfg commercial banking": "/companies/sumitomo-mitsui-financial-group",
  "smbc commercial banking": "/companies/sumitomo-mitsui-financial-group",

  /* corporate banking */
  "smfg corporate banking": "/companies/sumitomo-mitsui-financial-group",
  "smbc corporate banking": "/companies/sumitomo-mitsui-financial-group",

  /* investment banking */
  "smfg investment banking": "/companies/sumitomo-mitsui-financial-group",
  "smbc investment banking": "/companies/sumitomo-mitsui-financial-group",

  /* asset management */
  "smfg asset management": "/companies/sumitomo-mitsui-financial-group",
  "smbc asset management": "/companies/sumitomo-mitsui-financial-group",

  /* financial services */
  "smfg financial services": "/companies/sumitomo-mitsui-financial-group",
  "smbc financial services": "/companies/sumitomo-mitsui-financial-group",

  /* ticker lookups */
  "8316": "/companies/sumitomo-mitsui-financial-group",
  "8316 stock": "/companies/sumitomo-mitsui-financial-group",
  "smfg stock": "/companies/sumitomo-mitsui-financial-group",
  /* sumitomo-mitsui-financial-group */

  /* advantest */
  advantest: "/companies/advantest",
  "advantest corp": "/companies/advantest",
  "advantest corporation": "/companies/advantest",
  "advantest japan": "/companies/advantest",
  "advantest tokyo": "/companies/advantest",

  /* semiconductor test systems */
  "advantest semiconductor": "/companies/advantest",
  "advantest semiconductor test": "/companies/advantest",
  "advantest test systems": "/companies/advantest",

  /* automated test equipment (ATE) */
  "advantest ate": "/companies/advantest",
  "advantest automated test": "/companies/advantest",
  "advantest automated test equipment": "/companies/advantest",

  /* memory test */
  "advantest memory test": "/companies/advantest",
  "advantest memory systems": "/companies/advantest",

  /* soc test */
  "advantest soc": "/companies/advantest",
  "advantest soc test": "/companies/advantest",
  "advantest soc solutions": "/companies/advantest",

  /* measurement instruments */
  "advantest measurement": "/companies/advantest",
  "advantest electronic measurement": "/companies/advantest",

  /* ticker lookups */
  "6857": "/companies/advantest",
  "6857 stock": "/companies/advantest",
  "advantest stock": "/companies/advantest",
  /* advantest */

  /* prologis */
  prologis: "/companies/prologis",
  "prologis inc": "/companies/prologis",
  "prologis reit": "/companies/prologis",
  "prologis san francisco": "/companies/prologis",
  "prologis california": "/companies/prologis",

  /* logistics real estate */
  "prologis logistics": "/companies/prologis",
  "prologis logistics real estate": "/companies/prologis",
  "prologis industrial real estate": "/companies/prologis",

  /* warehouses */
  "prologis warehouse": "/companies/prologis",
  "prologis warehouses": "/companies/prologis",
  "prologis storage": "/companies/prologis",

  /* distribution centers */
  "prologis distribution": "/companies/prologis",
  "prologis distribution center": "/companies/prologis",
  "prologis dc": "/companies/prologis",

  /* industrial development */
  "prologis industrial": "/companies/prologis",
  "prologis industrial development": "/companies/prologis",
  "prologis industrial property": "/companies/prologis",

  /* supply chain infrastructure */
  "prologis supply chain": "/companies/prologis",
  "prologis supply chain infrastructure": "/companies/prologis",

  /* ticker lookups */
  pld: "/companies/prologis",
  "pld stock": "/companies/prologis",
  "prologis stock": "/companies/prologis",
  /* prologis */

  /* zijin-mining */
  "zijin-mining": "/companies/zijin-mining",
  "zijin mining": "/companies/zijin-mining",
  zijin: "/companies/zijin-mining",
  "zijin mining group": "/companies/zijin-mining",
  "zijin china": "/companies/zijin-mining",
  "zijin longyan": "/companies/zijin-mining",

  /* gold mining */
  "zijin gold": "/companies/zijin-mining",
  "zijin gold mining": "/companies/zijin-mining",

  /* copper mining */
  "zijin copper": "/companies/zijin-mining",
  "zijin copper mining": "/companies/zijin-mining",

  /* zinc mining */
  "zijin zinc": "/companies/zijin-mining",
  "zijin zinc mining": "/companies/zijin-mining",

  /* silver production */
  "zijin silver": "/companies/zijin-mining",
  "zijin silver production": "/companies/zijin-mining",

  /* exploration + smelting */
  "zijin exploration": "/companies/zijin-mining",
  "zijin mineral exploration": "/companies/zijin-mining",
  "zijin smelting": "/companies/zijin-mining",
  "zijin mineral smelting": "/companies/zijin-mining",

  /* ticker lookups */
  "601899": "/companies/zijin-mining",
  "601899 stock": "/companies/zijin-mining",
  "zijin stock": "/companies/zijin-mining",
  /* zijin-mining */

  /* byd */
  byd: "/companies/byd",
  "byd auto": "/companies/byd",
  "byd company": "/companies/byd",
  "byd china": "/companies/byd",
  "byd shenzhen": "/companies/byd",

  /* electric vehicles */
  "byd ev": "/companies/byd",
  "byd electric vehicle": "/companies/byd",
  "byd electric cars": "/companies/byd",
  "byd passenger ev": "/companies/byd",

  /* commercial vehicles */
  "byd bus": "/companies/byd",
  "byd buses": "/companies/byd",
  "byd truck": "/companies/byd",
  "byd trucks": "/companies/byd",
  "byd commercial vehicles": "/companies/byd",

  /* batteries */
  "byd battery": "/companies/byd",
  "byd batteries": "/companies/byd",
  "byd rechargeable batteries": "/companies/byd",
  "byd blade battery": "/companies/byd",

  /* energy storage */
  "byd energy": "/companies/byd",
  "byd energy storage": "/companies/byd",
  "byd bess": "/companies/byd",

  /* renewable energy */
  "byd renewable": "/companies/byd",
  "byd renewable energy": "/companies/byd",

  /* ticker lookups */
  "002594": "/companies/byd",
  "002594 stock": "/companies/byd",
  "byd stock": "/companies/byd",
  /* byd */

  /* dbs-group */
  "dbs-group": "/companies/dbs-group",
  "dbs group": "/companies/dbs-group",
  dbs: "/companies/dbs-group",
  "dbs singapore": "/companies/dbs-group",
  "dbs bank": "/companies/dbs-group",
  "dbs asia": "/companies/dbs-group",

  /* consumer banking */
  "dbs consumer banking": "/companies/dbs-group",
  "dbs retail banking": "/companies/dbs-group",

  /* corporate banking */
  "dbs corporate banking": "/companies/dbs-group",
  "dbs business banking": "/companies/dbs-group",

  /* investment banking */
  "dbs investment banking": "/companies/dbs-group",
  "dbs capital markets": "/companies/dbs-group",

  /* wealth management */
  "dbs wealth": "/companies/dbs-group",
  "dbs wealth management": "/companies/dbs-group",
  "dbs private bank": "/companies/dbs-group",

  /* treasury + markets */
  "dbs treasury": "/companies/dbs-group",
  "dbs treasury services": "/companies/dbs-group",
  "dbs markets": "/companies/dbs-group",

  /* ticker lookups */
  d05: "/companies/dbs-group",
  "d05 stock": "/companies/dbs-group",
  "dbs stock": "/companies/dbs-group",
  /* dbs-group */

  /* petrobras */
  petrobras: "/companies/petrobras",
  "petrobras sa": "/companies/petrobras",
  "petroleo brasileiro": "/companies/petrobras",
  "petroleo brasileiro sa": "/companies/petrobras",
  "petrobras brazil": "/companies/petrobras",
  "petrobras rio": "/companies/petrobras",

  /* oil exploration + production */
  "petrobras oil": "/companies/petrobras",
  "petrobras crude oil": "/companies/petrobras",
  "petrobras offshore": "/companies/petrobras",
  "petrobras deepwater": "/companies/petrobras",

  /* natural gas */
  "petrobras gas": "/companies/petrobras",
  "petrobras natural gas": "/companies/petrobras",

  /* refining */
  "petrobras refining": "/companies/petrobras",
  "petrobras refinery": "/companies/petrobras",

  /* fuel distribution */
  "petrobras fuel": "/companies/petrobras",
  "petrobras fuel distribution": "/companies/petrobras",

  /* petrochemicals */
  "petrobras petrochemicals": "/companies/petrobras",
  "petrobras chemicals": "/companies/petrobras",

  /* ticker lookups */
  pbr: "/companies/petrobras",
  "pbr stock": "/companies/petrobras",
  "petrobras stock": "/companies/petrobras",
  /* petrobras */

  /* vertiv-holdings */
  "vertiv-holdings": "/companies/vertiv-holdings",
  "vertiv holdings": "/companies/vertiv-holdings",
  vertiv: "/companies/vertiv-holdings",
  "vertiv ohio": "/companies/vertiv-holdings",
  "vertiv westerville": "/companies/vertiv-holdings",

  /* data center infrastructure */
  "vertiv data center": "/companies/vertiv-holdings",
  "vertiv data centers": "/companies/vertiv-holdings",
  "vertiv dc infrastructure": "/companies/vertiv-holdings",

  /* power systems */
  "vertiv power": "/companies/vertiv-holdings",
  "vertiv power systems": "/companies/vertiv-holdings",
  "vertiv ups": "/companies/vertiv-holdings",
  "vertiv uninterruptible power": "/companies/vertiv-holdings",

  /* thermal management */
  "vertiv cooling": "/companies/vertiv-holdings",
  "vertiv thermal": "/companies/vertiv-holdings",
  "vertiv thermal management": "/companies/vertiv-holdings",

  /* it infrastructure */
  "vertiv it": "/companies/vertiv-holdings",
  "vertiv it infrastructure": "/companies/vertiv-holdings",
  "vertiv racks": "/companies/vertiv-holdings",

  /* critical digital infrastructure */
  "vertiv critical infrastructure": "/companies/vertiv-holdings",
  "vertiv digital infrastructure": "/companies/vertiv-holdings",

  /* ticker lookups */
  vrt: "/companies/vertiv-holdings",
  "vrt stock": "/companies/vertiv-holdings",
  "vertiv stock": "/companies/vertiv-holdings",
  /* vertiv-holdings */
  /* booking-holdings */
  "booking-holdings": "/companies/booking-holdings",
  "booking holdings": "/companies/booking-holdings",
  "booking holdings inc": "/companies/booking-holdings",
  "booking holdings company": "/companies/booking-holdings",
  "booking norwalk": "/companies/booking-holdings",
  "booking connecticut": "/companies/booking-holdings",

  /* booking.com */
  booking: "/companies/booking-holdings",
  "booking.com": "/companies/booking-holdings",
  "booking com": "/companies/booking-holdings",

  /* priceline */
  priceline: "/companies/booking-holdings",
  "priceline.com": "/companies/booking-holdings",
  "priceline travel": "/companies/booking-holdings",

  /* agoda */
  agoda: "/companies/booking-holdings",
  "agoda.com": "/companies/booking-holdings",

  /* kayak */
  kayak: "/companies/booking-holdings",
  "kayak.com": "/companies/booking-holdings",
  "kayak travel": "/companies/booking-holdings",

  /* opentable */
  opentable: "/companies/booking-holdings",
  "open table": "/companies/booking-holdings",
  "opentable reservations": "/companies/booking-holdings",

  /* travel platforms */
  "booking travel": "/companies/booking-holdings",
  "booking travel platforms": "/companies/booking-holdings",
  "booking hotel": "/companies/booking-holdings",
  "booking hotels": "/companies/booking-holdings",
  "booking flights": "/companies/booking-holdings",
  "booking vacation rentals": "/companies/booking-holdings",

  /* metasearch */
  "booking metasearch": "/companies/booking-holdings",
  "booking travel search": "/companies/booking-holdings",

  /* restaurant reservations */
  "booking restaurants": "/companies/booking-holdings",
  "booking dining": "/companies/booking-holdings",

  /* ticker lookups */
  bkng: "/companies/booking-holdings",
  "bkng stock": "/companies/booking-holdings",
  "booking holdings stock": "/companies/booking-holdings",
  /* booking-holdings */
  /* booking-com */
  "booking-com": "/companies/booking-com",
  "booking dot com": "/companies/booking-com",
  "booking amsterdam": "/companies/booking-com",
  "booking netherlands": "/companies/booking-com",

  /* booking holdings relationship */
  "booking holdings booking.com": "/companies/booking-com",
  "booking holdings booking": "/companies/booking-com",

  /* hotel reservations */
  "booking accommodation": "/companies/booking-com",

  /* vacation rentals */
  "booking apartments": "/companies/booking-com",
  "booking stays": "/companies/booking-com",

  /* flights */
  "booking flight": "/companies/booking-com",

  /* car rentals */
  "booking car rentals": "/companies/booking-com",
  "booking cars": "/companies/booking-com",

  /* travel experiences */
  "booking experiences": "/companies/booking-com",
  "booking activities": "/companies/booking-com",
  "booking tours": "/companies/booking-com",

  /* ticker lookups (inherits BKNG) */
  "booking.com stock": "/companies/booking-com",
  /* booking-com */

  /* hdfc-bank */
  "hdfc-bank": "/companies/hdfc-bank",
  "hdfc bank": "/companies/hdfc-bank",
  hdfc: "/companies/hdfc-bank",
  "hdfc bank india": "/companies/hdfc-bank",
  "hdfc mumbai": "/companies/hdfc-bank",

  /* retail banking */
  "hdfc retail": "/companies/hdfc-bank",
  "hdfc retail banking": "/companies/hdfc-bank",

  /* corporate banking */
  "hdfc corporate": "/companies/hdfc-bank",
  "hdfc corporate banking": "/companies/hdfc-bank",

  /* credit cards */
  "hdfc credit card": "/companies/hdfc-bank",
  "hdfc credit cards": "/companies/hdfc-bank",

  /* loans + mortgages */
  "hdfc loans": "/companies/hdfc-bank",
  "hdfc loan": "/companies/hdfc-bank",
  "hdfc mortgage": "/companies/hdfc-bank",
  "hdfc mortgages": "/companies/hdfc-bank",

  /* digital banking */
  "hdfc digital": "/companies/hdfc-bank",
  "hdfc digital banking": "/companies/hdfc-bank",
  "hdfc netbanking": "/companies/hdfc-bank",
  "hdfc mobile banking": "/companies/hdfc-bank",

  /* ticker lookups */
  hdb: "/companies/hdfc-bank",
  "hdb stock": "/companies/hdfc-bank",
  "hdfc bank stock": "/companies/hdfc-bank",
  /* hdfc-bank */
  /* keyence */
  keyence: "/companies/keyence",
  "keyence corp": "/companies/keyence",
  "keyence corporation": "/companies/keyence",
  "keyence japan": "/companies/keyence",
  "keyence osaka": "/companies/keyence",

  /* industrial sensors */
  "keyence sensors": "/companies/keyence",
  "keyence industrial sensors": "/companies/keyence",
  "keyence proximity sensors": "/companies/keyence",
  "keyence photoelectric sensors": "/companies/keyence",

  /* machine vision */
  "keyence vision": "/companies/keyence",
  "keyence machine vision": "/companies/keyence",
  "keyence vision systems": "/companies/keyence",
  "keyence cameras": "/companies/keyence",

  /* measurement instruments */
  "keyence measurement": "/companies/keyence",
  "keyence measurement instruments": "/companies/keyence",
  "keyence laser measurement": "/companies/keyence",
  "keyence metrology": "/companies/keyence",

  /* laser markers */
  "keyence laser": "/companies/keyence",
  "keyence laser markers": "/companies/keyence",
  "keyence marking systems": "/companies/keyence",

  /* factory automation */
  "keyence automation": "/companies/keyence",
  "keyence factory automation": "/companies/keyence",
  "keyence fa": "/companies/keyence",

  /* ticker lookups */
  "6861": "/companies/keyence",
  "6861 stock": "/companies/keyence",
  "keyence stock": "/companies/keyence",
  /* keyence */

  /* british-american-tobacco */
  "british-american-tobacco": "/companies/british-american-tobacco",
  "british american tobacco": "/companies/british-american-tobacco",
  bat: "/companies/british-american-tobacco",
  "bat plc": "/companies/british-american-tobacco",
  "bat london": "/companies/british-american-tobacco",
  "bat uk": "/companies/british-american-tobacco",

  /* cigarettes */
  "bat cigarettes": "/companies/british-american-tobacco",
  "british american tobacco cigarettes": "/companies/british-american-tobacco",

  /* vaping products */
  "bat vape": "/companies/british-american-tobacco",
  "bat vaping": "/companies/british-american-tobacco",
  "bat vuse": "/companies/british-american-tobacco",

  /* heated tobacco */
  "bat heated tobacco": "/companies/british-american-tobacco",
  "bat glo": "/companies/british-american-tobacco",

  /* oral nicotine */
  "bat oral nicotine": "/companies/british-american-tobacco",
  "bat velo": "/companies/british-american-tobacco",

  /* reduced-risk products */
  "bat reduced risk": "/companies/british-american-tobacco",
  "bat rrps": "/companies/british-american-tobacco",
  "bat next gen products": "/companies/british-american-tobacco",

  /* ticker lookups */
  bti: "/companies/british-american-tobacco",
  "bti stock": "/companies/british-american-tobacco",
  "british american tobacco stock": "/companies/british-american-tobacco",
  /* british-american-tobacco */

  /* newmont */
  newmont: "/companies/newmont",
  "newmont corp": "/companies/newmont",
  "newmont corporation": "/companies/newmont",
  "newmont mining": "/companies/newmont",
  "newmont denver": "/companies/newmont",
  "newmont colorado": "/companies/newmont",

  /* gold mining */
  "newmont gold": "/companies/newmont",
  "newmont gold mining": "/companies/newmont",
  "newmont gold production": "/companies/newmont",

  /* copper production */
  "newmont copper": "/companies/newmont",
  "newmont copper mining": "/companies/newmont",

  /* mineral exploration */
  "newmont exploration": "/companies/newmont",
  "newmont mineral exploration": "/companies/newmont",

  /* mining operations */
  "newmont operations": "/companies/newmont",
  "newmont mines": "/companies/newmont",
  "newmont mining operations": "/companies/newmont",

  /* precious metals */
  "newmont precious metals": "/companies/newmont",
  "newmont metals": "/companies/newmont",

  /* ticker lookups */
  nem: "/companies/newmont",
  "nem stock": "/companies/newmont",
  "newmont stock": "/companies/newmont",
  /* newmont */

  /* sp-global */
  "sp-global": "/companies/sp-global",
  "s&p global": "/companies/sp-global",
  spglobal: "/companies/sp-global",
  "s and p global": "/companies/sp-global",
  "s&p": "/companies/sp-global",
  "s&p nyc": "/companies/sp-global",
  "s&p new york": "/companies/sp-global",

  /* credit ratings */
  "s&p ratings": "/companies/sp-global",
  "spglobal ratings": "/companies/sp-global",
  "s&p credit ratings": "/companies/sp-global",

  /* financial benchmarks */
  "s&p benchmarks": "/companies/sp-global",
  "spglobal benchmarks": "/companies/sp-global",

  /* market indices */
  "s&p indices": "/companies/sp-global",
  "s&p index": "/companies/sp-global",
  "s&p 500": "/companies/sp-global",
  "spglobal indices": "/companies/sp-global",

  /* data analytics */
  "s&p analytics": "/companies/sp-global",
  "spglobal analytics": "/companies/sp-global",
  "s&p data": "/companies/sp-global",

  /* risk intelligence */
  "s&p risk": "/companies/sp-global",
  "spglobal risk": "/companies/sp-global",
  "s&p risk intelligence": "/companies/sp-global",

  /* ticker lookups */
  spgi: "/companies/sp-global",
  "spgi stock": "/companies/sp-global",
  "s&p global stock": "/companies/sp-global",
  /* sp-global */

  /* banco-bilbao-vizcaya-argentaria */
  "banco-bilbao-vizcaya-argentaria":
    "/companies/banco-bilbao-vizcaya-argentaria",
  "banco bilbao vizcaya argentaria":
    "/companies/banco-bilbao-vizcaya-argentaria",
  bbva: "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva bank": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva spain": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva madrid": "/companies/banco-bilbao-vizcaya-argentaria",

  /* retail banking */
  "bbva retail": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva retail banking": "/companies/banco-bilbao-vizcaya-argentaria",

  /* corporate banking */
  "bbva corporate": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva corporate banking": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva business banking": "/companies/banco-bilbao-vizcaya-argentaria",

  /* investment banking */
  "bbva investment": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva investment banking": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva capital markets": "/companies/banco-bilbao-vizcaya-argentaria",

  /* digital banking */
  "bbva digital": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva digital banking": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva online banking": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva mobile banking": "/companies/banco-bilbao-vizcaya-argentaria",

  /* asset management */
  "bbva asset management": "/companies/banco-bilbao-vizcaya-argentaria",
  "bbva am": "/companies/banco-bilbao-vizcaya-argentaria",

  /* ticker lookups */
  "bbva stock": "/companies/banco-bilbao-vizcaya-argentaria",
  /* banco-bilbao-vizcaya-argentaria */
  /* chubb */
  chubb: "/companies/chubb",
  "chubb insurance": "/companies/chubb",
  "chubb ltd": "/companies/chubb",
  "chubb zurich": "/companies/chubb",
  "chubb switzerland": "/companies/chubb",

  /* property insurance */
  "chubb property": "/companies/chubb",
  "chubb property insurance": "/companies/chubb",

  /* casualty insurance */
  "chubb casualty": "/companies/chubb",
  "chubb casualty insurance": "/companies/chubb",

  /* life insurance */
  "chubb life": "/companies/chubb",
  "chubb life insurance": "/companies/chubb",

  /* reinsurance */
  "chubb reinsurance": "/companies/chubb",
  "chubb re": "/companies/chubb",

  /* commercial risk */
  "chubb commercial": "/companies/chubb",
  "chubb commercial insurance": "/companies/chubb",
  "chubb business insurance": "/companies/chubb",

  /* ticker lookups */
  cb: "/companies/chubb",
  "cb stock": "/companies/chubb",
  "chubb stock": "/companies/chubb",
  /* chubb */

  /* investor-ab */
  "investor-ab": "/companies/investor-ab",
  "investor ab": "/companies/investor-ab",
  investor: "/companies/investor-ab",
  "investor sweden": "/companies/investor-ab",
  "investor stockholm": "/companies/investor-ab",

  /* investment management */
  "investor investment": "/companies/investor-ab",
  "investor investment management": "/companies/investor-ab",
  "investor asset management": "/companies/investor-ab",

  /* private equity */
  "investor private equity": "/companies/investor-ab",
  "investor pe": "/companies/investor-ab",

  /* industrial holdings */
  "investor industrial": "/companies/investor-ab",
  "investor industrial holdings": "/companies/investor-ab",

  /* healthcare investments */
  "investor healthcare": "/companies/investor-ab",
  "investor healthcare investments": "/companies/investor-ab",

  /* financial asset management */
  "investor financial": "/companies/investor-ab",
  "investor financial services": "/companies/investor-ab",

  /* ticker lookups */
  "inve-b": "/companies/investor-ab",
  "inve b": "/companies/investor-ab",
  "inve-b stock": "/companies/investor-ab",
  "investor ab stock": "/companies/investor-ab",
  /* investor-ab */
  /* danaher */
  danaher: "/companies/danaher",
  "danaher corp": "/companies/danaher",
  "danaher corporation": "/companies/danaher",
  "danaher dc": "/companies/danaher",
  "danaher washington": "/companies/danaher",

  /* biotechnology */
  "danaher biotech": "/companies/danaher",
  "danaher biotechnology": "/companies/danaher",

  /* life sciences */
  "danaher life sciences": "/companies/danaher",
  "danaher life science": "/companies/danaher",
  "danaher ls": "/companies/danaher",

  /* diagnostics */
  "danaher diagnostics": "/companies/danaher",
  "danaher diagnostic technologies": "/companies/danaher",

  /* environmental + applied solutions */
  "danaher environmental": "/companies/danaher",
  "danaher environmental solutions": "/companies/danaher",
  "danaher applied solutions": "/companies/danaher",

  /* healthcare technologies */
  "danaher healthcare": "/companies/danaher",
  "danaher medical": "/companies/danaher",
  "danaher health tech": "/companies/danaher",

  /* ticker lookups */
  dhr: "/companies/danaher",
  "dhr stock": "/companies/danaher",
  "danaher stock": "/companies/danaher",
  /* danaher */

  /* mitsubishi-corporation */
  "mitsubishi-corporation": "/companies/mitsubishi-corporation",
  "mitsubishi corporation": "/companies/mitsubishi-corporation",
  "mitsubishi corp": "/companies/mitsubishi-corporation",
  "mitsubishi tokyo": "/companies/mitsubishi-corporation",
  "mitsubishi japan": "/companies/mitsubishi-corporation",

  /* trading & investment conglomerate */
  "mitsubishi trading": "/companies/mitsubishi-corporation",
  "mitsubishi trading company": "/companies/mitsubishi-corporation",
  "mitsubishi sogo shosha": "/companies/mitsubishi-corporation",

  /* energy & natural resources */
  "mitsubishi energy": "/companies/mitsubishi-corporation",
  "mitsubishi natural resources": "/companies/mitsubishi-corporation",
  "mitsubishi oil gas": "/companies/mitsubishi-corporation",

  /* industrial materials */
  "mitsubishi industrial": "/companies/mitsubishi-corporation",
  "mitsubishi industrial materials": "/companies/mitsubishi-corporation",

  /* automotive & mobility */
  "mitsubishi automotive": "/companies/mitsubishi-corporation",
  "mitsubishi mobility": "/companies/mitsubishi-corporation",

  /* infrastructure */
  "mitsubishi infrastructure": "/companies/mitsubishi-corporation",
  "mitsubishi infrastructure projects": "/companies/mitsubishi-corporation",

  /* food & consumer products */
  "mitsubishi food": "/companies/mitsubishi-corporation",
  "mitsubishi consumer products": "/companies/mitsubishi-corporation",

  /* ticker lookups */
  "8058": "/companies/mitsubishi-corporation",
  "8058 stock": "/companies/mitsubishi-corporation",
  "mitsubishi corporation stock": "/companies/mitsubishi-corporation",
  /* mitsubishi-corporation */

  /* compagnie-financiere-richemont */
  "compagnie-financiere-richemont": "/companies/compagnie-financiere-richemont",
  "compagnie financiere richemont": "/companies/compagnie-financiere-richemont",
  richemont: "/companies/compagnie-financiere-richemont",
  "richemont group": "/companies/compagnie-financiere-richemont",
  "richemont switzerland": "/companies/compagnie-financiere-richemont",
  "richemont bellevue": "/companies/compagnie-financiere-richemont",

  /* luxury watches */
  "richemont watches": "/companies/compagnie-financiere-richemont",
  "richemont luxury watches": "/companies/compagnie-financiere-richemont",

  /* jewelry */
  "richemont jewelry": "/companies/compagnie-financiere-richemont",
  "richemont jewels": "/companies/compagnie-financiere-richemont",

  /* fashion accessories */
  "richemont fashion": "/companies/compagnie-financiere-richemont",
  "richemont fashion accessories": "/companies/compagnie-financiere-richemont",

  /* luxury goods */
  "richemont luxury": "/companies/compagnie-financiere-richemont",
  "richemont luxury goods": "/companies/compagnie-financiere-richemont",

  /* premium lifestyle brands */
  "richemont lifestyle": "/companies/compagnie-financiere-richemont",
  "richemont premium brands": "/companies/compagnie-financiere-richemont",

  /* ticker lookups */
  cfr: "/companies/compagnie-financiere-richemont",
  "cfr stock": "/companies/compagnie-financiere-richemont",
  "richemont stock": "/companies/compagnie-financiere-richemont",
  /* compagnie-financiere-richemont */
  /* intesa-sanpaolo */
  "intesa-sanpaolo": "/companies/intesa-sanpaolo",
  "intesa sanpaolo": "/companies/intesa-sanpaolo",
  "intesa bank": "/companies/intesa-sanpaolo",
  "intesa italy": "/companies/intesa-sanpaolo",
  "intesa turin": "/companies/intesa-sanpaolo",

  /* retail banking */
  "intesa retail": "/companies/intesa-sanpaolo",
  "intesa retail banking": "/companies/intesa-sanpaolo",

  /* corporate banking */
  "intesa corporate": "/companies/intesa-sanpaolo",
  "intesa corporate banking": "/companies/intesa-sanpaolo",
  "intesa business banking": "/companies/intesa-sanpaolo",

  /* investment services */
  "intesa investment": "/companies/intesa-sanpaolo",
  "intesa investment services": "/companies/intesa-sanpaolo",

  /* insurance */
  "intesa insurance": "/companies/intesa-sanpaolo",
  "intesa insurance products": "/companies/intesa-sanpaolo",

  /* wealth management */
  "intesa wealth": "/companies/intesa-sanpaolo",
  "intesa wealth management": "/companies/intesa-sanpaolo",

  /* ticker lookups */
  isp: "/companies/intesa-sanpaolo",
  "isp stock": "/companies/intesa-sanpaolo",
  "intesa sanpaolo stock": "/companies/intesa-sanpaolo",
  /* intesa-sanpaolo */

  /* air-liquide */
  "air-liquide": "/companies/air-liquide",
  "air liquide": "/companies/air-liquide",
  "air liquide france": "/companies/air-liquide",
  "air liquide paris": "/companies/air-liquide",
  "air liquide group": "/companies/air-liquide",

  /* industrial gases */
  "air liquide gases": "/companies/air-liquide",
  "air liquide industrial gases": "/companies/air-liquide",
  "air liquide oxygen": "/companies/air-liquide",
  "air liquide nitrogen": "/companies/air-liquide",
  "air liquide hydrogen": "/companies/air-liquide",

  /* healthcare gases */
  "air liquide healthcare": "/companies/air-liquide",
  "air liquide medical gases": "/companies/air-liquide",

  /* hydrogen solutions */
  "air liquide hydrogen solutions": "/companies/air-liquide",
  "air liquide h2": "/companies/air-liquide",

  /* engineering services */
  "air liquide engineering": "/companies/air-liquide",
  "air liquide engineering services": "/companies/air-liquide",

  /* medical equipment & services */
  "air liquide medical": "/companies/air-liquide",
  "air liquide medical equipment": "/companies/air-liquide",

  /* ticker lookups */
  ai: "/companies/air-liquide",
  "ai stock": "/companies/air-liquide",
  "air liquide stock": "/companies/air-liquide",
  /* air-liquide */

  /* bnp-paribas */
  "bnp-paribas": "/companies/bnp-paribas",
  "bnp paribas": "/companies/bnp-paribas",
  "bnp bank": "/companies/bnp-paribas",
  "bnp france": "/companies/bnp-paribas",
  "bnp paris": "/companies/bnp-paribas",

  /* retail banking */
  "bnp retail": "/companies/bnp-paribas",
  "bnp retail banking": "/companies/bnp-paribas",

  /* corporate & institutional banking */
  "bnp corporate": "/companies/bnp-paribas",
  "bnp corporate banking": "/companies/bnp-paribas",
  "bnp cib": "/companies/bnp-paribas",
  "bnp institutional banking": "/companies/bnp-paribas",

  /* investment solutions */
  "bnp investment": "/companies/bnp-paribas",
  "bnp investment solutions": "/companies/bnp-paribas",

  /* asset management */
  "bnp asset management": "/companies/bnp-paribas",
  "bnp am": "/companies/bnp-paribas",

  /* insurance services */
  "bnp insurance": "/companies/bnp-paribas",
  "bnp insurance services": "/companies/bnp-paribas",

  /* ticker lookups */
  bnp: "/companies/bnp-paribas",
  "bnp stock": "/companies/bnp-paribas",
  "bnp paribas stock": "/companies/bnp-paribas",
  /* bnp-paribas */
  /* bharti-airtel */
  "bharti-airtel": "/companies/bharti-airtel",
  "bharti airtel": "/companies/bharti-airtel",
  airtel: "/companies/bharti-airtel",
  "airtel india": "/companies/bharti-airtel",
  "airtel delhi": "/companies/bharti-airtel",

  /* mobile telecommunications */
  "airtel mobile": "/companies/bharti-airtel",
  "airtel telecom": "/companies/bharti-airtel",
  "airtel 4g": "/companies/bharti-airtel",
  "airtel 5g": "/companies/bharti-airtel",

  /* broadband internet */
  "airtel broadband": "/companies/bharti-airtel",
  "airtel fiber": "/companies/bharti-airtel",
  "airtel wifi": "/companies/bharti-airtel",

  /* digital tv */
  "airtel tv": "/companies/bharti-airtel",
  "airtel digital tv": "/companies/bharti-airtel",
  "airtel dth": "/companies/bharti-airtel",

  /* enterprise connectivity */
  "airtel enterprise": "/companies/bharti-airtel",
  "airtel business": "/companies/bharti-airtel",
  "airtel enterprise solutions": "/companies/bharti-airtel",

  /* digital payments */
  "airtel payments": "/companies/bharti-airtel",
  "airtel payments bank": "/companies/bharti-airtel",
  "airtel money": "/companies/bharti-airtel",

  /* ticker lookups */
  bhartiartl: "/companies/bharti-airtel",
  "bhartiartl stock": "/companies/bharti-airtel",
  "airtel stock": "/companies/bharti-airtel",
  /* bharti-airtel */
  /* capital-one */
  "capital-one": "/companies/capital-one",
  "capital one": "/companies/capital-one",
  "capital one bank": "/companies/capital-one",
  "capital one financial": "/companies/capital-one",
  "capital one virginia": "/companies/capital-one",
  "capital one mclean": "/companies/capital-one",

  /* credit cards */
  "capital one credit cards": "/companies/capital-one",
  "capital one cards": "/companies/capital-one",
  "capital one mastercard": "/companies/capital-one",
  "capital one visa": "/companies/capital-one",

  /* auto loans */
  "capital one auto": "/companies/capital-one",
  "capital one auto loans": "/companies/capital-one",
  "capital one car loans": "/companies/capital-one",

  /* retail banking */
  "capital one retail": "/companies/capital-one",
  "capital one retail banking": "/companies/capital-one",

  /* savings accounts */
  "capital one savings": "/companies/capital-one",
  "capital one 360": "/companies/capital-one",
  "capital one 360 savings": "/companies/capital-one",

  /* commercial banking */
  "capital one commercial": "/companies/capital-one",
  "capital one business banking": "/companies/capital-one",

  /* ticker lookups */
  cof: "/companies/capital-one",
  "cof stock": "/companies/capital-one",
  "capital one stock": "/companies/capital-one",
  /* capital-one */ /* progressive */ progressive: "/companies/progressive",
  "progressive corp": "/companies/progressive",
  "progressive corporation": "/companies/progressive",
  "progressive insurance": "/companies/progressive",
  "progressive ohio": "/companies/progressive",
  "progressive mayfield": "/companies/progressive",

  /* auto insurance */
  "progressive auto": "/companies/progressive",
  "progressive auto insurance": "/companies/progressive",
  "progressive car insurance": "/companies/progressive",

  /* home insurance */
  "progressive home": "/companies/progressive",
  "progressive home insurance": "/companies/progressive",

  /* commercial insurance */
  "progressive commercial": "/companies/progressive",
  "progressive commercial insurance": "/companies/progressive",
  "progressive business insurance": "/companies/progressive",

  /* motorcycle insurance */
  "progressive motorcycle": "/companies/progressive",
  "progressive motorcycle insurance": "/companies/progressive",

  /* usage-based insurance */
  "progressive usage based": "/companies/progressive",
  "progressive usage-based insurance": "/companies/progressive",
  "progressive snapshot": "/companies/progressive",

  /* ticker lookups */
  pgr: "/companies/progressive",
  "pgr stock": "/companies/progressive",
  "progressive stock": "/companies/progressive",
  /* progressive */

  /* altria-group */
  "altria-group": "/companies/altria-group",
  "altria group": "/companies/altria-group",
  altria: "/companies/altria-group",
  "altria inc": "/companies/altria-group",
  "altria virginia": "/companies/altria-group",
  "altria richmond": "/companies/altria-group",

  /* cigarettes */
  "altria cigarettes": "/companies/altria-group",
  "altria tobacco": "/companies/altria-group",
  "altria smoke": "/companies/altria-group",

  /* smokeless tobacco */
  "altria smokeless": "/companies/altria-group",
  "altria smokeless tobacco": "/companies/altria-group",

  /* nicotine pouches */
  "altria nicotine": "/companies/altria-group",
  "altria nicotine pouches": "/companies/altria-group",

  /* vaping products */
  "altria vape": "/companies/altria-group",
  "altria vaping": "/companies/altria-group",
  "altria e-cig": "/companies/altria-group",
  "altria ecig": "/companies/altria-group",

  /* tobacco-related products */
  "altria tobacco products": "/companies/altria-group",
  "altria nicotine products": "/companies/altria-group",

  /* ticker lookups */
  mo: "/companies/altria-group",
  "mo stock": "/companies/altria-group",
  "altria stock": "/companies/altria-group",
  /* altria-group */

  /* quanta-services */
  "quanta-services": "/companies/quanta-services",
  "quanta services": "/companies/quanta-services",
  quanta: "/companies/quanta-services",
  "quanta houston": "/companies/quanta-services",
  "quanta texas": "/companies/quanta-services",

  /* electric power infrastructure */
  "quanta electric": "/companies/quanta-services",
  "quanta electric power": "/companies/quanta-services",
  "quanta power infrastructure": "/companies/quanta-services",

  /* pipeline construction */
  "quanta pipeline": "/companies/quanta-services",
  "quanta pipeline construction": "/companies/quanta-services",
  "quanta oil gas pipelines": "/companies/quanta-services",

  /* telecommunications infrastructure */
  "quanta telecom": "/companies/quanta-services",
  "quanta telecommunications": "/companies/quanta-services",
  "quanta fiber": "/companies/quanta-services",

  /* renewable energy construction */
  "quanta renewable": "/companies/quanta-services",
  "quanta renewable energy": "/companies/quanta-services",
  "quanta solar": "/companies/quanta-services",
  "quanta wind": "/companies/quanta-services",

  /* utility maintenance */
  "quanta utility": "/companies/quanta-services",
  "quanta utility maintenance": "/companies/quanta-services",

  /* ticker lookups */
  pwr: "/companies/quanta-services",
  "pwr stock": "/companies/quanta-services",
  "quanta services stock": "/companies/quanta-services",
  /* quanta-services */

  /* aia-group */
  "aia-group": "/companies/aia-group",
  "aia group": "/companies/aia-group",
  aia: "/companies/aia-group",
  "aia hong kong": "/companies/aia-group",
  "aia asia": "/companies/aia-group",

  /* life insurance */
  "aia life": "/companies/aia-group",
  "aia life insurance": "/companies/aia-group",

  /* health insurance */
  "aia health": "/companies/aia-group",
  "aia health insurance": "/companies/aia-group",

  /* retirement planning */
  "aia retirement": "/companies/aia-group",
  "aia retirement planning": "/companies/aia-group",

  /* wealth management */
  "aia wealth": "/companies/aia-group",
  "aia wealth management": "/companies/aia-group",

  /* financial protection */
  "aia financial protection": "/companies/aia-group",
  "aia protection services": "/companies/aia-group",

  /* ticker lookups */
  "1299": "/companies/aia-group",
  "1299 stock": "/companies/aia-group",
  "aia stock": "/companies/aia-group",
  /* aia-group */

  /* vertex-pharmaceuticals */
  "vertex-pharmaceuticals": "/companies/vertex-pharmaceuticals",
  "vertex pharmaceuticals": "/companies/vertex-pharmaceuticals",
  vertex: "/companies/vertex-pharmaceuticals",
  "vertex boston": "/companies/vertex-pharmaceuticals",
  "vertex massachusetts": "/companies/vertex-pharmaceuticals",

  /* cystic fibrosis therapies */
  "vertex cf": "/companies/vertex-pharmaceuticals",
  "vertex cystic fibrosis": "/companies/vertex-pharmaceuticals",
  "vertex cf therapies": "/companies/vertex-pharmaceuticals",

  /* gene-based medicines */
  "vertex gene": "/companies/vertex-pharmaceuticals",
  "vertex gene therapy": "/companies/vertex-pharmaceuticals",
  "vertex gene-based medicines": "/companies/vertex-pharmaceuticals",

  /* rare disease treatments */
  "vertex rare": "/companies/vertex-pharmaceuticals",
  "vertex rare disease": "/companies/vertex-pharmaceuticals",
  "vertex rare disease treatments": "/companies/vertex-pharmaceuticals",

  /* kidney disease research */
  "vertex kidney": "/companies/vertex-pharmaceuticals",
  "vertex kidney disease": "/companies/vertex-pharmaceuticals",
  "vertex kidney research": "/companies/vertex-pharmaceuticals",

  /* biotechnology pharmaceuticals */
  "vertex biotech": "/companies/vertex-pharmaceuticals",
  "vertex biotechnology": "/companies/vertex-pharmaceuticals",
  "vertex pharma": "/companies/vertex-pharmaceuticals",

  /* ticker lookups */
  vrtx: "/companies/vertex-pharmaceuticals",
  "vrtx stock": "/companies/vertex-pharmaceuticals",
  "vertex stock": "/companies/vertex-pharmaceuticals",
  /* vertex-pharmaceuticals */

  /* parker-hannifin */
  "parker-hannifin": "/companies/parker-hannifin",
  "parker hannifin": "/companies/parker-hannifin",
  parker: "/companies/parker-hannifin",
  "parker cleveland": "/companies/parker-hannifin",
  "parker ohio": "/companies/parker-hannifin",

  /* motion & control systems */
  "parker motion": "/companies/parker-hannifin",
  "parker motion control": "/companies/parker-hannifin",
  "parker control systems": "/companies/parker-hannifin",

  /* hydraulic systems */
  "parker hydraulics": "/companies/parker-hannifin",
  "parker hydraulic systems": "/companies/parker-hannifin",

  /* aerospace components */
  "parker aerospace": "/companies/parker-hannifin",
  "parker aerospace components": "/companies/parker-hannifin",

  /* industrial automation */
  "parker automation": "/companies/parker-hannifin",
  "parker industrial automation": "/companies/parker-hannifin",

  /* filtration & sealing */
  "parker filtration": "/companies/parker-hannifin",
  "parker sealing": "/companies/parker-hannifin",
  "parker filtration systems": "/companies/parker-hannifin",
  "parker sealing technologies": "/companies/parker-hannifin",

  /* ticker lookups */
  ph: "/companies/parker-hannifin",
  "ph stock": "/companies/parker-hannifin",
  "parker hannifin stock": "/companies/parker-hannifin",
  /* parker-hannifin */

  /* howmet-aerospace */
  "howmet-aerospace": "/companies/howmet-aerospace",
  "howmet aerospace": "/companies/howmet-aerospace",
  howmet: "/companies/howmet-aerospace",
  "howmet pittsburgh": "/companies/howmet-aerospace",
  "howmet pennsylvania": "/companies/howmet-aerospace",

  /* aerospace engine components */
  "howmet engine components": "/companies/howmet-aerospace",
  "howmet jet engine": "/companies/howmet-aerospace",
  "howmet aerospace engines": "/companies/howmet-aerospace",

  /* aircraft fasteners */
  "howmet fasteners": "/companies/howmet-aerospace",
  "howmet aircraft fasteners": "/companies/howmet-aerospace",

  /* structural aircraft parts */
  "howmet structural parts": "/companies/howmet-aerospace",
  "howmet aircraft parts": "/companies/howmet-aerospace",
  "howmet structural components": "/companies/howmet-aerospace",

  /* industrial metal products */
  "howmet metal": "/companies/howmet-aerospace",
  "howmet industrial metal": "/companies/howmet-aerospace",
  "howmet engineered metals": "/companies/howmet-aerospace",

  /* defense & transportation components */
  "howmet defense": "/companies/howmet-aerospace",
  "howmet defense components": "/companies/howmet-aerospace",
  "howmet transportation components": "/companies/howmet-aerospace",

  /* ticker lookups */
  hwm: "/companies/howmet-aerospace",
  "hwm stock": "/companies/howmet-aerospace",
  "howmet stock": "/companies/howmet-aerospace",
  /* howmet-aerospace */

  /* constellation-energy */
  "constellation-energy": "/companies/constellation-energy",
  "constellation energy": "/companies/constellation-energy",
  constellation: "/companies/constellation-energy",
  "constellation baltimore": "/companies/constellation-energy",
  "constellation maryland": "/companies/constellation-energy",

  /* nuclear energy */
  "constellation nuclear": "/companies/constellation-energy",
  "constellation nuclear energy": "/companies/constellation-energy",

  /* renewable energy */
  "constellation renewable": "/companies/constellation-energy",
  "constellation renewables": "/companies/constellation-energy",
  "constellation wind": "/companies/constellation-energy",
  "constellation solar": "/companies/constellation-energy",
  "constellation hydro": "/companies/constellation-energy",

  /* electricity retail services */
  "constellation electricity": "/companies/constellation-energy",
  "constellation electric": "/companies/constellation-energy",
  "constellation retail energy": "/companies/constellation-energy",

  /* clean energy solutions */
  "constellation clean energy": "/companies/constellation-energy",
  "constellation clean power": "/companies/constellation-energy",

  /* energy trading & supply */
  "constellation energy trading": "/companies/constellation-energy",
  "constellation energy supply": "/companies/constellation-energy",

  /* ticker lookups */
  ceg: "/companies/constellation-energy",
  "ceg stock": "/companies/constellation-energy",
  "constellation energy stock": "/companies/constellation-energy",
  /* constellation-energy */

  /* stryker-corporation */
  "stryker-corporation": "/companies/stryker-corporation",
  "stryker corporation": "/companies/stryker-corporation",
  stryker: "/companies/stryker-corporation",
  "stryker kalamazoo": "/companies/stryker-corporation",
  "stryker michigan": "/companies/stryker-corporation",

  /* orthopedic implants */
  "stryker ortho": "/companies/stryker-corporation",
  "stryker orthopedic": "/companies/stryker-corporation",
  "stryker orthopedic implants": "/companies/stryker-corporation",

  /* surgical equipment */
  "stryker surgical": "/companies/stryker-corporation",
  "stryker surgical equipment": "/companies/stryker-corporation",

  /* medical devices */
  "stryker medical": "/companies/stryker-corporation",
  "stryker medical devices": "/companies/stryker-corporation",

  /* neurotechnology */
  "stryker neuro": "/companies/stryker-corporation",
  "stryker neurotechnology": "/companies/stryker-corporation",

  /* hospital solutions */
  "stryker hospital": "/companies/stryker-corporation",
  "stryker healthcare solutions": "/companies/stryker-corporation",

  /* ticker lookups */
  syk: "/companies/stryker-corporation",
  "syk stock": "/companies/stryker-corporation",
  "stryker stock": "/companies/stryker-corporation",
  /* stryker-corporation */

  /* bank-of-montreal */
  "bank-of-montreal": "/companies/bank-of-montreal",
  "bank of montreal": "/companies/bank-of-montreal",
  bmo: "/companies/bank-of-montreal",
  "bmo bank": "/companies/bank-of-montreal",
  "bmo canada": "/companies/bank-of-montreal",
  "bmo toronto": "/companies/bank-of-montreal",

  /* personal banking */
  "bmo personal": "/companies/bank-of-montreal",
  "bmo personal banking": "/companies/bank-of-montreal",

  /* commercial banking */
  "bmo commercial": "/companies/bank-of-montreal",
  "bmo commercial banking": "/companies/bank-of-montreal",
  "bmo business banking": "/companies/bank-of-montreal",

  /* wealth management */
  "bmo wealth": "/companies/bank-of-montreal",
  "bmo wealth management": "/companies/bank-of-montreal",

  /* investment banking */
  "bmo capital markets": "/companies/bank-of-montreal",
  "bmo investment banking": "/companies/bank-of-montreal",

  /* financial services */
  "bmo financial services": "/companies/bank-of-montreal",

  /* ticker lookups */
  "bmo stock": "/companies/bank-of-montreal",
  "bank of montreal stock": "/companies/bank-of-montreal",
  /* bank-of-montreal */

  /* mizuho-financial-group */
  "mizuho-financial-group": "/companies/mizuho-financial-group",
  "mizuho financial group": "/companies/mizuho-financial-group",
  mizuho: "/companies/mizuho-financial-group",
  "mizuho tokyo": "/companies/mizuho-financial-group",
  "mizuho japan": "/companies/mizuho-financial-group",

  /* retail banking */
  "mizuho retail": "/companies/mizuho-financial-group",
  "mizuho retail banking": "/companies/mizuho-financial-group",

  /* corporate banking */
  "mizuho corporate": "/companies/mizuho-financial-group",
  "mizuho corporate banking": "/companies/mizuho-financial-group",

  /* investment banking */
  "mizuho investment": "/companies/mizuho-financial-group",
  "mizuho investment banking": "/companies/mizuho-financial-group",
  "mizuho securities": "/companies/mizuho-financial-group",

  /* asset management */
  "mizuho asset management": "/companies/mizuho-financial-group",
  "mizuho asset": "/companies/mizuho-financial-group",

  /* trust & securities services */
  "mizuho trust": "/companies/mizuho-financial-group",
  "mizuho trust banking": "/companies/mizuho-financial-group",
  "mizuho securities services": "/companies/mizuho-financial-group",

  /* ticker lookups */
  "8411": "/companies/mizuho-financial-group",
  "8411 stock": "/companies/mizuho-financial-group",
  "mizuho stock": "/companies/mizuho-financial-group",
  /* mizuho-financial-group */
  /* al-rajhi-bank */
  "al-rajhi-bank": "/companies/al-rajhi-bank",
  "al rajhi bank": "/companies/al-rajhi-bank",
  "al rajhi": "/companies/al-rajhi-bank",
  "rajhi bank": "/companies/al-rajhi-bank",
  "al rajhi saudi": "/companies/al-rajhi-bank",
  "al rajhi riyadh": "/companies/al-rajhi-bank",

  /* islamic banking */
  "al rajhi islamic": "/companies/al-rajhi-bank",
  "al rajhi islamic banking": "/companies/al-rajhi-bank",
  "al rajhi sharia": "/companies/al-rajhi-bank",
  "al rajhi sharia compliant": "/companies/al-rajhi-bank",

  /* retail banking */
  "al rajhi retail": "/companies/al-rajhi-bank",
  "al rajhi retail banking": "/companies/al-rajhi-bank",

  /* corporate banking */
  "al rajhi corporate": "/companies/al-rajhi-bank",
  "al rajhi corporate banking": "/companies/al-rajhi-bank",

  /* wealth management */
  "al rajhi wealth": "/companies/al-rajhi-bank",
  "al rajhi wealth management": "/companies/al-rajhi-bank",

  /* financial services */
  "al rajhi financial services": "/companies/al-rajhi-bank",
  "al rajhi investment": "/companies/al-rajhi-bank",
  "al rajhi investment services": "/companies/al-rajhi-bank",

  /* ticker lookups */
  "1120": "/companies/al-rajhi-bank",
  "1120 stock": "/companies/al-rajhi-bank",
  "al rajhi stock": "/companies/al-rajhi-bank",
  /* al-rajhi-bank */

  /* equinix */
  equinix: "/companies/equinix",
  "equinix inc": "/companies/equinix",
  "equinix redwood city": "/companies/equinix",
  "equinix california": "/companies/equinix",

  /* data center colocation */
  "equinix data center": "/companies/equinix",
  "equinix data centers": "/companies/equinix",
  "equinix colocation": "/companies/equinix",

  /* interconnection services */
  "equinix interconnection": "/companies/equinix",
  "equinix ix": "/companies/equinix",
  "equinix peering": "/companies/equinix",

  /* cloud on-ramps */
  "equinix cloud": "/companies/equinix",
  "equinix cloud onramp": "/companies/equinix",
  "equinix cloud connect": "/companies/equinix",

  /* edge infrastructure */
  "equinix edge": "/companies/equinix",
  "equinix edge services": "/companies/equinix",

  /* digital infrastructure */
  "equinix digital": "/companies/equinix",
  "equinix digital infrastructure": "/companies/equinix",

  /* ticker lookups */
  eqix: "/companies/equinix",
  "eqix stock": "/companies/equinix",
  "equinix stock": "/companies/equinix",
  /* equinix */

  /* mitsui-bussan */
  "mitsui-bussan": "/companies/mitsui-bussan",
  "mitsui bussan": "/companies/mitsui-bussan",
  "mitsui & co": "/companies/mitsui-bussan",
  "mitsui and co": "/companies/mitsui-bussan",
  mitsui: "/companies/mitsui-bussan",
  "mitsui tokyo": "/companies/mitsui-bussan",
  "mitsui japan": "/companies/mitsui-bussan",

  /* energy trading & investment */
  "mitsui energy": "/companies/mitsui-bussan",
  "mitsui energy trading": "/companies/mitsui-bussan",
  "mitsui energy investment": "/companies/mitsui-bussan",

  /* industrial machinery */
  "mitsui machinery": "/companies/mitsui-bussan",
  "mitsui industrial machinery": "/companies/mitsui-bussan",

  /* chemicals */
  "mitsui chemicals": "/companies/mitsui-bussan",
  "mitsui chemical trading": "/companies/mitsui-bussan",

  /* metals & mineral resources */
  "mitsui metals": "/companies/mitsui-bussan",
  "mitsui minerals": "/companies/mitsui-bussan",
  "mitsui metal resources": "/companies/mitsui-bussan",

  /* food & consumer products */
  "mitsui food": "/companies/mitsui-bussan",
  "mitsui consumer products": "/companies/mitsui-bussan",

  /* infrastructure development */
  "mitsui infrastructure": "/companies/mitsui-bussan",
  "mitsui infrastructure development": "/companies/mitsui-bussan",

  /* logistics services */
  "mitsui logistics": "/companies/mitsui-bussan",
  "mitsui logistics services": "/companies/mitsui-bussan",

  /* ticker lookups */
  "8031": "/companies/mitsui-bussan",
  "8031 stock": "/companies/mitsui-bussan",
  "mitsui stock": "/companies/mitsui-bussan",
  /* mitsui-bussan */
  /* southern-company */
  "southern-company": "/companies/southern-company",
  "southern company": "/companies/southern-company",
  southern: "/companies/southern-company",
  "southern atlanta": "/companies/southern-company",
  "southern georgia": "/companies/southern-company",

  /* electric utility services */
  "southern electric": "/companies/southern-company",
  "southern electric utility": "/companies/southern-company",
  "southern electricity": "/companies/southern-company",

  /* natural gas distribution */
  "southern gas": "/companies/southern-company",
  "southern natural gas": "/companies/southern-company",

  /* energy generation */
  "southern energy": "/companies/southern-company",
  "southern power generation": "/companies/southern-company",

  /* renewable energy */
  "southern renewable": "/companies/southern-company",
  "southern renewables": "/companies/southern-company",
  "southern solar": "/companies/southern-company",
  "southern wind": "/companies/southern-company",

  /* energy infrastructure */
  "southern infrastructure": "/companies/southern-company",
  "southern energy infrastructure": "/companies/southern-company",

  /* ticker lookups */
  so: "/companies/southern-company",
  "so stock": "/companies/southern-company",
  "southern company stock": "/companies/southern-company",
  /* southern-company */

  /* zurich-insurance-group */
  "zurich-insurance-group": "/companies/zurich-insurance-group",
  "zurich insurance group": "/companies/zurich-insurance-group",
  zurich: "/companies/zurich-insurance-group",
  "zurich switzerland": "/companies/zurich-insurance-group",
  "zurich zurich": "/companies/zurich-insurance-group",

  /* life insurance */
  "zurich life": "/companies/zurich-insurance-group",
  "zurich life insurance": "/companies/zurich-insurance-group",

  /* property & casualty */
  "zurich p&c": "/companies/zurich-insurance-group",
  "zurich property": "/companies/zurich-insurance-group",
  "zurich casualty": "/companies/zurich-insurance-group",
  "zurich property and casualty": "/companies/zurich-insurance-group",

  /* commercial insurance */
  "zurich commercial": "/companies/zurich-insurance-group",
  "zurich commercial insurance": "/companies/zurich-insurance-group",

  /* risk management */
  "zurich risk": "/companies/zurich-insurance-group",
  "zurich risk management": "/companies/zurich-insurance-group",

  /* reinsurance */
  "zurich reinsurance": "/companies/zurich-insurance-group",
  "zurich re": "/companies/zurich-insurance-group",

  /* ticker lookups */
  zurn: "/companies/zurich-insurance-group",
  "zurn stock": "/companies/zurich-insurance-group",
  "zurich stock": "/companies/zurich-insurance-group",
  /* zurich-insurance-group */

  /* brookfield-corporation */
  "brookfield-corporation": "/companies/brookfield-corporation",
  "brookfield corporation": "/companies/brookfield-corporation",
  brookfield: "/companies/brookfield-corporation",
  "brookfield toronto": "/companies/brookfield-corporation",
  "brookfield canada": "/companies/brookfield-corporation",

  /* asset management */
  "brookfield asset management": "/companies/brookfield-corporation",

  "brookfield am": "/companies/brookfield-corporation",

  /* real estate investments */
  "brookfield real estate": "/companies/brookfield-corporation",
  "brookfield properties": "/companies/brookfield-corporation",

  /* infrastructure investments */
  "brookfield infrastructure": "/companies/brookfield-corporation",
  "brookfield infra": "/companies/brookfield-corporation",

  /* renewable power */
  "brookfield renewable": "/companies/brookfield-corporation",
  "brookfield renewables": "/companies/brookfield-corporation",

  /* private equity */
  "brookfield private equity": "/companies/brookfield-corporation",
  "brookfield pe": "/companies/brookfield-corporation",

  /* credit investments */
  "brookfield credit": "/companies/brookfield-corporation",
  "brookfield credit solutions": "/companies/brookfield-corporation",

  /* ticker lookups */
  bn: "/companies/brookfield-corporation",
  "bn stock": "/companies/brookfield-corporation",
  "brookfield stock": "/companies/brookfield-corporation",
  /* brookfield-corporation */

  /* brookfield-asset-management */
  "brookfield-asset-management": "/companies/brookfield-asset-management",
  // "brookfield asset management": "/companies/brookfield-asset-management",
  bam: "/companies/brookfield-asset-management",
  "bam stock": "/companies/brookfield-asset-management",
  // "brookfield am": "/companies/brookfield-asset-management",
  "brookfield investments": "/companies/brookfield-asset-management",
  "brookfield asset manager": "/companies/brookfield-asset-management",
  // "brookfield toronto": "/companies/brookfield-asset-management",
  "brookfield alternative assets": "/companies/brookfield-asset-management",
  /* brookfield-asset-management */

  /* cme-group */
  "cme-group": "/companies/cme-group",
  "cme group": "/companies/cme-group",
  cme: "/companies/cme-group",
  "cme chicago": "/companies/cme-group",
  "cme illinois": "/companies/cme-group",

  /* futures trading */
  "cme futures": "/companies/cme-group",
  "cme futures trading": "/companies/cme-group",

  /* options trading */
  "cme options": "/companies/cme-group",
  "cme options trading": "/companies/cme-group",

  /* interest rate derivatives */
  "cme interest rates": "/companies/cme-group",
  "cme rate futures": "/companies/cme-group",

  /* equity index derivatives */
  "cme equity index": "/companies/cme-group",
  "cme index futures": "/companies/cme-group",

  /* foreign exchange derivatives */
  "cme fx": "/companies/cme-group",
  "cme forex": "/companies/cme-group",
  "cme currency futures": "/companies/cme-group",

  /* commodity derivatives */
  "cme commodities": "/companies/cme-group",
  "cme commodity futures": "/companies/cme-group",

  /* clearing services */
  "cme clearing": "/companies/cme-group",
  "cme clearing services": "/companies/cme-group",

  /* ticker lookups */
  "cme stock": "/companies/cme-group",
  "cme group stock": "/companies/cme-group",
  /* cme-group */

  /* cibc */
  cibc: "/companies/cibc",
  "cibc bank": "/companies/cibc",
  "canadian imperial bank of commerce": "/companies/cibc",
  "cibc canada": "/companies/cibc",
  "cibc toronto": "/companies/cibc",

  /* personal banking */
  "cibc personal": "/companies/cibc",
  "cibc personal banking": "/companies/cibc",

  /* business banking */
  "cibc business": "/companies/cibc",
  "cibc business banking": "/companies/cibc",
  "cibc small business": "/companies/cibc",

  /* wealth management */
  "cibc wealth": "/companies/cibc",
  "cibc wealth management": "/companies/cibc",

  /* investment banking */
  "cibc investment banking": "/companies/cibc",
  "cibc capital markets": "/companies/cibc",

  /* mortgages & lending */
  "cibc mortgage": "/companies/cibc",
  "cibc mortgages": "/companies/cibc",
  "cibc lending": "/companies/cibc",

  /* ticker lookups */
  cm: "/companies/cibc",
  "cm stock": "/companies/cibc",
  "cibc stock": "/companies/cibc",
  /* cibc */

  /* sk-square */
  "sk-square": "/companies/sk-square",
  "sk square": "/companies/sk-square",
  sksquare: "/companies/sk-square",
  "sk sq": "/companies/sk-square",
  "sk square korea": "/companies/sk-square",
  "sk square seoul": "/companies/sk-square",

  /* sk group associations */
  "sk group square": "/companies/sk-square",
  "sk telecom spin off": "/companies/sk-square",
  "sk telecom spinoff": "/companies/sk-square",

  /* investment management */
  "sk square investment": "/companies/sk-square",
  "sk square investments": "/companies/sk-square",
  "sk square investment management": "/companies/sk-square",

  /* semiconductor investments */
  "sk square semiconductor": "/companies/sk-square",
  "sk square semiconductors": "/companies/sk-square",

  /* ict platform investments */
  "sk square ict": "/companies/sk-square",
  "sk square platform": "/companies/sk-square",
  "sk square platform investments": "/companies/sk-square",

  /* digital infrastructure */
  "sk square digital": "/companies/sk-square",
  "sk square digital infrastructure": "/companies/sk-square",

  /* technology portfolio */
  "sk square tech": "/companies/sk-square",
  "sk square technology": "/companies/sk-square",
  "sk square tech portfolio": "/companies/sk-square",

  /* ticker lookups */
  "402340": "/companies/sk-square",
  "402340.ks": "/companies/sk-square",
  "402340 stock": "/companies/sk-square",
  "sk square stock": "/companies/sk-square",
  /* sk-square */

  /* cadence-design-systems */
  "cadence-design-systems": "/companies/cadence-design-systems",
  "cadence design systems": "/companies/cadence-design-systems",
  cadence: "/companies/cadence-design-systems",
  "cadence eda": "/companies/cadence-design-systems",
  "cadence san jose": "/companies/cadence-design-systems",
  "cadence california": "/companies/cadence-design-systems",

  /* electronic design automation */
  "cadence electronic design automation": "/companies/cadence-design-systems",
  "cadence eda tools": "/companies/cadence-design-systems",
  "cadence design tools": "/companies/cadence-design-systems",

  /* ic design & verification */
  "cadence ic design": "/companies/cadence-design-systems",
  "cadence ic tools": "/companies/cadence-design-systems",
  "cadence verification": "/companies/cadence-design-systems",
  "cadence chip design": "/companies/cadence-design-systems",

  /* system design & analysis */
  "cadence system design": "/companies/cadence-design-systems",
  "cadence system analysis": "/companies/cadence-design-systems",

  /* semiconductor ip */
  "cadence semiconductor ip": "/companies/cadence-design-systems",
  "cadence ip": "/companies/cadence-design-systems",

  /* custom ic platforms */
  "cadence custom ic": "/companies/cadence-design-systems",
  "cadence custom design": "/companies/cadence-design-systems",

  /* ticker lookups */
  cdns: "/companies/cadence-design-systems",
  "cdns stock": "/companies/cadence-design-systems",
  "cadence stock": "/companies/cadence-design-systems",
  /* cadence-design-systems */

  /* gsk */
  gsk: "/companies/gsk",
  "gsk plc": "/companies/gsk",
  glaxosmithkline: "/companies/gsk",
  "gsk uk": "/companies/gsk",
  "gsk london": "/companies/gsk",

  /* vaccines */
  "gsk vaccines": "/companies/gsk",
  "gsk vaccine": "/companies/gsk",

  /* respiratory medicines */
  "gsk respiratory": "/companies/gsk",
  "gsk asthma": "/companies/gsk",
  "gsk copd": "/companies/gsk",

  /* hiv treatments */
  "gsk hiv": "/companies/gsk",
  "gsk viiv": "/companies/gsk",

  /* oncology drugs */
  "gsk oncology": "/companies/gsk",
  "gsk cancer": "/companies/gsk",

  /* immunology treatments */
  "gsk immunology": "/companies/gsk",
  "gsk immune": "/companies/gsk",

  /* general pharmaceuticals */
  "gsk pharma": "/companies/gsk",
  "gsk pharmaceuticals": "/companies/gsk",

  /* ticker lookups */
  // gsk: "/companies/gsk",
  "gsk stock": "/companies/gsk",
  "glaxosmithkline stock": "/companies/gsk",
  /* gsk */

  /* synopsys */
  synopsys: "/companies/synopsys",
  "synopsys inc": "/companies/synopsys",
  "synopsys usa": "/companies/synopsys",
  "synopsys sunnyvale": "/companies/synopsys",
  "synopsys california": "/companies/synopsys",

  /* electronic design automation */
  "synopsys eda": "/companies/synopsys",
  "synopsys electronic design automation": "/companies/synopsys",
  "synopsys design tools": "/companies/synopsys",

  /* silicon design tools */
  "synopsys silicon": "/companies/synopsys",
  "synopsys silicon design": "/companies/synopsys",
  "synopsys chip design": "/companies/synopsys",

  /* verification & testing */
  "synopsys verification": "/companies/synopsys",
  "synopsys testing": "/companies/synopsys",
  "synopsys verification tools": "/companies/synopsys",

  /* semiconductor ip */
  "synopsys ip": "/companies/synopsys",
  "synopsys semiconductor ip": "/companies/synopsys",

  /* software security */
  "synopsys security": "/companies/synopsys",
  "synopsys software security": "/companies/synopsys",
  "synopsys quality": "/companies/synopsys",

  /* ticker lookups */
  snps: "/companies/synopsys",
  "snps stock": "/companies/synopsys",
  "synopsys stock": "/companies/synopsys",
  /* synopsys */

  /* agnico-eagle-mines */
  "agnico-eagle-mines": "/companies/agnico-eagle-mines",
  "agnico eagle mines": "/companies/agnico-eagle-mines",
  "agnico eagle": "/companies/agnico-eagle-mines",
  agnico: "/companies/agnico-eagle-mines",
  "agnico toronto": "/companies/agnico-eagle-mines",
  "agnico canada": "/companies/agnico-eagle-mines",

  /* gold mining */
  "agnico gold": "/companies/agnico-eagle-mines",
  "agnico gold mining": "/companies/agnico-eagle-mines",
  "agnico gold production": "/companies/agnico-eagle-mines",

  /* mineral exploration */
  "agnico exploration": "/companies/agnico-eagle-mines",
  "agnico mineral exploration": "/companies/agnico-eagle-mines",

  /* mining development */
  "agnico mining development": "/companies/agnico-eagle-mines",
  "agnico development projects": "/companies/agnico-eagle-mines",

  /* precious metals */
  "agnico precious metals": "/companies/agnico-eagle-mines",
  "agnico metals": "/companies/agnico-eagle-mines",

  /* ticker lookups */
  aem: "/companies/agnico-eagle-mines",
  "aem stock": "/companies/agnico-eagle-mines",
  "agnico stock": "/companies/agnico-eagle-mines",
  /* agnico-eagle-mines */

  /* duke-energy */
  "duke-energy": "/companies/duke-energy",
  "duke energy": "/companies/duke-energy",
  duke: "/companies/duke-energy",
  "duke charlotte": "/companies/duke-energy",
  "duke north carolina": "/companies/duke-energy",

  /* electric utility services */
  "duke electric": "/companies/duke-energy",
  "duke electricity": "/companies/duke-energy",
  "duke electric utility": "/companies/duke-energy",

  /* power generation */
  "duke power": "/companies/duke-energy",
  "duke power generation": "/companies/duke-energy",

  /* transmission & distribution */
  "duke transmission": "/companies/duke-energy",
  "duke distribution": "/companies/duke-energy",
  "duke grid": "/companies/duke-energy",

  /* natural gas utilities */
  "duke gas": "/companies/duke-energy",
  "duke natural gas": "/companies/duke-energy",

  /* renewable energy */
  "duke renewable": "/companies/duke-energy",
  "duke renewables": "/companies/duke-energy",
  "duke solar": "/companies/duke-energy",
  "duke wind": "/companies/duke-energy",

  /* ticker lookups */
  duk: "/companies/duke-energy",
  "duk stock": "/companies/duke-energy",
  "duke energy stock": "/companies/duke-energy",
  /* duke-energy */
  /* china-yangtze-power */
  "china-yangtze-power": "/companies/china-yangtze-power",
  "china yangtze power": "/companies/china-yangtze-power",
  yangtze: "/companies/china-yangtze-power",
  "yangtze power": "/companies/china-yangtze-power",
  "yangtze china": "/companies/china-yangtze-power",
  "yangtze beijing": "/companies/china-yangtze-power",

  /* hydropower */
  "yangtze hydro": "/companies/china-yangtze-power",
  "yangtze hydropower": "/companies/china-yangtze-power",
  "china hydropower": "/companies/china-yangtze-power",

  /* three gorges dam */
  "three gorges": "/companies/china-yangtze-power",
  "three gorges dam": "/companies/china-yangtze-power",
  "three gorges power": "/companies/china-yangtze-power",

  /* renewable energy */
  "yangtze renewable": "/companies/china-yangtze-power",
  "yangtze renewables": "/companies/china-yangtze-power",
  "yangtze clean energy": "/companies/china-yangtze-power",

  /* electricity supply */
  "yangtze electricity": "/companies/china-yangtze-power",
  "yangtze electric": "/companies/china-yangtze-power",
  "yangtze power supply": "/companies/china-yangtze-power",

  /* power infrastructure */
  "yangtze infrastructure": "/companies/china-yangtze-power",
  "yangtze power infrastructure": "/companies/china-yangtze-power",

  /* ticker lookups */
  "600900": "/companies/china-yangtze-power",
  "600900.ss": "/companies/china-yangtze-power",
  "600900 stock": "/companies/china-yangtze-power",
  "yangtze power stock": "/companies/china-yangtze-power",
  /* china-yangtze-power */
  /* cummins */
  cummins: "/companies/cummins",
  "cummins inc": "/companies/cummins",
  "cummins usa": "/companies/cummins",
  "cummins columbus": "/companies/cummins",
  "cummins indiana": "/companies/cummins",

  /* diesel engines */
  "cummins diesel": "/companies/cummins",
  "cummins diesel engines": "/companies/cummins",

  /* natural gas engines */
  "cummins natural gas": "/companies/cummins",
  "cummins ng engines": "/companies/cummins",

  /* power generation */
  "cummins power": "/companies/cummins",
  "cummins generators": "/companies/cummins",
  "cummins power generation": "/companies/cummins",

  /* engine components */
  "cummins components": "/companies/cummins",
  "cummins engine parts": "/companies/cummins",

  /* hybrid & electric systems */
  "cummins hybrid": "/companies/cummins",
  "cummins electric": "/companies/cummins",
  "cummins electrified power": "/companies/cummins",

  /* fuel systems & aftertreatment */
  "cummins fuel systems": "/companies/cummins",
  "cummins aftertreatment": "/companies/cummins",
  "cummins emissions": "/companies/cummins",

  /* ticker lookups */
  cmi: "/companies/cummins",
  "cmi stock": "/companies/cummins",
  "cummins stock": "/companies/cummins",
  /* cummins */

  /* medtronic */
  medtronic: "/companies/medtronic",
  "medtronic plc": "/companies/medtronic",
  "medtronic ireland": "/companies/medtronic",
  "medtronic dublin": "/companies/medtronic",

  /* cardiovascular devices */
  "medtronic pacemaker": "/companies/medtronic",
  "medtronic pacemakers": "/companies/medtronic",
  "medtronic icd": "/companies/medtronic",
  "medtronic defibrillator": "/companies/medtronic",
  "medtronic heart valve": "/companies/medtronic",
  "medtronic heart valves": "/companies/medtronic",

  /* diabetes technologies */
  "medtronic insulin pump": "/companies/medtronic",
  "medtronic insulin pumps": "/companies/medtronic",
  "medtronic diabetes": "/companies/medtronic",

  /* neurological therapies */
  "medtronic neuro": "/companies/medtronic",
  "medtronic neurological": "/companies/medtronic",
  "medtronic brain": "/companies/medtronic",

  /* surgical devices */
  "medtronic surgical": "/companies/medtronic",
  "medtronic surgery": "/companies/medtronic",

  /* aortic & vascular */
  "medtronic stent": "/companies/medtronic",
  "medtronic stent graft": "/companies/medtronic",
  "medtronic aortic": "/companies/medtronic",

  /* ticker lookups */
  mdt: "/companies/medtronic",
  "mdt stock": "/companies/medtronic",
  "medtronic stock": "/companies/medtronic",
  /* medtronic */

  /* equinor */
  equinor: "/companies/equinor",
  "equinor asa": "/companies/equinor",
  "equinor norway": "/companies/equinor",
  "equinor stavanger": "/companies/equinor",

  /* legacy: statoil */
  statoil: "/companies/equinor",
  "statoil asa": "/companies/equinor",
  "statoil norway": "/companies/equinor",

  /* oil & gas */
  "equinor oil": "/companies/equinor",
  "equinor crude": "/companies/equinor",
  "equinor gas": "/companies/equinor",
  "equinor natural gas": "/companies/equinor",

  /* offshore energy */
  "equinor offshore": "/companies/equinor",
  "equinor offshore energy": "/companies/equinor",
  "equinor offshore drilling": "/companies/equinor",

  /* renewable energy */
  "equinor renewable": "/companies/equinor",
  "equinor renewables": "/companies/equinor",
  "equinor wind": "/companies/equinor",
  "equinor offshore wind": "/companies/equinor",

  /* carbon capture & storage */
  "equinor ccs": "/companies/equinor",
  "equinor carbon capture": "/companies/equinor",
  "equinor carbon storage": "/companies/equinor",

  /* ticker lookups */
  eqnr: "/companies/equinor",
  "eqnr stock": "/companies/equinor",
  "equinor stock": "/companies/equinor",
  /* equinor */

  /* scotiabank */
  scotiabank: "/companies/scotiabank",
  "scotia bank": "/companies/scotiabank",
  "bank of nova scotia": "/companies/scotiabank",
  "bns bank": "/companies/scotiabank",
  "scotiabank canada": "/companies/scotiabank",
  "scotiabank toronto": "/companies/scotiabank",

  /* personal banking */
  "scotiabank personal": "/companies/scotiabank",
  "scotiabank personal banking": "/companies/scotiabank",

  /* commercial banking */
  "scotiabank business": "/companies/scotiabank",
  "scotiabank commercial": "/companies/scotiabank",
  "scotiabank commercial banking": "/companies/scotiabank",

  /* wealth management */
  "scotiabank wealth": "/companies/scotiabank",
  "scotiabank wealth management": "/companies/scotiabank",

  /* investment banking */
  "scotiabank investment": "/companies/scotiabank",
  "scotiabank investment banking": "/companies/scotiabank",
  "scotiabank capital markets": "/companies/scotiabank",

  /* credit & lending */
  "scotiabank credit": "/companies/scotiabank",
  "scotiabank loans": "/companies/scotiabank",
  "scotiabank lending": "/companies/scotiabank",

  /* international banking */
  "scotiabank international": "/companies/scotiabank",
  "scotiabank latin america": "/companies/scotiabank",
  "scotiabank caribbean": "/companies/scotiabank",

  /* ticker lookups */
  bns: "/companies/scotiabank",
  "bns stock": "/companies/scotiabank",
  "scotiabank stock": "/companies/scotiabank",
  /* scotiabank */

  /* hca-healthcare */
  "hca-healthcare": "/companies/hca-healthcare",
  "hca healthcare": "/companies/hca-healthcare",
  hca: "/companies/hca-healthcare",
  "hca hospitals": "/companies/hca-healthcare",
  "hca nashville": "/companies/hca-healthcare",
  "hca tennessee": "/companies/hca-healthcare",

  /* hospital services */
  "hca hospital": "/companies/hca-healthcare",
  "hca hospital services": "/companies/hca-healthcare",
  "hca inpatient": "/companies/hca-healthcare",

  /* emergency care */
  "hca emergency": "/companies/hca-healthcare",
  "hca er": "/companies/hca-healthcare",
  "hca emergency care": "/companies/hca-healthcare",

  /* surgical services */
  "hca surgery": "/companies/hca-healthcare",
  "hca surgical": "/companies/hca-healthcare",
  "hca surgical services": "/companies/hca-healthcare",

  /* outpatient care */
  "hca outpatient": "/companies/hca-healthcare",
  "hca outpatient care": "/companies/hca-healthcare",
  "hca clinics": "/companies/hca-healthcare",

  /* diagnostic services */
  "hca diagnostics": "/companies/hca-healthcare",
  "hca imaging": "/companies/hca-healthcare",
  "hca diagnostic services": "/companies/hca-healthcare",

  /* specialty medical care */
  "hca specialty care": "/companies/hca-healthcare",
  "hca specialty": "/companies/hca-healthcare",

  /* ticker lookups */
  // hca: "/companies/hca-healthcare",
  "hca stock": "/companies/hca-healthcare",
  "hca healthcare stock": "/companies/hca-healthcare",
  /* hca-healthcare */
  /* infineon-technologies */
  "infineon-technologies": "/companies/infineon-technologies",
  "infineon technologies": "/companies/infineon-technologies",
  infineon: "/companies/infineon-technologies",
  "infineon germany": "/companies/infineon-technologies",
  "infineon neubiberg": "/companies/infineon-technologies",

  /* power semiconductors */
  "infineon power": "/companies/infineon-technologies",
  "infineon power semiconductors": "/companies/infineon-technologies",
  "infineon power devices": "/companies/infineon-technologies",

  /* automotive electronics */
  "infineon automotive": "/companies/infineon-technologies",
  "infineon auto chips": "/companies/infineon-technologies",
  "infineon car electronics": "/companies/infineon-technologies",

  /* microcontrollers */
  "infineon microcontrollers": "/companies/infineon-technologies",
  "infineon mcu": "/companies/infineon-technologies",

  /* security chips */
  "infineon security": "/companies/infineon-technologies",
  "infineon security chips": "/companies/infineon-technologies",
  "infineon trusted": "/companies/infineon-technologies",

  /* industrial power control */
  "infineon industrial": "/companies/infineon-technologies",
  "infineon industrial power": "/companies/infineon-technologies",
  "infineon ipc": "/companies/infineon-technologies",

  /* sensors */
  "infineon sensors": "/companies/infineon-technologies",
  "infineon sensor systems": "/companies/infineon-technologies",

  /* ticker lookups */
  "ifx.de": "/companies/infineon-technologies",
  ifx: "/companies/infineon-technologies",
  "ifx stock": "/companies/infineon-technologies",
  "infineon stock": "/companies/infineon-technologies",
  /* infineon-technologies */

  /* canadian-natural-resources */
  "canadian-natural-resources": "/companies/canadian-natural-resources",
  "canadian natural resources": "/companies/canadian-natural-resources",
  cnrl: "/companies/canadian-natural-resources",
  "cnrl canada": "/companies/canadian-natural-resources",
  "cnrl calgary": "/companies/canadian-natural-resources",
  "canadian natural": "/companies/canadian-natural-resources",

  /* crude oil */
  "cnrl oil": "/companies/canadian-natural-resources",
  "cnrl crude": "/companies/canadian-natural-resources",
  "canadian natural oil": "/companies/canadian-natural-resources",

  /* natural gas */
  "cnrl gas": "/companies/canadian-natural-resources",
  "cnrl natural gas": "/companies/canadian-natural-resources",

  /* natural gas liquids */
  "cnrl ngl": "/companies/canadian-natural-resources",
  "cnrl natural gas liquids": "/companies/canadian-natural-resources",

  /* oil sands */
  "cnrl oil sands": "/companies/canadian-natural-resources",
  "canadian natural oil sands": "/companies/canadian-natural-resources",

  /* offshore energy */
  "cnrl offshore": "/companies/canadian-natural-resources",
  "cnrl offshore energy": "/companies/canadian-natural-resources",

  /* ticker lookups */
  cnq: "/companies/canadian-natural-resources",
  "cnq stock": "/companies/canadian-natural-resources",
  "canadian natural resources stock": "/companies/canadian-natural-resources",
  /* canadian-natural-resources */
  /* sberbank */
  sberbank: "/companies/sberbank",
  "sber bank": "/companies/sberbank",
  "sberbank russia": "/companies/sberbank",
  "sber russia": "/companies/sberbank",
  "sber moscow": "/companies/sberbank",
  "sberbank moscow": "/companies/sberbank",

  /* retail banking */
  "sberbank retail": "/companies/sberbank",
  "sber retail banking": "/companies/sberbank",

  /* corporate banking */
  "sberbank corporate": "/companies/sberbank",
  "sber corporate banking": "/companies/sberbank",

  /* digital banking */
  "sber digital": "/companies/sberbank",
  "sberbank digital": "/companies/sberbank",
  "sber online": "/companies/sberbank",
  "sberbank online": "/companies/sberbank",

  /* asset management */
  "sberbank asset management": "/companies/sberbank",
  "sber asset management": "/companies/sberbank",

  /* investment services */
  "sberbank investment": "/companies/sberbank",
  "sber investments": "/companies/sberbank",

  /* insurance */
  "sberbank insurance": "/companies/sberbank",
  "sber insurance": "/companies/sberbank",

  /* ticker lookups */
  "sber.me": "/companies/sberbank",
  sber: "/companies/sberbank",
  "sber stock": "/companies/sberbank",
  "sberbank stock": "/companies/sberbank",
  /* sberbank */

  /* state-bank-of-india */
  "state-bank-of-india": "/companies/state-bank-of-india",
  "state bank of india": "/companies/state-bank-of-india",
  sbi: "/companies/state-bank-of-india",
  "sbi bank": "/companies/state-bank-of-india",
  "sbi india": "/companies/state-bank-of-india",
  "sbi mumbai": "/companies/state-bank-of-india",

  /* retail banking */
  "sbi retail": "/companies/state-bank-of-india",
  "sbi retail banking": "/companies/state-bank-of-india",

  /* corporate banking */
  "sbi corporate": "/companies/state-bank-of-india",
  "sbi corporate banking": "/companies/state-bank-of-india",

  /* agricultural banking */
  "sbi agriculture": "/companies/state-bank-of-india",
  "sbi agri": "/companies/state-bank-of-india",
  "sbi agricultural banking": "/companies/state-bank-of-india",

  /* treasury */
  "sbi treasury": "/companies/state-bank-of-india",
  "sbi treasury services": "/companies/state-bank-of-india",

  /* wealth management */
  "sbi wealth": "/companies/state-bank-of-india",
  "sbi wealth management": "/companies/state-bank-of-india",

  /* international banking */
  "sbi international": "/companies/state-bank-of-india",
  "sbi overseas": "/companies/state-bank-of-india",
  "sbi nri": "/companies/state-bank-of-india",

  /* ticker lookups */
  "sbin.ns": "/companies/state-bank-of-india",
  sbin: "/companies/state-bank-of-india",
  "sbin stock": "/companies/state-bank-of-india",
  "sbi stock": "/companies/state-bank-of-india",
  /* state-bank-of-india */
  /* icici-bank */
  "icici-bank": "/companies/icici-bank",
  "icici bank": "/companies/icici-bank",
  icici: "/companies/icici-bank",
  "icici india": "/companies/icici-bank",
  "icici mumbai": "/companies/icici-bank",

  /* retail banking */
  "icici retail": "/companies/icici-bank",
  "icici retail banking": "/companies/icici-bank",

  /* corporate banking */
  "icici corporate": "/companies/icici-bank",
  "icici corporate banking": "/companies/icici-bank",

  /* investment banking */
  "icici investment": "/companies/icici-bank",
  "icici investment banking": "/companies/icici-bank",

  /* insurance */
  "icici insurance": "/companies/icici-bank",
  "icici prudential": "/companies/icici-bank",
  "icici lombard": "/companies/icici-bank",

  /* wealth management */
  "icici wealth": "/companies/icici-bank",
  "icici wealth management": "/companies/icici-bank",

  /* digital banking */
  "icici digital": "/companies/icici-bank",
  "icici online": "/companies/icici-bank",
  "icici netbanking": "/companies/icici-bank",

  /* ticker lookups */
  ibn: "/companies/icici-bank",
  "ibn stock": "/companies/icici-bank",
  "icici stock": "/companies/icici-bank",
  /* icici-bank */

  /* grupo-mexico */
  "grupo-mexico": "/companies/grupo-mexico",
  "grupo méxico": "/companies/grupo-mexico",
  "grupo mexico": "/companies/grupo-mexico",
  gmexico: "/companies/grupo-mexico",
  "gmexico mexico": "/companies/grupo-mexico",
  "grupo mexico city": "/companies/grupo-mexico",

  /* mining */
  "grupo mexico mining": "/companies/grupo-mexico",
  "gmexico mining": "/companies/grupo-mexico",
  "grupo mexico copper": "/companies/grupo-mexico",
  "grupo mexico silver": "/companies/grupo-mexico",
  "grupo mexico zinc": "/companies/grupo-mexico",

  /* copper production */
  "grupo mexico copper production": "/companies/grupo-mexico",
  "gmexico copper": "/companies/grupo-mexico",

  /* rail transportation */
  "grupo mexico rail": "/companies/grupo-mexico",
  "gmexico rail": "/companies/grupo-mexico",
  ferromex: "/companies/grupo-mexico",
  ferrosur: "/companies/grupo-mexico",

  /* infrastructure */
  "grupo mexico infrastructure": "/companies/grupo-mexico",
  "gmexico infrastructure": "/companies/grupo-mexico",

  /* metallurgical processing */
  "grupo mexico metallurgical": "/companies/grupo-mexico",
  "gmexico metallurgical": "/companies/grupo-mexico",

  /* ticker lookups */
  gmbxf: "/companies/grupo-mexico",
  "gmbxf stock": "/companies/grupo-mexico",
  "grupo mexico stock": "/companies/grupo-mexico",
  /* grupo-mexico */

  /* marriott-international */
  "marriott-international": "/companies/marriott-international",
  "marriott international": "/companies/marriott-international",
  marriott: "/companies/marriott-international",
  "marriott hotels": "/companies/marriott-international",
  "marriott bethesda": "/companies/marriott-international",
  "marriott maryland": "/companies/marriott-international",

  /* hotel operations */
  "marriott hotel": "/companies/marriott-international",
  "marriott lodging": "/companies/marriott-international",
  "marriott accommodations": "/companies/marriott-international",

  /* franchising */
  "marriott franchise": "/companies/marriott-international",
  "marriott franchising": "/companies/marriott-international",

  /* luxury hospitality */
  "marriott luxury": "/companies/marriott-international",
  "marriott luxury hotels": "/companies/marriott-international",

  /* resort management */
  "marriott resort": "/companies/marriott-international",
  "marriott resorts": "/companies/marriott-international",

  /* loyalty programs */
  "marriott bonvoy": "/companies/marriott-international",
  "marriott loyalty": "/companies/marriott-international",

  /* ticker lookups */
  mar: "/companies/marriott-international",
  "mar stock": "/companies/marriott-international",
  "marriott stock": "/companies/marriott-international",
  /* marriott-international */

  /* general-dynamics */
  "general-dynamics": "/companies/general-dynamics",
  "general dynamics": "/companies/general-dynamics",
  gdyn: "/companies/general-dynamics",
  gd: "/companies/general-dynamics",
  "general dynamics reston": "/companies/general-dynamics",
  "general dynamics virginia": "/companies/general-dynamics",

  /* combat vehicles */
  "gd combat": "/companies/general-dynamics",
  "general dynamics combat vehicles": "/companies/general-dynamics",
  "gd land systems": "/companies/general-dynamics",

  /* submarines */
  "gd submarines": "/companies/general-dynamics",
  "general dynamics submarines": "/companies/general-dynamics",
  "electric boat": "/companies/general-dynamics",

  /* business jets */
  "gd jets": "/companies/general-dynamics",
  "general dynamics jets": "/companies/general-dynamics",
  gulfstream: "/companies/general-dynamics",
  "gulfstream aerospace": "/companies/general-dynamics",

  /* weapons systems */
  "gd weapons": "/companies/general-dynamics",
  "general dynamics weapons": "/companies/general-dynamics",

  /* defense IT solutions */
  "gd it": "/companies/general-dynamics",
  "general dynamics it": "/companies/general-dynamics",
  "gd information technology": "/companies/general-dynamics",
  gdit: "/companies/general-dynamics",

  /* aerospace systems */
  "gd aerospace": "/companies/general-dynamics",
  "general dynamics aerospace": "/companies/general-dynamics",

  /* ticker lookups */
  "gd stock": "/companies/general-dynamics",
  "general dynamics stock": "/companies/general-dynamics",
  /* general-dynamics */
  /* kkr-and-co */
  "kkr-and-co": "/companies/kkr-and-co",
  "kkr & co": "/companies/kkr-and-co",
  kkr: "/companies/kkr-and-co",
  "kkr inc": "/companies/kkr-and-co",
  "kkr new york": "/companies/kkr-and-co",
  "kohlberg kravis roberts": "/companies/kkr-and-co",

  /* private equity */
  "kkr private equity": "/companies/kkr-and-co",
  "kkr pe": "/companies/kkr-and-co",

  /* credit & debt */
  "kkr credit": "/companies/kkr-and-co",
  "kkr debt": "/companies/kkr-and-co",
  "kkr financing": "/companies/kkr-and-co",

  /* infrastructure */
  "kkr infrastructure": "/companies/kkr-and-co",
  "kkr infra": "/companies/kkr-and-co",

  /* real estate */
  "kkr real estate": "/companies/kkr-and-co",
  "kkr re": "/companies/kkr-and-co",

  /* asset management */
  "kkr asset management": "/companies/kkr-and-co",
  "kkr investments": "/companies/kkr-and-co",

  /* capital markets */
  "kkr capital markets": "/companies/kkr-and-co",
  "kkr advisory": "/companies/kkr-and-co",

  /* ticker lookups */
  // kkr: "/companies/kkr-and-co",
  "kkr stock": "/companies/kkr-and-co",
  "kkr & co stock": "/companies/kkr-and-co",
  /* kkr-and-co */

  /* freeport-mcmoran */
  "freeport-mcmoran": "/companies/freeport-mcmoran",
  "freeport mcmoran": "/companies/freeport-mcmoran",
  "freeport-mcmoran inc": "/companies/freeport-mcmoran",
  "freeport mcmoran inc": "/companies/freeport-mcmoran",
  fcx: "/companies/freeport-mcmoran",
  "freeport phoenix": "/companies/freeport-mcmoran",
  "freeport arizona": "/companies/freeport-mcmoran",

  /* copper */
  "freeport copper": "/companies/freeport-mcmoran",
  "fcx copper": "/companies/freeport-mcmoran",

  /* gold */
  "freeport gold": "/companies/freeport-mcmoran",
  "fcx gold": "/companies/freeport-mcmoran",

  /* molybdenum */
  "freeport molybdenum": "/companies/freeport-mcmoran",
  "fcx molybdenum": "/companies/freeport-mcmoran",

  /* mining operations */
  "freeport mining": "/companies/freeport-mcmoran",
  "fcx mining": "/companies/freeport-mcmoran",
  "freeport mines": "/companies/freeport-mcmoran",

  /* smelting & refining */
  "freeport smelting": "/companies/freeport-mcmoran",
  "freeport refining": "/companies/freeport-mcmoran",

  /* exploration */
  "freeport exploration": "/companies/freeport-mcmoran",
  "fcx exploration": "/companies/freeport-mcmoran",

  /* ticker lookups */
  "fcx stock": "/companies/freeport-mcmoran",
  "freeport stock": "/companies/freeport-mcmoran",
  /* freeport-mcmoran */

  /* sinopec */
  sinopec: "/companies/sinopec",
  "china petroleum & chemical": "/companies/sinopec",
  "china petroleum and chemical": "/companies/sinopec",
  "sinopec china": "/companies/sinopec",
  "sinopec beijing": "/companies/sinopec",
  "sinopec corp": "/companies/sinopec",

  /* crude oil */
  "sinopec crude": "/companies/sinopec",
  "sinopec crude oil": "/companies/sinopec",

  /* natural gas */
  "sinopec gas": "/companies/sinopec",
  "sinopec natural gas": "/companies/sinopec",

  /* refining */
  "sinopec refining": "/companies/sinopec",
  "sinopec refinery": "/companies/sinopec",

  /* petrochemicals */
  "sinopec petrochemicals": "/companies/sinopec",
  "sinopec chemicals": "/companies/sinopec",

  /* chemical fibers */
  "sinopec fibers": "/companies/sinopec",
  "sinopec chemical fibers": "/companies/sinopec",

  /* lubricants */
  "sinopec lubricants": "/companies/sinopec",
  "sinopec lube": "/companies/sinopec",

  /* hydrogen energy */
  "sinopec hydrogen": "/companies/sinopec",
  "sinopec hydrogen energy": "/companies/sinopec",

  /* ticker lookups */
  "600028.ss": "/companies/sinopec",
  "600028": "/companies/sinopec",
  "sinopec stock": "/companies/sinopec",
  "snp stock": "/companies/sinopec",
  /* sinopec */

  /* mitsubishi-heavy-industries */
  "mitsubishi-heavy-industries": "/companies/mitsubishi-heavy-industries",
  "mitsubishi heavy industries": "/companies/mitsubishi-heavy-industries",
  mhi: "/companies/mitsubishi-heavy-industries",
  "mhi japan": "/companies/mitsubishi-heavy-industries",
  "mhi tokyo": "/companies/mitsubishi-heavy-industries",

  /* aerospace systems */
  "mhi aerospace": "/companies/mitsubishi-heavy-industries",
  "mitsubishi aerospace": "/companies/mitsubishi-heavy-industries",
  "mhi aircraft": "/companies/mitsubishi-heavy-industries",

  /* power generation */
  "mhi power": "/companies/mitsubishi-heavy-industries",
  "mhi power systems": "/companies/mitsubishi-heavy-industries",
  "mitsubishi power": "/companies/mitsubishi-heavy-industries",

  /* defense systems */
  "mhi defense": "/companies/mitsubishi-heavy-industries",
  "mitsubishi defense": "/companies/mitsubishi-heavy-industries",

  /* industrial machinery */
  "mhi machinery": "/companies/mitsubishi-heavy-industries",
  "mitsubishi machinery": "/companies/mitsubishi-heavy-industries",

  /* shipbuilding */
  "mhi shipbuilding": "/companies/mitsubishi-heavy-industries",
  "mitsubishi shipbuilding": "/companies/mitsubishi-heavy-industries",

  /* hvac systems */
  "mhi hvac": "/companies/mitsubishi-heavy-industries",
  "mitsubishi hvac": "/companies/mitsubishi-heavy-industries",

  /* energy infrastructure */
  "mhi energy": "/companies/mitsubishi-heavy-industries",
  // "mitsubishi energy": "/companies/mitsubishi-heavy-industries",

  /* transportation systems */
  "mhi transportation": "/companies/mitsubishi-heavy-industries",
  "mitsubishi transportation": "/companies/mitsubishi-heavy-industries",

  /* ticker lookups */
  "7011.t": "/companies/mitsubishi-heavy-industries",
  "7011": "/companies/mitsubishi-heavy-industries",
  "mhi stock": "/companies/mitsubishi-heavy-industries",
  "mitsubishi heavy industries stock": "/companies/mitsubishi-heavy-industries",
  /* mitsubishi-heavy-industries */

  /* itochu-shoji */
  "itochu-shoji": "/companies/itochu-shoji",
  "itōchū shōji": "/companies/itochu-shoji",
  "itochu shoji": "/companies/itochu-shoji",
  itochu: "/companies/itochu-shoji",
  "itochu corp": "/companies/itochu-shoji",
  "itochu corporation": "/companies/itochu-shoji",
  "itochu tokyo": "/companies/itochu-shoji",
  "itochu japan": "/companies/itochu-shoji",

  /* textiles */
  "itochu textiles": "/companies/itochu-shoji",
  "itochu textile": "/companies/itochu-shoji",

  /* machinery */
  "itochu machinery": "/companies/itochu-shoji",
  "itochu industrial machinery": "/companies/itochu-shoji",

  /* metals & minerals */
  "itochu metals": "/companies/itochu-shoji",
  "itochu minerals": "/companies/itochu-shoji",
  "itochu metals and minerals": "/companies/itochu-shoji",

  /* energy */
  "itochu energy": "/companies/itochu-shoji",
  "itochu oil": "/companies/itochu-shoji",
  "itochu gas": "/companies/itochu-shoji",

  /* chemicals */
  "itochu chemicals": "/companies/itochu-shoji",
  "itochu chemical": "/companies/itochu-shoji",

  /* food */
  "itochu food": "/companies/itochu-shoji",
  "itochu food products": "/companies/itochu-shoji",

  /* ICT solutions */
  "itochu ict": "/companies/itochu-shoji",
  "itochu it": "/companies/itochu-shoji",
  "itochu technology": "/companies/itochu-shoji",

  /* financial services */
  "itochu finance": "/companies/itochu-shoji",
  "itochu financial services": "/companies/itochu-shoji",

  /* ticker lookups */
  "8001.t": "/companies/itochu-shoji",
  "8001": "/companies/itochu-shoji",
  "itochu stock": "/companies/itochu-shoji",
  "itochu shoji stock": "/companies/itochu-shoji",
  /* itochu-shoji */

  /* bny-mellon */
  "bny-mellon": "/companies/bny-mellon",
  "bny mellon": "/companies/bny-mellon",
  "bank of new york mellon": "/companies/bny-mellon",
  "the bank of new york mellon": "/companies/bny-mellon",
  "bny new york": "/companies/bny-mellon",
  "bny mellon nyc": "/companies/bny-mellon",

  /* asset servicing */
  "bny asset servicing": "/companies/bny-mellon",
  "bny mellon asset servicing": "/companies/bny-mellon",

  /* investment management */
  "bny investment management": "/companies/bny-mellon",
  "bny mellon investment management": "/companies/bny-mellon",

  /* wealth management */
  "bny wealth": "/companies/bny-mellon",
  "bny mellon wealth": "/companies/bny-mellon",
  "bny mellon wealth management": "/companies/bny-mellon",

  /* custody services */
  "bny custody": "/companies/bny-mellon",
  "bny mellon custody": "/companies/bny-mellon",

  /* securities clearing */
  "bny clearing": "/companies/bny-mellon",
  "bny mellon clearing": "/companies/bny-mellon",

  /* treasury services */
  "bny treasury": "/companies/bny-mellon",
  "bny mellon treasury": "/companies/bny-mellon",

  /* collateral management */
  "bny collateral": "/companies/bny-mellon",
  "bny mellon collateral": "/companies/bny-mellon",

  /* ticker lookups */
  bk: "/companies/bny-mellon",
  "bk stock": "/companies/bny-mellon",
  "bny mellon stock": "/companies/bny-mellon",
  /* bny-mellon */
  /* williams-companies */
  "williams-companies": "/companies/williams-companies",
  "williams companies": "/companies/williams-companies",
  williams: "/companies/williams-companies",
  "williams energy": "/companies/williams-companies",
  "williams tulsa": "/companies/williams-companies",
  "williams oklahoma": "/companies/williams-companies",

  /* natural gas transportation */
  "williams natural gas": "/companies/williams-companies",
  "williams gas": "/companies/williams-companies",
  "williams gas transportation": "/companies/williams-companies",

  /* pipeline infrastructure */
  "williams pipeline": "/companies/williams-companies",
  "williams pipelines": "/companies/williams-companies",
  "williams midstream": "/companies/williams-companies",

  /* natural gas processing */
  "williams gas processing": "/companies/williams-companies",
  "williams processing": "/companies/williams-companies",

  /* energy storage */
  "williams storage": "/companies/williams-companies",
  "williams energy storage": "/companies/williams-companies",

  /* ngl services */
  "williams ngl": "/companies/williams-companies",
  "williams natural gas liquids": "/companies/williams-companies",

  /* midstream energy solutions */
  "williams midstream energy": "/companies/williams-companies",
  "williams midstream solutions": "/companies/williams-companies",

  /* ticker lookups */
  wmb: "/companies/williams-companies",
  "wmb stock": "/companies/williams-companies",
  "williams stock": "/companies/williams-companies",
  /* williams-companies */
  /* dior */
  dior: "/companies/dior",
  "christian dior": "/companies/dior",
  "christian dior se": "/companies/dior",
  "dior paris": "/companies/dior",
  "dior france": "/companies/dior",

  /* haute couture */
  "dior haute couture": "/companies/dior",
  "dior couture": "/companies/dior",

  /* leather goods */
  "dior leather": "/companies/dior",
  "dior leather goods": "/companies/dior",

  /* fashion accessories */
  "dior accessories": "/companies/dior",
  "dior fashion accessories": "/companies/dior",

  /* footwear */
  "dior shoes": "/companies/dior",
  "dior footwear": "/companies/dior",

  /* perfume & cosmetics */
  "dior perfume": "/companies/dior",
  "dior fragrances": "/companies/dior",
  "dior cosmetics": "/companies/dior",
  "dior beauty": "/companies/dior",

  /* watches & jewelry */
  "dior watches": "/companies/dior",
  "dior jewelry": "/companies/dior",
  "dior joaillerie": "/companies/dior",

  /* ticker lookups */
  "cdi.pa": "/companies/dior",
  cdi: "/companies/dior",
  "dior stock": "/companies/dior",
  "christian dior stock": "/companies/dior",
  /* dior */

  /* westpac-banking */
  "westpac-banking": "/companies/westpac-banking",
  "westpac banking": "/companies/westpac-banking",
  westpac: "/companies/westpac-banking",
  "westpac australia": "/companies/westpac-banking",
  "westpac sydney": "/companies/westpac-banking",
  "westpac bank": "/companies/westpac-banking",

  /* retail banking */
  "westpac retail": "/companies/westpac-banking",
  "westpac retail banking": "/companies/westpac-banking",

  /* business banking */
  "westpac business": "/companies/westpac-banking",
  "westpac business banking": "/companies/westpac-banking",

  /* corporate banking */
  "westpac corporate": "/companies/westpac-banking",
  "westpac corporate banking": "/companies/westpac-banking",

  /* wealth management */
  "westpac wealth": "/companies/westpac-banking",
  "westpac wealth management": "/companies/westpac-banking",

  /* mortgage services */
  "westpac mortgage": "/companies/westpac-banking",
  "westpac mortgages": "/companies/westpac-banking",

  /* credit cards */
  "westpac credit cards": "/companies/westpac-banking",
  "westpac cards": "/companies/westpac-banking",

  /* insurance */
  "westpac insurance": "/companies/westpac-banking",
  "westpac insurance products": "/companies/westpac-banking",

  /* ticker lookups */
  "wbc.ax": "/companies/westpac-banking",
  wbc: "/companies/westpac-banking",
  "westpac stock": "/companies/westpac-banking",
  /* westpac-banking */

  /* essilorluxottica */
  essilorluxottica: "/companies/essilorluxottica",
  "essilor luxottica": "/companies/essilorluxottica",
  "essilor-luxottica": "/companies/essilorluxottica",
  "essilor luxottica france": "/companies/essilorluxottica",
  "essilorluxottica france": "/companies/essilorluxottica",
  "essilor charenton": "/companies/essilorluxottica",
  luxottica: "/companies/essilorluxottica",
  essilor: "/companies/essilorluxottica",

  /* eyeglass lenses */
  "essilor lenses": "/companies/essilorluxottica",
  "essilorluxottica lenses": "/companies/essilorluxottica",

  /* sunglasses */
  "luxottica sunglasses": "/companies/essilorluxottica",
  "essilorluxottica sunglasses": "/companies/essilorluxottica",

  /* prescription glasses */
  "essilor prescription": "/companies/essilorluxottica",
  "essilorluxottica prescription": "/companies/essilorluxottica",

  /* contact lenses */
  "essilor contacts": "/companies/essilorluxottica",
  "essilorluxottica contacts": "/companies/essilorluxottica",

  /* optical retail */
  "essilorluxottica retail": "/companies/essilorluxottica",
  "luxottica retail": "/companies/essilorluxottica",
  lenscrafters: "/companies/essilorluxottica",
  "pearle vision": "/companies/essilorluxottica",

  /* vision care */
  "essilor vision": "/companies/essilorluxottica",
  "essilorluxottica vision care": "/companies/essilorluxottica",

  /* luxury eyewear brands */
  "ray-ban": "/companies/essilorluxottica",
  oakley: "/companies/essilorluxottica",
  persol: "/companies/essilorluxottica",
  "oliver peoples": "/companies/essilorluxottica",

  /* ticker lookups */
  "el.pa": "/companies/essilorluxottica",
  el: "/companies/essilorluxottica",
  "essilorluxottica stock": "/companies/essilorluxottica",
  /* essilorluxottica */

  /* itau-unibanco */
  "itau-unibanco": "/companies/itau-unibanco",
  "itaú unibanco": "/companies/itau-unibanco",
  "itau unibanco": "/companies/itau-unibanco",
  itau: "/companies/itau-unibanco",
  "itau bank": "/companies/itau-unibanco",
  "itau brazil": "/companies/itau-unibanco",
  "itau sao paulo": "/companies/itau-unibanco",

  /* retail banking */
  "itau retail": "/companies/itau-unibanco",
  "itau retail banking": "/companies/itau-unibanco",

  /* corporate banking */
  "itau corporate": "/companies/itau-unibanco",
  "itau corporate banking": "/companies/itau-unibanco",

  /* investment banking */
  "itau investment": "/companies/itau-unibanco",
  "itau investment banking": "/companies/itau-unibanco",

  /* credit cards */
  "itau credit cards": "/companies/itau-unibanco",
  "itau cards": "/companies/itau-unibanco",

  /* loans & financing */
  "itau loans": "/companies/itau-unibanco",
  "itau financing": "/companies/itau-unibanco",

  /* insurance */
  "itau insurance": "/companies/itau-unibanco",
  "itau insurance services": "/companies/itau-unibanco",

  /* asset management */
  "itau asset management": "/companies/itau-unibanco",
  "itau investments": "/companies/itau-unibanco",

  /* ticker lookups */
  itub: "/companies/itau-unibanco",
  "itub stock": "/companies/itau-unibanco",
  "itau stock": "/companies/itau-unibanco",
  /* itau-unibanco */
  /* midea */
  midea: "/companies/midea",
  "midea group": "/companies/midea",
  "midea china": "/companies/midea",
  "midea foshan": "/companies/midea",
  "midea guangdong": "/companies/midea",

  /* air conditioners */
  "midea ac": "/companies/midea",
  "midea air conditioners": "/companies/midea",

  /* refrigerators */
  "midea fridge": "/companies/midea",
  "midea refrigerator": "/companies/midea",

  /* washing machines */
  "midea washer": "/companies/midea",
  "midea washing machine": "/companies/midea",

  /* kitchen appliances */
  "midea kitchen": "/companies/midea",
  "midea kitchen appliances": "/companies/midea",

  /* small home appliances */
  "midea appliances": "/companies/midea",
  "midea small appliances": "/companies/midea",

  /* industrial robotics */
  "midea robotics": "/companies/midea",
  kuka: "/companies/midea", // Midea owns KUKA Robotics

  /* hvac systems */
  "midea hvac": "/companies/midea",
  "midea heating": "/companies/midea",
  "midea cooling": "/companies/midea",

  /* ticker lookups */
  "000333.sz": "/companies/midea",
  "000333": "/companies/midea",
  "midea stock": "/companies/midea",
  /* midea */

  /* intercontinental-exchange */
  "intercontinental-exchange": "/companies/intercontinental-exchange",
  "intercontinental exchange": "/companies/intercontinental-exchange",
  ice: "/companies/intercontinental-exchange",
  "ice exchange": "/companies/intercontinental-exchange",
  "ice atlanta": "/companies/intercontinental-exchange",
  "ice georgia": "/companies/intercontinental-exchange",

  /* nyse ownership */
  nyse: "/companies/intercontinental-exchange",
  "new york stock exchange": "/companies/intercontinental-exchange",
  "ice nyse": "/companies/intercontinental-exchange",

  /* financial exchanges */
  "ice exchanges": "/companies/intercontinental-exchange",
  "ice trading": "/companies/intercontinental-exchange",

  /* clearing houses */
  "ice clearing": "/companies/intercontinental-exchange",
  "ice clearing house": "/companies/intercontinental-exchange",

  /* market data */
  "ice data": "/companies/intercontinental-exchange",
  "ice market data": "/companies/intercontinental-exchange",

  /* derivatives trading */
  "ice derivatives": "/companies/intercontinental-exchange",
  "ice futures": "/companies/intercontinental-exchange",
  "ice options": "/companies/intercontinental-exchange",

  /* equities trading */
  "ice equities": "/companies/intercontinental-exchange",
  "ice stock trading": "/companies/intercontinental-exchange",

  /* commodity trading */
  "ice commodities": "/companies/intercontinental-exchange",
  "ice commodity trading": "/companies/intercontinental-exchange",

  /* risk management */
  "ice risk management": "/companies/intercontinental-exchange",
  "ice risk services": "/companies/intercontinental-exchange",

  /* ticker lookups */
  "ice stock": "/companies/intercontinental-exchange",
  /* intercontinental-exchange */
  /* postal-savings-bank-of-china */
  "postal-savings-bank-of-china": "/companies/postal-savings-bank-of-china",
  "postal savings bank of china": "/companies/postal-savings-bank-of-china",
  psbc: "/companies/postal-savings-bank-of-china",
  "psbc china": "/companies/postal-savings-bank-of-china",
  "psbc beijing": "/companies/postal-savings-bank-of-china",
  "china postal bank": "/companies/postal-savings-bank-of-china",

  /* retail banking */
  "psbc retail": "/companies/postal-savings-bank-of-china",
  "psbc retail banking": "/companies/postal-savings-bank-of-china",

  /* savings accounts */
  "psbc savings": "/companies/postal-savings-bank-of-china",
  "psbc savings accounts": "/companies/postal-savings-bank-of-china",

  /* loans & mortgages */
  "psbc loans": "/companies/postal-savings-bank-of-china",
  "psbc mortgages": "/companies/postal-savings-bank-of-china",

  /* sme banking */
  "psbc sme": "/companies/postal-savings-bank-of-china",
  "psbc small business": "/companies/postal-savings-bank-of-china",

  /* rural finance */
  "psbc rural": "/companies/postal-savings-bank-of-china",
  "psbc rural finance": "/companies/postal-savings-bank-of-china",

  /* credit cards */
  "psbc credit cards": "/companies/postal-savings-bank-of-china",
  "psbc cards": "/companies/postal-savings-bank-of-china",

  /* wealth management */
  "psbc wealth": "/companies/postal-savings-bank-of-china",
  "psbc wealth management": "/companies/postal-savings-bank-of-china",

  /* ticker lookups */
  "601658.ss": "/companies/postal-savings-bank-of-china",
  "601658": "/companies/postal-savings-bank-of-china",
  "psbc stock": "/companies/postal-savings-bank-of-china",
  /* postal-savings-bank-of-china */

  /* shin-etsu-chemical */
  "shin-etsu-chemical": "/companies/shin-etsu-chemical",
  "shin etsu chemical": "/companies/shin-etsu-chemical",
  "shin-etsu": "/companies/shin-etsu-chemical",
  "shin etsu": "/companies/shin-etsu-chemical",
  "shin-etsu japan": "/companies/shin-etsu-chemical",
  "shin-etsu tokyo": "/companies/shin-etsu-chemical",

  /* semiconductor silicon wafers */
  "shin-etsu wafers": "/companies/shin-etsu-chemical",
  "shin-etsu silicon": "/companies/shin-etsu-chemical",
  "shin-etsu semiconductor": "/companies/shin-etsu-chemical",

  /* pvc */
  "shin-etsu pvc": "/companies/shin-etsu-chemical",
  "shin-etsu polyvinyl chloride": "/companies/shin-etsu-chemical",

  /* silicones */
  "shin-etsu silicones": "/companies/shin-etsu-chemical",
  "shin-etsu silicone": "/companies/shin-etsu-chemical",

  /* specialty chemicals */
  "shin-etsu specialty chemicals": "/companies/shin-etsu-chemical",
  "shin-etsu chemicals": "/companies/shin-etsu-chemical",

  /* electronic materials */
  "shin-etsu electronic materials": "/companies/shin-etsu-chemical",
  "shin-etsu electronics": "/companies/shin-etsu-chemical",

  /* ticker lookups */
  "4063.t": "/companies/shin-etsu-chemical",
  "4063": "/companies/shin-etsu-chemical",
  "shin-etsu stock": "/companies/shin-etsu-chemical",
  /* shin-etsu-chemical */

  /* caixabank */
  caixabank: "/companies/caixabank",
  "caixa bank": "/companies/caixabank",
  "caixa-bank": "/companies/caixabank",
  "caixabank spain": "/companies/caixabank",
  "caixabank valencia": "/companies/caixabank",

  /* retail banking */
  "caixabank retail": "/companies/caixabank",
  "caixabank retail banking": "/companies/caixabank",

  /* corporate banking */
  "caixabank corporate": "/companies/caixabank",
  "caixabank corporate banking": "/companies/caixabank",

  /* wealth management */
  "caixabank wealth": "/companies/caixabank",
  "caixabank wealth management": "/companies/caixabank",

  /* insurance */
  "caixabank insurance": "/companies/caixabank",
  "caixabank insurance services": "/companies/caixabank",

  /* financial services */
  "caixabank financial services": "/companies/caixabank",
  "caixabank finance": "/companies/caixabank",

  /* ticker lookups */
  "cabk.mc": "/companies/caixabank",
  cabk: "/companies/caixabank",
  "caixabank stock": "/companies/caixabank",
  /* caixabank */

  /* tokio-marine */
  "tokio-marine": "/companies/tokio-marine",
  "tokio marine": "/companies/tokio-marine",
  "tokio marine holdings": "/companies/tokio-marine",
  "tokio marine japan": "/companies/tokio-marine",
  "tokio marine tokyo": "/companies/tokio-marine",

  /* life insurance */
  "tokio marine life": "/companies/tokio-marine",
  "tokio marine life insurance": "/companies/tokio-marine",

  /* property insurance */
  "tokio marine property": "/companies/tokio-marine",
  "tokio marine property insurance": "/companies/tokio-marine",

  /* casualty insurance */
  "tokio marine casualty": "/companies/tokio-marine",
  "tokio marine casualty insurance": "/companies/tokio-marine",

  /* reinsurance */
  "tokio marine reinsurance": "/companies/tokio-marine",
  "tokio marine re": "/companies/tokio-marine",

  /* financial services */
  "tokio marine financial services": "/companies/tokio-marine",
  "tokio marine finance": "/companies/tokio-marine",

  /* ticker lookups */
  "8766.t": "/companies/tokio-marine",
  "8766": "/companies/tokio-marine",
  "tokio marine stock": "/companies/tokio-marine",
  /* tokio-marine */

  /* eoptolink-technology */
  "eoptolink-technology": "/companies/eoptolink-technology",
  eoptolink: "/companies/eoptolink-technology",
  "eoptolink china": "/companies/eoptolink-technology",
  "eoptolink chengdu": "/companies/eoptolink-technology",
  "eoptolink optical": "/companies/eoptolink-technology",
  "eoptolink transceivers": "/companies/eoptolink-technology",
  "eoptolink modules": "/companies/eoptolink-technology",
  "eoptolink fiber": "/companies/eoptolink-technology",
  "eoptolink networking": "/companies/eoptolink-technology",
  "300502.sz": "/companies/eoptolink-technology",
  "300502": "/companies/eoptolink-technology",
  "eoptolink stock": "/companies/eoptolink-technology",
  /* eoptolink-technology */
  /* national-grid */
  "national-grid": "/companies/national-grid",
  nationalgrid: "/companies/national-grid",
  "national grid": "/companies/national-grid",
  "national grid uk": "/companies/national-grid",
  "national grid london": "/companies/national-grid",
  "national grid energy": "/companies/national-grid",
  "national grid electricity": "/companies/national-grid",
  "national grid gas": "/companies/national-grid",
  "national grid utility": "/companies/national-grid",
  "ng.l": "/companies/national-grid",
  ng: "/companies/national-grid",
  "national grid stock": "/companies/national-grid",
  /* national-grid */

  /* bank-of-communications */
  "bank-of-communications": "/companies/bank-of-communications",
  "bank of communications": "/companies/bank-of-communications",
  bocom: "/companies/bank-of-communications",
  "bocom china": "/companies/bank-of-communications",
  "bocom shanghai": "/companies/bank-of-communications",
  bankcomm: "/companies/bank-of-communications",
  "bankcomm china": "/companies/bank-of-communications",
  "bank of communications retail": "/companies/bank-of-communications",
  "bank of communications corporate": "/companies/bank-of-communications",
  "bank of communications wealth": "/companies/bank-of-communications",
  "bank of communications credit cards": "/companies/bank-of-communications",
  "601328.ss": "/companies/bank-of-communications",
  "601328": "/companies/bank-of-communications",
  "bank of communications stock": "/companies/bank-of-communications",
  /* bank-of-communications */

  /* johnson-controls */
  "johnson-controls": "/companies/johnson-controls",
  "johnson controls": "/companies/johnson-controls",
  jci: "/companies/johnson-controls",
  "johnson controls hvac": "/companies/johnson-controls",
  "johnson controls building": "/companies/johnson-controls",
  "johnson controls fire": "/companies/johnson-controls",
  "johnson controls security": "/companies/johnson-controls",
  "johnson controls energy": "/companies/johnson-controls",
  "johnson controls cork": "/companies/johnson-controls",
  "johnson controls ireland": "/companies/johnson-controls",
  "jci stock": "/companies/johnson-controls",
  /* johnson-controls */

  /* ing-group */
  "ing-group": "/companies/ing-group",
  "ing group": "/companies/ing-group",
  ing: "/companies/ing-group",
  "ing bank": "/companies/ing-group",
  "ing netherlands": "/companies/ing-group",
  "ing amsterdam": "/companies/ing-group",
  "ing retail": "/companies/ing-group",
  "ing commercial": "/companies/ing-group",
  "ing investment": "/companies/ing-group",
  "ing asset management": "/companies/ing-group",
  "ing financial services": "/companies/ing-group",
  "ing stock": "/companies/ing-group",
  /* ing-group */

  /* pnc-financial-services */
  "pnc-financial-services": "/companies/pnc-financial-services",
  pnc: "/companies/pnc-financial-services",
  "pnc bank": "/companies/pnc-financial-services",
  "pnc financial": "/companies/pnc-financial-services",
  "pnc financial services": "/companies/pnc-financial-services",
  "pnc pittsburgh": "/companies/pnc-financial-services",
  "pnc pennsylvania": "/companies/pnc-financial-services",
  "pnc retail": "/companies/pnc-financial-services",
  "pnc corporate": "/companies/pnc-financial-services",
  "pnc asset management": "/companies/pnc-financial-services",
  "pnc mortgage": "/companies/pnc-financial-services",
  "pnc stock": "/companies/pnc-financial-services",
  /* pnc-financial-services */

  /* waste-management */
  "waste-management": "/companies/waste-management",
  "waste management": "/companies/waste-management",
  wm: "/companies/waste-management",
  "wm waste": "/companies/waste-management",
  "wm recycling": "/companies/waste-management",
  "wm landfill": "/companies/waste-management",
  "wm environmental": "/companies/waste-management",
  "wm sustainability": "/companies/waste-management",
  "waste management houston": "/companies/waste-management",
  "wm texas": "/companies/waste-management",
  "wm stock": "/companies/waste-management",
  /* waste-management */

  /* united-parcel-service */
  "united-parcel-service": "/companies/united-parcel-service",
  "united parcel service": "/companies/united-parcel-service",
  // ups: "/companies/united-parcel-service",
  "ups delivery": "/companies/united-parcel-service",
  "ups logistics": "/companies/united-parcel-service",
  "ups shipping": "/companies/united-parcel-service",
  "ups atlanta": "/companies/united-parcel-service",
  "ups georgia": "/companies/united-parcel-service",
  "ups stock": "/companies/united-parcel-service",
  // spot: "/companies/united-parcel-service",
  /* united-parcel-service */

  /* automatic-data-processing */
  "automatic-data-processing": "/companies/automatic-data-processing",
  adp: "/companies/automatic-data-processing",
  "adp payroll": "/companies/automatic-data-processing",
  "adp hcm": "/companies/automatic-data-processing",
  "adp hr": "/companies/automatic-data-processing",
  "adp talent": "/companies/automatic-data-processing",
  "adp benefits": "/companies/automatic-data-processing",
  "adp new jersey": "/companies/automatic-data-processing",
  "adp roseland": "/companies/automatic-data-processing",
  "adp stock": "/companies/automatic-data-processing",
  /* automatic-data-processing */

  /* us-bancorp */
  "us-bancorp": "/companies/us-bancorp",
  "u.s. bancorp": "/companies/us-bancorp",
  "us bancorp": "/companies/us-bancorp",
  usbank: "/companies/us-bancorp",
  "us bank": "/companies/us-bancorp",
  "u.s. bank": "/companies/us-bancorp",
  "us bank minneapolis": "/companies/us-bancorp",
  "us bancorp minnesota": "/companies/us-bancorp",
  "us bancorp retail": "/companies/us-bancorp",
  "us bancorp commercial": "/companies/us-bancorp",
  "us bancorp investment": "/companies/us-bancorp",
  "us bancorp mortgage": "/companies/us-bancorp",
  "us bancorp payments": "/companies/us-bancorp",
  usb: "/companies/us-bancorp",
  "usb stock": "/companies/us-bancorp",
  "us bancorp stock": "/companies/us-bancorp",
  /* us-bancorp */

  /* monster-beverage */
  "monster-beverage": "/companies/monster-beverage",
  "monster beverage": "/companies/monster-beverage",
  monster: "/companies/monster-beverage",
  "monster energy": "/companies/monster-beverage",
  "monster drinks": "/companies/monster-beverage",
  "monster corona": "/companies/monster-beverage",
  "monster california": "/companies/monster-beverage",
  mnst: "/companies/monster-beverage",
  "mnst stock": "/companies/monster-beverage",
  "monster beverage stock": "/companies/monster-beverage",
  /* monster-beverage */

  /* atlas-copco */
  "atlas-copco": "/companies/atlas-copco",
  "atlas copco": "/companies/atlas-copco",
  atlascopco: "/companies/atlas-copco",
  "atlas copco sweden": "/companies/atlas-copco",
  "atlas copco nacka": "/companies/atlas-copco",
  "atlas copco compressors": "/companies/atlas-copco",
  "atlas copco vacuum": "/companies/atlas-copco",
  "atlas copco tools": "/companies/atlas-copco",
  "atlas copco power": "/companies/atlas-copco",
  "atco-b.st": "/companies/atlas-copco",
  "atlas copco stock": "/companies/atlas-copco",
  /* atlas-copco */

  /* mitsubishi-electric */
  "mitsubishi-electric": "/companies/mitsubishi-electric",
  "mitsubishi electric": "/companies/mitsubishi-electric",
  mitsubishielectric: "/companies/mitsubishi-electric",
  "mitsubishi electric japan": "/companies/mitsubishi-electric",
  "mitsubishi electric tokyo": "/companies/mitsubishi-electric",
  "mitsubishi electric automation": "/companies/mitsubishi-electric",
  "mitsubishi electric power": "/companies/mitsubishi-electric",
  "mitsubishi electric hvac": "/companies/mitsubishi-electric",
  "mitsubishi electric semiconductors": "/companies/mitsubishi-electric",
  "6503.t": "/companies/mitsubishi-electric",
  "mitsubishi electric stock": "/companies/mitsubishi-electric",
  /* mitsubishi-electric */

  /* csx-corporation */
  "csx-corporation": "/companies/csx-corporation",
  "csx corporation": "/companies/csx-corporation",
  csx: "/companies/csx-corporation",
  "csx rail": "/companies/csx-corporation",
  "csx freight": "/companies/csx-corporation",
  "csx transportation": "/companies/csx-corporation",
  "csx logistics": "/companies/csx-corporation",
  "csx intermodal": "/companies/csx-corporation",
  "csx jacksonville": "/companies/csx-corporation",
  "csx florida": "/companies/csx-corporation",
  "csx stock": "/companies/csx-corporation",
  /* csx-corporation */

  /* elevance-health */
  "elevance-health": "/companies/elevance-health",
  "elevance health": "/companies/elevance-health",
  elevance: "/companies/elevance-health",
  "elevance insurance": "/companies/elevance-health",
  "elevance healthcare": "/companies/elevance-health",
  "elevance managed care": "/companies/elevance-health",
  "elevance medicare": "/companies/elevance-health",
  "elevance medicaid": "/companies/elevance-health",
  "elevance indianapolis": "/companies/elevance-health",
  "elevance indiana": "/companies/elevance-health",
  elv: "/companies/elevance-health",
  "elv stock": "/companies/elevance-health",
  "elevance stock": "/companies/elevance-health",
  /* elevance-health */

  /* national-australia-bank */
  "national-australia-bank": "/companies/national-australia-bank",
  "national australia bank": "/companies/national-australia-bank",
  nab: "/companies/national-australia-bank",
  "nab bank": "/companies/national-australia-bank",
  "nab australia": "/companies/national-australia-bank",
  "nab melbourne": "/companies/national-australia-bank",
  "nab personal banking": "/companies/national-australia-bank",
  "nab business banking": "/companies/national-australia-bank",
  "nab corporate banking": "/companies/national-australia-bank",
  "nab loans": "/companies/national-australia-bank",
  "nab mortgages": "/companies/national-australia-bank",
  "nab credit cards": "/companies/national-australia-bank",
  "nab.ax": "/companies/national-australia-bank",
  "nab stock": "/companies/national-australia-bank",
  /* national-australia-bank */
  /* enterprise-products */
  "enterprise-products": "/companies/enterprise-products",
  "enterprise products": "/companies/enterprise-products",
  epp: "/companies/enterprise-products",
  epd: "/companies/enterprise-products",
  "epd stock": "/companies/enterprise-products",
  "enterprise pipelines": "/companies/enterprise-products",
  "enterprise midstream": "/companies/enterprise-products",
  "enterprise ngl": "/companies/enterprise-products",
  "enterprise petrochemical": "/companies/enterprise-products",
  "enterprise houston": "/companies/enterprise-products",
  "enterprise texas": "/companies/enterprise-products",
  /* enterprise-products */

  /* american-tower */
  "american-tower": "/companies/american-tower",
  "american tower": "/companies/american-tower",
  americantower: "/companies/american-tower",
  "american tower reit": "/companies/american-tower",
  "american tower infrastructure": "/companies/american-tower",
  "american tower wireless": "/companies/american-tower",
  "american tower antennas": "/companies/american-tower",
  "american tower boston": "/companies/american-tower",
  "american tower massachusetts": "/companies/american-tower",
  amt: "/companies/american-tower",
  "amt stock": "/companies/american-tower",
  "american tower stock": "/companies/american-tower",
  /* american-tower */

  /* slb */
  slb: "/companies/slb",
  "slb schlumberger": "/companies/slb",
  schlumberger: "/companies/slb",
  "slb oilfield": "/companies/slb",
  "slb drilling": "/companies/slb",
  "slb reservoir": "/companies/slb",
  "slb production": "/companies/slb",
  "slb houston": "/companies/slb",
  "slb texas": "/companies/slb",
  "slb energy": "/companies/slb",
  "slb technology": "/companies/slb",
  "slb stock": "/companies/slb",
  /* slb */

  /* chugai-pharmaceutical */
  "chugai-pharmaceutical": "/companies/chugai-pharmaceutical",
  "chugai pharmaceutical": "/companies/chugai-pharmaceutical",
  chugai: "/companies/chugai-pharmaceutical",
  "chugai pharma": "/companies/chugai-pharmaceutical",
  "chugai oncology": "/companies/chugai-pharmaceutical",
  "chugai immunology": "/companies/chugai-pharmaceutical",
  "chugai rare diseases": "/companies/chugai-pharmaceutical",
  "chugai tokyo": "/companies/chugai-pharmaceutical",
  "chugai japan": "/companies/chugai-pharmaceutical",
  "4519.t": "/companies/chugai-pharmaceutical",
  "chugai stock": "/companies/chugai-pharmaceutical",
  /* chugai-pharmaceutical */

  /* america-movil */
  "america-movil": "/companies/america-movil",
  "america movil": "/companies/america-movil",
  americamovil: "/companies/america-movil",
  "america movil telecom": "/companies/america-movil",
  "america movil mobile": "/companies/america-movil",
  "america movil broadband": "/companies/america-movil",
  "america movil mexico": "/companies/america-movil",
  "america movil mexico city": "/companies/america-movil",
  amx: "/companies/america-movil",
  "amx stock": "/companies/america-movil",
  "america movil stock": "/companies/america-movil",
  /* america-movil */

  /* engie */
  engie: "/companies/engie",
  "engie france": "/companies/engie",
  "engie courbevoie": "/companies/engie",
  "engie energy": "/companies/engie",
  "engie electricity": "/companies/engie",
  "engie gas": "/companies/engie",
  "engie renewables": "/companies/engie",
  "engie infrastructure": "/companies/engie",
  "engi.pa": "/companies/engie",
  "engie stock": "/companies/engie",
  /* engie */

  /* boston-scientific */
  "boston-scientific": "/companies/boston-scientific",
  "boston scientific": "/companies/boston-scientific",
  bostonscientific: "/companies/boston-scientific",
  "boston sci": "/companies/boston-scientific",
  "boston scientific cardiology": "/companies/boston-scientific",
  "boston scientific endoscopy": "/companies/boston-scientific",
  "boston scientific urology": "/companies/boston-scientific",
  "boston scientific neuromodulation": "/companies/boston-scientific",
  "boston scientific implants": "/companies/boston-scientific",
  "boston scientific marlborough": "/companies/boston-scientific",
  bsx: "/companies/boston-scientific",
  "bsx stock": "/companies/boston-scientific",
  /* boston-scientific */

  /* moodys */
  moodys: "/companies/moodys",
  "moody's": "/companies/moodys",
  "moodys ratings": "/companies/moodys",
  "moodys credit": "/companies/moodys",
  "moodys research": "/companies/moodys",
  "moodys analytics": "/companies/moodys",
  "moodys new york": "/companies/moodys",
  mco: "/companies/moodys",
  "mco stock": "/companies/moodys",
  "moodys stock": "/companies/moodys",
  /* moodys */

  /* marsh-mclennan */
  "marsh-mclennan": "/companies/marsh-mclennan",
  "marsh & mclennan": "/companies/marsh-mclennan",
  "marsh and mclennan": "/companies/marsh-mclennan",
  marshmclennan: "/companies/marsh-mclennan",
  "marsh mclennan consulting": "/companies/marsh-mclennan",
  "marsh mclennan insurance": "/companies/marsh-mclennan",
  "marsh mclennan risk": "/companies/marsh-mclennan",
  "marsh mclennan reinsurance": "/companies/marsh-mclennan",
  "marsh mclennan new york": "/companies/marsh-mclennan",
  mmc: "/companies/marsh-mclennan",
  "mmc stock": "/companies/marsh-mclennan",
  "marsh mclennan stock": "/companies/marsh-mclennan",
  /* marsh-mclennan */

  /* ocbc-bank */
  "ocbc-bank": "/companies/ocbc-bank",
  "ocbc bank": "/companies/ocbc-bank",
  ocbc: "/companies/ocbc-bank",
  "ocbc singapore": "/companies/ocbc-bank",
  "ocbc retail banking": "/companies/ocbc-bank",
  "ocbc corporate banking": "/companies/ocbc-bank",
  "ocbc wealth management": "/companies/ocbc-bank",
  "ocbc insurance": "/companies/ocbc-bank",
  "ocbc investment banking": "/companies/ocbc-bank",
  "o39.si": "/companies/ocbc-bank",
  "ocbc stock": "/companies/ocbc-bank",
  /* ocbc-bank */

  /* mercadolibre */
  mercadolibre: "/companies/mercadolibre",
  "mercado libre": "/companies/mercadolibre",
  "mercado-libre": "/companies/mercadolibre",
  meli: "/companies/mercadolibre",
  "meli stock": "/companies/mercadolibre",
  "mercadolibre stock": "/companies/mercadolibre",
  "mercadolibre ecommerce": "/companies/mercadolibre",
  "mercadolibre payments": "/companies/mercadolibre",
  "mercado pago": "/companies/mercadolibre",
  "mercadolibre logistics": "/companies/mercadolibre",
  "mercadolibre argentina": "/companies/mercadolibre",
  /* mercadolibre */

  /* smic */
  smic: "/companies/smic",
  "smic china": "/companies/smic",
  "smic shanghai": "/companies/smic",
  "smic semiconductor": "/companies/smic",
  "smic foundry": "/companies/smic",
  "smic chips": "/companies/smic",
  "smic wafer": "/companies/smic",
  "0981.hk": "/companies/smic",
  "smic stock": "/companies/smic",
  /* smic */

  /* suncor-energy */
  "suncor-energy": "/companies/suncor-energy",
  "suncor energy": "/companies/suncor-energy",
  suncor: "/companies/suncor-energy",
  "suncor canada": "/companies/suncor-energy",
  "suncor calgary": "/companies/suncor-energy",
  "suncor oil sands": "/companies/suncor-energy",
  "suncor refining": "/companies/suncor-energy",
  "suncor renewable energy": "/companies/suncor-energy",
  // su: "/companies/suncor-energy",
  // "su stock": "/companies/suncor-energy",
  "suncor stock": "/companies/suncor-energy",
  /* suncor-energy */

  /* simon-property-group */
  "simon-property-group": "/companies/simon-property-group",
  "simon property group": "/companies/simon-property-group",
  simon: "/companies/simon-property-group",
  "simon malls": "/companies/simon-property-group",
  "simon outlets": "/companies/simon-property-group",
  "simon premium outlets": "/companies/simon-property-group",
  "simon real estate": "/companies/simon-property-group",
  "simon reit": "/companies/simon-property-group",
  "simon indianapolis": "/companies/simon-property-group",
  spg: "/companies/simon-property-group",
  "spg stock": "/companies/simon-property-group",
  "simon property stock": "/companies/simon-property-group",
  /* simon-property-group */

  /* ciena */
  ciena: "/companies/ciena",
  "ciena corp": "/companies/ciena",
  "ciena corporation": "/companies/ciena",
  "ciena networking": "/companies/ciena",
  "ciena optical": "/companies/ciena",
  "ciena telecom": "/companies/ciena",
  "ciena hanover": "/companies/ciena",
  cien: "/companies/ciena",
  "cien stock": "/companies/ciena",
  /* ciena */

  /* the-cigna-group */
  "the-cigna-group": "/companies/the-cigna-group",
  "the cigna group": "/companies/the-cigna-group",
  cigna: "/companies/the-cigna-group",
  "cigna health": "/companies/the-cigna-group",
  "cigna insurance": "/companies/the-cigna-group",
  "cigna healthcare": "/companies/the-cigna-group",
  "cigna bloomfield": "/companies/the-cigna-group",
  ci: "/companies/the-cigna-group",
  "ci stock": "/companies/the-cigna-group",
  "cigna stock": "/companies/the-cigna-group",
  /* the-cigna-group */

  /* ntt */
  ntt: "/companies/ntt",
  "ntt japan": "/companies/ntt",
  "nippon telegraph": "/companies/ntt",
  "nippon telegraph & telephone": "/companies/ntt",
  "ntt telecom": "/companies/ntt",
  "ntt tokyo": "/companies/ntt",
  "ntt data center": "/companies/ntt",
  "9432.t": "/companies/ntt",
  "ntt stock": "/companies/ntt",
  /* ntt */

  /* sherwin-williams */
  "sherwin-williams": "/companies/sherwin-williams",
  "sherwin williams": "/companies/sherwin-williams",
  sherwin: "/companies/sherwin-williams",
  "sw paint": "/companies/sherwin-williams",
  "sherwin paints": "/companies/sherwin-williams",
  "sherwin coatings": "/companies/sherwin-williams",
  "sherwin industrial": "/companies/sherwin-williams",
  "sherwin cleveland": "/companies/sherwin-williams",
  shw: "/companies/sherwin-williams",
  "shw stock": "/companies/sherwin-williams",
  "sherwin williams stock": "/companies/sherwin-williams",
  /* sherwin-williams */

  /* bae-systems */
  "bae-systems": "/companies/bae-systems",
  "bae systems": "/companies/bae-systems",
  bae: "/companies/bae-systems",
  "bae defense": "/companies/bae-systems",
  "bae aerospace": "/companies/bae-systems",
  "bae naval": "/companies/bae-systems",
  "bae cybersecurity": "/companies/bae-systems",
  "bae london": "/companies/bae-systems",
  "ba.l": "/companies/bae-systems",
  "bae stock": "/companies/bae-systems",
  /* bae-systems */

  /* oreilly-automotive */
  "oreilly-automotive": "/companies/oreilly-automotive",
  "o'reilly automotive": "/companies/oreilly-automotive",
  "oreilly auto": "/companies/oreilly-automotive",
  "oreilly auto parts": "/companies/oreilly-automotive",
  "oreilly parts": "/companies/oreilly-automotive",
  "oreilly springfield": "/companies/oreilly-automotive",
  "oreilly tools": "/companies/oreilly-automotive",
  orly: "/companies/oreilly-automotive",
  "orly stock": "/companies/oreilly-automotive",
  "oreilly stock": "/companies/oreilly-automotive",
  /* oreilly-automotive */

  /* anz-bank */
  "anz-bank": "/companies/anz-bank",
  "anz bank": "/companies/anz-bank",
  anz: "/companies/anz-bank",
  "anz australia": "/companies/anz-bank",
  "anz melbourne": "/companies/anz-bank",
  "anz retail banking": "/companies/anz-bank",
  "anz commercial banking": "/companies/anz-bank",
  "anz institutional": "/companies/anz-bank",
  "anz home loans": "/companies/anz-bank",
  "anz credit cards": "/companies/anz-bank",
  "anz.ax": "/companies/anz-bank",
  "anz stock": "/companies/anz-bank",
  /* anz-bank */
  /* canadian-pacific-kansas-city */
  "canadian-pacific-kansas-city": "/companies/canadian-pacific-kansas-city",
  "canadian pacific kansas city": "/companies/canadian-pacific-kansas-city",
  cpkc: "/companies/canadian-pacific-kansas-city",
  "cpkc rail": "/companies/canadian-pacific-kansas-city",
  "cpkc railway": "/companies/canadian-pacific-kansas-city",
  "canadian pacific": "/companies/canadian-pacific-kansas-city",
  "kansas city southern": "/companies/canadian-pacific-kansas-city",
  "cp rail": "/companies/canadian-pacific-kansas-city",
  "cross-border rail": "/companies/canadian-pacific-kansas-city",
  cp: "/companies/canadian-pacific-kansas-city",
  "cp stock": "/companies/canadian-pacific-kansas-city",
  /* canadian-pacific-kansas-city */
  /* bloom-energy */
  "bloom-energy": "/companies/bloom-energy",
  "bloom energy": "/companies/bloom-energy",
  bloom: "/companies/bloom-energy",
  "bloom fuel cells": "/companies/bloom-energy",
  "bloom power": "/companies/bloom-energy",
  "bloom hydrogen": "/companies/bloom-energy",
  "bloom san jose": "/companies/bloom-energy",
  be: "/companies/bloom-energy",
  "be stock": "/companies/bloom-energy",
  "bloom energy stock": "/companies/bloom-energy",
  /* bloom-energy */

  /* emerson */
  emerson: "/companies/emerson",
  "emerson electric": "/companies/emerson",
  "emerson electric co": "/companies/emerson",
  "emerson automation": "/companies/emerson",
  "emerson climate": "/companies/emerson",
  "emerson process control": "/companies/emerson",
  "emerson st louis": "/companies/emerson",
  emr: "/companies/emerson",
  "emr stock": "/companies/emerson",
  "emerson stock": "/companies/emerson",
  /* emerson */

  /* monolithic-power-systems */
  "monolithic-power-systems": "/companies/monolithic-power-systems",
  "monolithic power systems": "/companies/monolithic-power-systems",
  mps: "/companies/monolithic-power-systems",
  "mps semiconductors": "/companies/monolithic-power-systems",
  "mps power": "/companies/monolithic-power-systems",
  "mps ic": "/companies/monolithic-power-systems",
  "monolithic power": "/companies/monolithic-power-systems",
  "mps kirkland": "/companies/monolithic-power-systems",
  mpwr: "/companies/monolithic-power-systems",
  "mpwr stock": "/companies/monolithic-power-systems",
  /* monolithic-power-systems */

  /* barrick-gold */
  "barrick-gold": "/companies/barrick-gold",
  "barrick gold": "/companies/barrick-gold",
  barrick: "/companies/barrick-gold",
  "barrick mining": "/companies/barrick-gold",
  "barrick gold mining": "/companies/barrick-gold",
  "barrick copper": "/companies/barrick-gold",
  "barrick toronto": "/companies/barrick-gold",
  b: "/companies/barrick-gold",
  "b stock": "/companies/barrick-gold",
  "barrick stock": "/companies/barrick-gold",
  /* barrick-gold */

  /* lloyds-banking-group */
  "lloyds-banking-group": "/companies/lloyds-banking-group",
  "lloyds banking group": "/companies/lloyds-banking-group",
  lloyds: "/companies/lloyds-banking-group",
  "lloyds bank": "/companies/lloyds-banking-group",
  "lloyds uk": "/companies/lloyds-banking-group",
  "lloyds london": "/companies/lloyds-banking-group",
  "lloyds retail banking": "/companies/lloyds-banking-group",
  "lloyds commercial banking": "/companies/lloyds-banking-group",
  lyg: "/companies/lloyds-banking-group",
  "lyg stock": "/companies/lloyds-banking-group",
  "lloyds stock": "/companies/lloyds-banking-group",
  /* lloyds-banking-group */

  /* regeneron-pharmaceuticals */
  "regeneron-pharmaceuticals": "/companies/regeneron-pharmaceuticals",
  "regeneron pharmaceuticals": "/companies/regeneron-pharmaceuticals",
  regeneron: "/companies/regeneron-pharmaceuticals",
  "regeneron biotech": "/companies/regeneron-pharmaceuticals",
  "regeneron medicine": "/companies/regeneron-pharmaceuticals",
  "regeneron immunology": "/companies/regeneron-pharmaceuticals",
  "regeneron oncology": "/companies/regeneron-pharmaceuticals",
  "regeneron tarrytown": "/companies/regeneron-pharmaceuticals",
  regn: "/companies/regeneron-pharmaceuticals",
  "regn stock": "/companies/regeneron-pharmaceuticals",
  "regeneron stock": "/companies/regeneron-pharmaceuticals",
  /* regeneron-pharmaceuticals */

  /* nokia */
  nokia: "/companies/nokia",
  "nokia corporation": "/companies/nokia",
  "nokia telecom": "/companies/nokia",
  "nokia networks": "/companies/nokia",
  "nokia 5g": "/companies/nokia",
  "nokia espoo": "/companies/nokia",
  "nokia finland": "/companies/nokia",
  nok: "/companies/nokia",
  "nok stock": "/companies/nokia",
  "nokia stock": "/companies/nokia",
  /* nokia */
  /* lumentum-holdings */
  "lumentum-holdings": "/companies/lumentum-holdings",
  "lumentum holdings": "/companies/lumentum-holdings",
  lumentum: "/companies/lumentum-holdings",
  "lumentum lasers": "/companies/lumentum-holdings",
  "lumentum photonics": "/companies/lumentum-holdings",
  "lumentum optical": "/companies/lumentum-holdings",
  "lumentum san jose": "/companies/lumentum-holdings",
  lite: "/companies/lumentum-holdings",
  "lite stock": "/companies/lumentum-holdings",
  "lumentum stock": "/companies/lumentum-holdings",
  /* lumentum-holdings */

  /* coherent-corp */
  "coherent-corp": "/companies/coherent-corp",
  "coherent corp": "/companies/coherent-corp",
  coherent: "/companies/coherent-corp",
  "coherent lasers": "/companies/coherent-corp",
  "coherent photonics": "/companies/coherent-corp",
  "coherent optical": "/companies/coherent-corp",
  "coherent saxonburg": "/companies/coherent-corp",
  cohr: "/companies/coherent-corp",
  "cohr stock": "/companies/coherent-corp",
  "coherent stock": "/companies/coherent-corp",
  /* coherent-corp */
  /* ase-technology-holding */
  "ase-technology-holding": "/companies/ase-technology-holding",
  "ase technology holding": "/companies/ase-technology-holding",
  ase: "/companies/ase-technology-holding",
  "ase semiconductors": "/companies/ase-technology-holding",
  "ase packaging": "/companies/ase-technology-holding",
  "ase testing": "/companies/ase-technology-holding",
  "ase kaohsiung": "/companies/ase-technology-holding",
  asx: "/companies/ase-technology-holding",
  "asx stock": "/companies/ase-technology-holding",
  "ase stock": "/companies/ase-technology-holding",
  /* ase-technology-holding */
  /* marubeni-corporation */
  "marubeni-corporation": "/companies/marubeni-corporation",
  "marubeni corporation": "/companies/marubeni-corporation",
  marubeni: "/companies/marubeni-corporation",
  "marubeni tokyo": "/companies/marubeni-corporation",
  "marubeni trading": "/companies/marubeni-corporation",
  "marubeni energy": "/companies/marubeni-corporation",
  "marubeni metals": "/companies/marubeni-corporation",
  "marubeni food": "/companies/marubeni-corporation",
  "8002.t": "/companies/marubeni-corporation",
  "marubeni stock": "/companies/marubeni-corporation",
  /* marubeni-corporation */
  /* the-saudi-national-bank */
  "the-saudi-national-bank": "/companies/the-saudi-national-bank",
  "saudi national bank": "/companies/the-saudi-national-bank",
  snb: "/companies/the-saudi-national-bank",
  "al ahli bank": "/companies/the-saudi-national-bank",
  "alahli bank": "/companies/the-saudi-national-bank",
  "alahli saudi": "/companies/the-saudi-national-bank",
  "saudi retail banking": "/companies/the-saudi-national-bank",
  "saudi corporate banking": "/companies/the-saudi-national-bank",
  "1180.sr": "/companies/the-saudi-national-bank",
  "snb stock": "/companies/the-saudi-national-bank",
  /* the-saudi-national-bank */

  /* nordea-bank */
  "nordea-bank": "/companies/nordea-bank",
  "nordea bank": "/companies/nordea-bank",
  nordea: "/companies/nordea-bank",
  "nordea finland": "/companies/nordea-bank",
  "nordea helsinki": "/companies/nordea-bank",
  "nordea nordic": "/companies/nordea-bank",
  "nordea retail banking": "/companies/nordea-bank",
  "nordea corporate banking": "/companies/nordea-bank",
  "nda-fi": "/companies/nordea-bank",
  "nordea stock": "/companies/nordea-bank",
  /* nordea-bank */
  /* merck-kgaa */
  "merck-kgaa": "/companies/merck-kgaa",
  "merck kgaa": "/companies/merck-kgaa",
  "merck germany": "/companies/merck-kgaa",
  "merck darmstadt": "/companies/merck-kgaa",
  "merck life science": "/companies/merck-kgaa",
  "merck electronics": "/companies/merck-kgaa",
  "merck biotech": "/companies/merck-kgaa",
  "mrk.de": "/companies/merck-kgaa",
  "merck kgaa stock": "/companies/merck-kgaa",
  "mrk.de stock": "/companies/merck-kgaa",
  /* merck-kgaa */
  /* keysight-technologies */
  "keysight-technologies": "/companies/keysight-technologies",
  "keysight technologies": "/companies/keysight-technologies",
  keysight: "/companies/keysight-technologies",
  "keysight test equipment": "/companies/keysight-technologies",
  "keysight measurement": "/companies/keysight-technologies",
  "keysight oscilloscopes": "/companies/keysight-technologies",
  "keysight network analyzers": "/companies/keysight-technologies",
  "keysight santa rosa": "/companies/keysight-technologies",
  keys: "/companies/keysight-technologies",
  "keys stock": "/companies/keysight-technologies",
  "keysight stock": "/companies/keysight-technologies",
  /* keysight-technologies */
  /* naura-technology-group */
  "naura-technology-group": "/companies/naura-technology-group",
  "naura technology group": "/companies/naura-technology-group",
  naura: "/companies/naura-technology-group",
  "naura semiconductors": "/companies/naura-technology-group",
  "naura equipment": "/companies/naura-technology-group",
  "naura etching": "/companies/naura-technology-group",
  "naura deposition": "/companies/naura-technology-group",
  "naura beijing": "/companies/naura-technology-group",
  "002371.sz": "/companies/naura-technology-group",
  "naura stock": "/companies/naura-technology-group",
  /* naura-technology-group */
  /* sumitomo-electric-industries */
  "sumitomo-electric-industries": "/companies/sumitomo-electric-industries",
  "sumitomo electric industries": "/companies/sumitomo-electric-industries",
  sumitomo: "/companies/sumitomo-electric-industries",
  "sumitomo electric": "/companies/sumitomo-electric-industries",
  "sumitomo wires": "/companies/sumitomo-electric-industries",
  "sumitomo cables": "/companies/sumitomo-electric-industries",
  "sumitomo optical fiber": "/companies/sumitomo-electric-industries",
  "sumitomo osaka": "/companies/sumitomo-electric-industries",
  "5802.t": "/companies/sumitomo-electric-industries",
  "sumitomo stock": "/companies/sumitomo-electric-industries",
  /* sumitomo-electric-industries */
  /* nu-holdings */
  "nu-holdings": "/companies/nu-holdings",
  "nu holdings": "/companies/nu-holdings",
  nubank: "/companies/nu-holdings",
  "nu bank": "/companies/nu-holdings",
  "nubank brazil": "/companies/nu-holdings",
  "nu fintech": "/companies/nu-holdings",
  "nu digital banking": "/companies/nu-holdings",
  "nu sao paulo": "/companies/nu-holdings",
  nu: "/companies/nu-holdings",
  "nu stock": "/companies/nu-holdings",
  "nubank stock": "/companies/nu-holdings",
  /* nu-holdings */
  /* strategy-microstrategy */
  "strategy-microstrategy": "/companies/strategy-microstrategy",
  "strategy (microstrategy)": "/companies/strategy-microstrategy",
  microstrategy: "/companies/strategy-microstrategy",
  "strategy analytics": "/companies/strategy-microstrategy",
  "strategy bi": "/companies/strategy-microstrategy",
  "microstrategy bitcoin": "/companies/strategy-microstrategy",
  "strategy bitcoin": "/companies/strategy-microstrategy",
  "strategy tysons": "/companies/strategy-microstrategy",
  mstr: "/companies/strategy-microstrategy",
  "mstr stock": "/companies/strategy-microstrategy",
  "microstrategy stock": "/companies/strategy-microstrategy",
  /* strategy-microstrategy */

  /* singtel */
  singtel: "/companies/singtel",
  "singtel (singapore telecommunications limited)": "/companies/singtel",
  "singapore telecommunications": "/companies/singtel",
  "singtel mobile": "/companies/singtel",
  "singtel broadband": "/companies/singtel",
  "singtel digital": "/companies/singtel",
  "singtel singapore": "/companies/singtel",
  "z74.si": "/companies/singtel",
  "singtel stock": "/companies/singtel",
  /* singtel */

  /* republic-services */
  "republic-services": "/companies/republic-services",
  "republic services": "/companies/republic-services",
  republic: "/companies/republic-services",
  "republic waste": "/companies/republic-services",
  "republic recycling": "/companies/republic-services",
  "republic landfill": "/companies/republic-services",
  "republic environmental": "/companies/republic-services",
  "republic phoenix": "/companies/republic-services",
  rsg: "/companies/republic-services",
  "rsg stock": "/companies/republic-services",
  "republic services stock": "/companies/republic-services",
  /* republic-services */
  /* kddi-corporation */
  "kddi-corporation": "/companies/kddi-corporation",
  "kddi corporation": "/companies/kddi-corporation",
  kddi: "/companies/kddi-corporation",
  "kddi telecom": "/companies/kddi-corporation",
  "au kddi": "/companies/kddi-corporation",
  "kddi mobile": "/companies/kddi-corporation",
  "kddi broadband": "/companies/kddi-corporation",
  "kddi tokyo": "/companies/kddi-corporation",
  "9433.t": "/companies/kddi-corporation",
  "kddi stock": "/companies/kddi-corporation",
  /* kddi-corporation */

  /* the-travelers-companies */
  "the-travelers-companies": "/companies/the-travelers-companies",
  "travelers companies": "/companies/the-travelers-companies",
  travelers: "/companies/the-travelers-companies",
  "travelers insurance": "/companies/the-travelers-companies",
  "travelers auto": "/companies/the-travelers-companies",
  "travelers home": "/companies/the-travelers-companies",
  "travelers commercial": "/companies/the-travelers-companies",
  "travelers nyc": "/companies/the-travelers-companies",
  trv: "/companies/the-travelers-companies",
  "trv stock": "/companies/the-travelers-companies",
  "travelers stock": "/companies/the-travelers-companies",
  /* the-travelers-companies */

  /* vingroup */
  vingroup: "/companies/vingroup",
  "vin group": "/companies/vingroup",
  "vingroup vietnam": "/companies/vingroup",
  "vingroup hanoi": "/companies/vingroup",
  "vinfast parent": "/companies/vingroup",
  "vingroup real estate": "/companies/vingroup",
  "vingroup retail": "/companies/vingroup",
  "vic.vn": "/companies/vingroup",
  "vic stock": "/companies/vingroup",
  "vingroup stock": "/companies/vingroup",
  /* vingroup */

  /* japan-post-bank */
  "japan-post-bank": "/companies/japan-post-bank",
  "japan post bank": "/companies/japan-post-bank",
  "jp bank": "/companies/japan-post-bank",
  "japanpost bank": "/companies/japan-post-bank",
  "japan post tokyo": "/companies/japan-post-bank",
  "japan post savings": "/companies/japan-post-bank",
  "japan post financial": "/companies/japan-post-bank",
  "7182.t": "/companies/japan-post-bank",
  "japan post bank stock": "/companies/japan-post-bank",
  "7182 stock": "/companies/japan-post-bank",
  /* japan-post-bank */

  /* wheaton-precious-metals */
  "wheaton-precious-metals": "/companies/wheaton-precious-metals",
  "wheaton precious metals": "/companies/wheaton-precious-metals",
  wheaton: "/companies/wheaton-precious-metals",
  "wheaton pm": "/companies/wheaton-precious-metals",
  "wheaton silver": "/companies/wheaton-precious-metals",
  "wheaton gold": "/companies/wheaton-precious-metals",
  "wheaton streaming": "/companies/wheaton-precious-metals",
  "wheaton vancouver": "/companies/wheaton-precious-metals",
  wpm: "/companies/wheaton-precious-metals",
  "wpm stock": "/companies/wheaton-precious-metals",
  "wheaton stock": "/companies/wheaton-precious-metals",
  /* wheaton-precious-metals */

  /* baker-hughes */
  "baker-hughes": "/companies/baker-hughes",
  "baker hughes": "/companies/baker-hughes",
  "baker hughes company": "/companies/baker-hughes",
  "baker hughes energy": "/companies/baker-hughes",
  "baker hughes oilfield": "/companies/baker-hughes",
  "baker hughes drilling": "/companies/baker-hughes",
  "baker hughes houston": "/companies/baker-hughes",
  bkr: "/companies/baker-hughes",
  "bkr stock": "/companies/baker-hughes",
  "baker hughes stock": "/companies/baker-hughes",
  /* baker-hughes */

  /* cintas-corporation */
  "cintas-corporation": "/companies/cintas-corporation",
  cintas: "/companies/cintas-corporation",
  "cintas corp": "/companies/cintas-corporation",
  "cintas uniforms": "/companies/cintas-corporation",
  "cintas workwear": "/companies/cintas-corporation",
  "cintas facility services": "/companies/cintas-corporation",
  "cintas safety": "/companies/cintas-corporation",
  "cintas fire protection": "/companies/cintas-corporation",
  ctas: "/companies/cintas-corporation",
  "ctas stock": "/companies/cintas-corporation",
  "cintas stock": "/companies/cintas-corporation",
  /* cintas-corporation */
  /* nongfu-spring */
  "nongfu-spring": "/companies/nongfu-spring",
  "nongfu spring": "/companies/nongfu-spring",
  nongfu: "/companies/nongfu-spring",
  "nongfu water": "/companies/nongfu-spring",
  "nongfu beverages": "/companies/nongfu-spring",
  "nongfu hangzhou": "/companies/nongfu-spring",
  "9633.hk": "/companies/nongfu-spring",
  "nongfu stock": "/companies/nongfu-spring",
  "9633 stock": "/companies/nongfu-spring",
  /* nongfu-spring */

  /* motorola-solutions */
  "motorola-solutions": "/companies/motorola-solutions",
  "motorola solutions": "/companies/motorola-solutions",
  motorola: "/companies/motorola-solutions",
  "motorola public safety": "/companies/motorola-solutions",
  "motorola radios": "/companies/motorola-solutions",
  "motorola command center": "/companies/motorola-solutions",
  "motorola chicago": "/companies/motorola-solutions",
  msi: "/companies/motorola-solutions",
  "msi stock": "/companies/motorola-solutions",
  "motorola solutions stock": "/companies/motorola-solutions",
  /* motorola-solutions */
  /* aon */
  aon: "/companies/aon",
  "aon plc": "/companies/aon",
  "aon london": "/companies/aon",
  "aon insurance": "/companies/aon",
  "aon risk management": "/companies/aon",
  "aon brokerage": "/companies/aon",
  "aon reinsurance": "/companies/aon",
  "aon consulting": "/companies/aon",
  aonnyse: "/companies/aon",
  aonstock: "/companies/aon",
  "aon stock": "/companies/aon",
  /* aon */

  /* manulife-financial */
  "manulife-financial": "/companies/manulife-financial",
  manulife: "/companies/manulife-financial",
  "manulife financial": "/companies/manulife-financial",
  "manulife canada": "/companies/manulife-financial",
  "manulife insurance": "/companies/manulife-financial",
  "manulife wealth": "/companies/manulife-financial",
  "manulife retirement": "/companies/manulife-financial",
  mfc: "/companies/manulife-financial",
  "mfc stock": "/companies/manulife-financial",
  "manulife stock": "/companies/manulife-financial",
  /* manulife-financial */
  /* macquarie-group */
  "macquarie-group": "/companies/macquarie-group",
  macquarie: "/companies/macquarie-group",
  "macquarie group": "/companies/macquarie-group",
  "macquarie australia": "/companies/macquarie-group",
  "macquarie bank": "/companies/macquarie-group",
  "macquarie asset management": "/companies/macquarie-group",
  "macquarie investment": "/companies/macquarie-group",
  "mqg.ax": "/companies/macquarie-group",
  "mqg stock": "/companies/macquarie-group",
  "macquarie stock": "/companies/macquarie-group",
  /* macquarie-group */
  /* maaden */
  maaden: "/companies/maaden",
  "ma'aden": "/companies/maaden",
  "saudi mining": "/companies/maaden",
  "maaden mining": "/companies/maaden",
  "maaden gold": "/companies/maaden",
  "maaden phosphate": "/companies/maaden",
  "maaden aluminum": "/companies/maaden",
  "1211.sr": "/companies/maaden",
  "maaden stock": "/companies/maaden",
  "1211 stock": "/companies/maaden",
  /* maaden */
  /* transdigm-group */
  "transdigm-group": "/companies/transdigm-group",
  transdigm: "/companies/transdigm-group",
  "transdigm group": "/companies/transdigm-group",
  "transdigm aerospace": "/companies/transdigm-group",
  "transdigm aircraft": "/companies/transdigm-group",
  "transdigm components": "/companies/transdigm-group",
  "transdigm cleveland": "/companies/transdigm-group",
  tdg: "/companies/transdigm-group",
  "tdg stock": "/companies/transdigm-group",
  "transdigm stock": "/companies/transdigm-group",
  /* transdigm-group */

  /* recruit-holdings */
  "recruit-holdings": "/companies/recruit-holdings",
  recruit: "/companies/recruit-holdings",
  "recruit holdings": "/companies/recruit-holdings",
  "recruit japan": "/companies/recruit-holdings",
  "recruit hr": "/companies/recruit-holdings",
  "recruit technology": "/companies/recruit-holdings",
  "recruit staffing": "/companies/recruit-holdings",
  "6098.t": "/companies/recruit-holdings",
  "recruit stock": "/companies/recruit-holdings",
  "6098 stock": "/companies/recruit-holdings",
  /* recruit-holdings */

  /* canadian-national-railway */
  "canadian-national-railway": "/companies/canadian-national-railway",
  "canadian national railway": "/companies/canadian-national-railway",
  cn: "/companies/canadian-national-railway",
  "cn rail": "/companies/canadian-national-railway",
  "cn railway": "/companies/canadian-national-railway",
  "cn freight": "/companies/canadian-national-railway",
  "cn intermodal": "/companies/canadian-national-railway",
  "cn montreal": "/companies/canadian-national-railway",
  cni: "/companies/canadian-national-railway",
  "cni stock": "/companies/canadian-national-railway",
  "canadian national stock": "/companies/canadian-national-railway",
  /* canadian-national-railway */

  /* air-products-and-chemicals */
  "air-products-and-chemicals": "/companies/air-products-and-chemicals",
  "air products": "/companies/air-products-and-chemicals",
  "air products inc": "/companies/air-products-and-chemicals",
  "air products gases": "/companies/air-products-and-chemicals",
  "air products hydrogen": "/companies/air-products-and-chemicals",
  "air products semiconductor": "/companies/air-products-and-chemicals",
  "air products cryogenic": "/companies/air-products-and-chemicals",
  apd: "/companies/air-products-and-chemicals",
  "apd stock": "/companies/air-products-and-chemicals",
  "air products stock": "/companies/air-products-and-chemicals",
  /* air-products-and-chemicals */

  /* generali */
  generali: "/companies/generali",
  "assicurazioni generali": "/companies/generali",
  "generali italy": "/companies/generali",
  "generali trieste": "/companies/generali",
  "generali insurance": "/companies/generali",
  "generali asset management": "/companies/generali",
  "generali pension": "/companies/generali",
  "g.mi": "/companies/generali",
  "generali stock": "/companies/generali",
  "gmi stock": "/companies/generali",
  /* generali */
  /* hong-kong-exchanges-clearing */
  "hong-kong-exchanges-clearing": "/companies/hong-kong-exchanges-clearing",
  "hong kong exchanges": "/companies/hong-kong-exchanges-clearing",
  "hong kong exchange": "/companies/hong-kong-exchanges-clearing",
  hkex: "/companies/hong-kong-exchanges-clearing",
  "hkex hong kong": "/companies/hong-kong-exchanges-clearing",
  "hkex trading": "/companies/hong-kong-exchanges-clearing",
  "hkex derivatives": "/companies/hong-kong-exchanges-clearing",
  "0388.hk": "/companies/hong-kong-exchanges-clearing",
  "hkex stock": "/companies/hong-kong-exchanges-clearing",
  "388 stock": "/companies/hong-kong-exchanges-clearing",
  /* hong-kong-exchanges-clearing */

  /* ross-stores */
  "ross-stores": "/companies/ross-stores",
  "ross stores": "/companies/ross-stores",
  ross: "/companies/ross-stores",
  "ross dress for less": "/companies/ross-stores",
  "dd's discounts": "/companies/ross-stores",
  "ross retail": "/companies/ross-stores",
  "ross apparel": "/companies/ross-stores",
  "ross home goods": "/companies/ross-stores",
  rost: "/companies/ross-stores",
  "rost stock": "/companies/ross-stores",
  "ross stores stock": "/companies/ross-stores",
  /* ross-stores */

  /* adnoc-gas */
  "adnoc-gas": "/companies/adnoc-gas",
  "adnoc gas": "/companies/adnoc-gas",
  adnoc: "/companies/adnoc-gas",
  "adnoc uae": "/companies/adnoc-gas",
  "adnoc natural gas": "/companies/adnoc-gas",
  "adnoc lng": "/companies/adnoc-gas",
  "adnoc ngl": "/companies/adnoc-gas",
  "adnoc industrial gas": "/companies/adnoc-gas",
  adnocgas: "/companies/adnoc-gas",
  "adnocgas.ae": "/companies/adnoc-gas",
  "adnoc gas stock": "/companies/adnoc-gas",
  /* adnoc-gas */

  /* phillips-66 */
  "phillips-66": "/companies/phillips-66",
  "phillips 66": "/companies/phillips-66",
  phillips: "/companies/phillips-66",
  "phillips energy": "/companies/phillips-66",
  "phillips refining": "/companies/phillips-66",
  "phillips midstream": "/companies/phillips-66",
  "phillips chemicals": "/companies/phillips-66",
  psx: "/companies/phillips-66",
  "psx stock": "/companies/phillips-66",
  "phillips 66 stock": "/companies/phillips-66",
  /* phillips-66 */

  /* digital-realty */
  "digital-realty": "/companies/digital-realty",
  "digital realty": "/companies/digital-realty",
  "digital realty trust": "/companies/digital-realty",
  "digital realty data center": "/companies/digital-realty",
  "digital realty colocation": "/companies/digital-realty",
  "dlr reit": "/companies/digital-realty",
  "dlr data centers": "/companies/digital-realty",
  dlr: "/companies/digital-realty",
  "dlr stock": "/companies/digital-realty",
  "digital realty stock": "/companies/digital-realty",
  /* digital-realty */

  /* energy-transfer */
  "energy-transfer": "/companies/energy-transfer",
  "energy transfer": "/companies/energy-transfer",
  "energy transfer lp": "/companies/energy-transfer",
  "energy transfer pipelines": "/companies/energy-transfer",
  "energy transfer natural gas": "/companies/energy-transfer",
  "energy transfer ngl": "/companies/energy-transfer",
  "energy transfer crude oil": "/companies/energy-transfer",
  et: "/companies/energy-transfer",
  "et stock": "/companies/energy-transfer",
  "energy transfer stock": "/companies/energy-transfer",
  /* energy-transfer */

  /* munich-re */
  "munich-re": "/companies/munich-re",
  "munich re": "/companies/munich-re",
  "münchener rück": "/companies/munich-re",
  "munich reinsurance": "/companies/munich-re",
  "munich re germany": "/companies/munich-re",
  "munich re bavaria": "/companies/munich-re",
  "muv2.de": "/companies/munich-re",
  "muv2 stock": "/companies/munich-re",
  "munich re stock": "/companies/munich-re",
  /* munich-re */
  /* american-electric-power */
  "american-electric-power": "/companies/american-electric-power",
  "american electric power": "/companies/american-electric-power",
  aep: "/companies/american-electric-power",
  "aep utilities": "/companies/american-electric-power",
  "aep ohio": "/companies/american-electric-power",
  "aep electricity": "/companies/american-electric-power",
  "aep power": "/companies/american-electric-power",
  "american electric": "/companies/american-electric-power",
  "aep stock": "/companies/american-electric-power",
  "american electric power stock": "/companies/american-electric-power",
  /* american-electric-power */

  /* volvo-group */
  "volvo-group": "/companies/volvo-group",
  "volvo group": "/companies/volvo-group",
  volvo: "/companies/volvo-group",
  "volvo trucks": "/companies/volvo-group",
  "volvo buses": "/companies/volvo-group",
  "volvo construction": "/companies/volvo-group",
  "volvo marine engines": "/companies/volvo-group",
  "volvo industrial": "/companies/volvo-group",
  "volv-a.st": "/companies/volvo-group",
  "volvo stock": "/companies/volvo-group",
  /* volvo-group */

  /* norfolk-southern */
  "norfolk-southern": "/companies/norfolk-southern",
  "norfolk southern": "/companies/norfolk-southern",
  "norfolk southern railway": "/companies/norfolk-southern",
  "norfolk southern railroad": "/companies/norfolk-southern",
  "ns rail": "/companies/norfolk-southern",
  "ns railway": "/companies/norfolk-southern",
  "ns intermodal": "/companies/norfolk-southern",
  nsc: "/companies/norfolk-southern",
  "nsc stock": "/companies/norfolk-southern",
  "norfolk southern stock": "/companies/norfolk-southern",
  /* norfolk-southern */

  /* tc-energy */
  "tc-energy": "/companies/tc-energy",
  "tc energy": "/companies/tc-energy",
  "tc energy corporation": "/companies/tc-energy",
  "tc pipelines": "/companies/tc-energy",
  "tc natural gas": "/companies/tc-energy",
  "tc liquids pipelines": "/companies/tc-energy",
  "tc energy storage": "/companies/tc-energy",
  trp: "/companies/tc-energy",
  "trp stock": "/companies/tc-energy",
  "tc energy stock": "/companies/tc-energy",
  /* tc-energy */

  /* japan-tobacco */
  "japan-tobacco": "/companies/japan-tobacco",
  "japan tobacco": "/companies/japan-tobacco",
  jti: "/companies/japan-tobacco",
  "jti japan": "/companies/japan-tobacco",
  "japan tobacco inc": "/companies/japan-tobacco",
  "japan tobacco company": "/companies/japan-tobacco",
  "jti tobacco": "/companies/japan-tobacco",
  "2914.t": "/companies/japan-tobacco",
  "2914 stock": "/companies/japan-tobacco",
  "japan tobacco stock": "/companies/japan-tobacco",
  /* japan-tobacco */

  /* ecolab */
  ecolab: "/companies/ecolab",
  "eco lab": "/companies/ecolab",
  "ecolab water": "/companies/ecolab",
  "ecolab hygiene": "/companies/ecolab",
  "ecolab sanitation": "/companies/ecolab",
  "ecolab infection prevention": "/companies/ecolab",
  ecl: "/companies/ecolab",
  "ecl stock": "/companies/ecolab",
  "ecolab stock": "/companies/ecolab",
  /* ecolab */

  /* colgate-palmolive */
  "colgate-palmolive": "/companies/colgate-palmolive",
  "colgate palmolive": "/companies/colgate-palmolive",
  colgate: "/companies/colgate-palmolive",
  "colgate toothpaste": "/companies/colgate-palmolive",
  "colgate oral care": "/companies/colgate-palmolive",
  "colgate home care": "/companies/colgate-palmolive",
  palmolive: "/companies/colgate-palmolive",
  cl: "/companies/colgate-palmolive",
  "cl stock": "/companies/colgate-palmolive",
  "colgate stock": "/companies/colgate-palmolive",
  /* colgate-palmolive */

  /* lg-energy-solution */
  "lg-energy-solution": "/companies/lg-energy-solution",
  "lg energy solution": "/companies/lg-energy-solution",
  "lg battery": "/companies/lg-energy-solution",
  "lg ev batteries": "/companies/lg-energy-solution",
  "lg ess": "/companies/lg-energy-solution",
  "lg rechargeable": "/companies/lg-energy-solution",
  "lg battery packs": "/companies/lg-energy-solution",
  "373220.ks": "/companies/lg-energy-solution",
  "lg energy stock": "/companies/lg-energy-solution",
  "373220 stock": "/companies/lg-energy-solution",
  /* lg-energy-solution */

  /* taqa */
  taqa: "/companies/taqa",
  "taqa uae": "/companies/taqa",
  "abu dhabi taqa": "/companies/taqa",
  "taqa energy": "/companies/taqa",
  "taqa power": "/companies/taqa",
  "taqa desalination": "/companies/taqa",
  "taqa utilities": "/companies/taqa",
  "taqa.ae": "/companies/taqa",
  "taqa stock": "/companies/taqa",
  "taqa ae stock": "/companies/taqa",
  /* taqa */

  /* royal-caribbean-group */
  "royal-caribbean-group": "/companies/royal-caribbean-group",
  "royal caribbean group": "/companies/royal-caribbean-group",
  "royal caribbean": "/companies/royal-caribbean-group",
  "royal caribbean cruises": "/companies/royal-caribbean-group",
  "royal caribbean vacation": "/companies/royal-caribbean-group",
  "royal cruise": "/companies/royal-caribbean-group",
  "rcl cruises": "/companies/royal-caribbean-group",
  rcl: "/companies/royal-caribbean-group",
  "rcl stock": "/companies/royal-caribbean-group",
  "royal caribbean stock": "/companies/royal-caribbean-group",
  /* royal-caribbean-group */

  /* hilton-worldwide */
  "hilton-worldwide": "/companies/hilton-worldwide",
  "hilton worldwide": "/companies/hilton-worldwide",
  hilton: "/companies/hilton-worldwide",
  "hilton hotels": "/companies/hilton-worldwide",
  "hilton resorts": "/companies/hilton-worldwide",
  "hilton hospitality": "/companies/hilton-worldwide",
  hlt: "/companies/hilton-worldwide",
  "hlt stock": "/companies/hilton-worldwide",
  "hilton stock": "/companies/hilton-worldwide",
  /* hilton-worldwide */

  /* comfort-systems-usa */
  "comfort-systems-usa": "/companies/comfort-systems-usa",
  "comfort systems usa": "/companies/comfort-systems-usa",
  "comfort systems": "/companies/comfort-systems-usa",
  "comfort hvac": "/companies/comfort-systems-usa",
  "comfort mechanical": "/companies/comfort-systems-usa",
  "comfort industrial hvac": "/companies/comfort-systems-usa",
  fix: "/companies/comfort-systems-usa",
  "fix stock": "/companies/comfort-systems-usa",
  "comfort systems stock": "/companies/comfort-systems-usa",
  /* comfort-systems-usa */

  /* vale */
  vale: "/companies/vale",
  "vale mining": "/companies/vale",
  "vale brazil": "/companies/vale",
  "vale iron ore": "/companies/vale",
  "vale nickel": "/companies/vale",
  "vale copper": "/companies/vale",
  "vale metals": "/companies/vale",
  "vale rio de janeiro": "/companies/vale",
  "vale.com": "/companies/vale",
  "vale stock": "/companies/vale",
  /* vale */

  /* rocket-lab */
  "rocket-lab": "/companies/rocket-lab",
  "rocket lab": "/companies/rocket-lab",
  "rocket lab usa": "/companies/rocket-lab",
  "rocket lab electron": "/companies/rocket-lab",
  "rocket lab neutron": "/companies/rocket-lab",
  "rocket lab launch": "/companies/rocket-lab",
  "rocket lab space": "/companies/rocket-lab",
  rklb: "/companies/rocket-lab",
  "rklb stock": "/companies/rocket-lab",
  "rocket lab stock": "/companies/rocket-lab",
  /* rocket-lab */

  /* eog-resources */
  "eog-resources": "/companies/eog-resources",
  "eog resources": "/companies/eog-resources",
  eog: "/companies/eog-resources",
  "eog oil": "/companies/eog-resources",
  "eog natural gas": "/companies/eog-resources",
  "eog ngl": "/companies/eog-resources",
  "eog energy": "/companies/eog-resources",
  "eog houston": "/companies/eog-resources",
  "eog stock": "/companies/eog-resources",
  "eog nyse": "/companies/eog-resources",
  /* eog-resources */

  /* illinois-tool-works */
  "illinois-tool-works": "/companies/illinois-tool-works",
  "illinois tool works": "/companies/illinois-tool-works",
  itw: "/companies/illinois-tool-works",
  "itw industrial": "/companies/illinois-tool-works",
  "itw fasteners": "/companies/illinois-tool-works",
  "itw welding": "/companies/illinois-tool-works",
  "itw food equipment": "/companies/illinois-tool-works",
  "itw automotive": "/companies/illinois-tool-works",
  "itw stock": "/companies/illinois-tool-works",
  "illinois tool works stock": "/companies/illinois-tool-works",
  /* illinois-tool-works */

  /* valero-energy */
  "valero-energy": "/companies/valero-energy",
  "valero energy": "/companies/valero-energy",
  valero: "/companies/valero-energy",
  "valero fuels": "/companies/valero-energy",
  "valero gasoline": "/companies/valero-energy",
  "valero diesel": "/companies/valero-energy",
  "valero jet fuel": "/companies/valero-energy",
  vlo: "/companies/valero-energy",
  "vlo stock": "/companies/valero-energy",
  "valero stock": "/companies/valero-energy",
  /* valero-energy */

  /* crh */
  crh: "/companies/crh",
  "crh plc": "/companies/crh",
  "cement roadstone holding": "/companies/crh",
  "crh cement": "/companies/crh",
  "crh aggregates": "/companies/crh",
  "crh asphalt": "/companies/crh",
  "crh building materials": "/companies/crh",
  "crh ireland": "/companies/crh",
  "crh stock": "/companies/crh",
  "crh nyse": "/companies/crh",
  /* crh */

  /* marathon-petroleum */
  "marathon-petroleum": "/companies/marathon-petroleum",
  "marathon petroleum": "/companies/marathon-petroleum",
  marathon: "/companies/marathon-petroleum",
  "marathon fuels": "/companies/marathon-petroleum",
  "marathon gasoline": "/companies/marathon-petroleum",
  "marathon diesel": "/companies/marathon-petroleum",
  "marathon jet fuel": "/companies/marathon-petroleum",
  mpc: "/companies/marathon-petroleum",
  "mpc stock": "/companies/marathon-petroleum",
  "marathon petroleum stock": "/companies/marathon-petroleum",
  /* marathon-petroleum */
  /* kinder-morgan */
  "kinder-morgan": "/companies/kinder-morgan",
  "kinder morgan": "/companies/kinder-morgan",
  "kinder morgan pipelines": "/companies/kinder-morgan",
  "kinder morgan terminals": "/companies/kinder-morgan",
  "kinder natural gas": "/companies/kinder-morgan",
  "kinder crude oil": "/companies/kinder-morgan",
  "kinder refined products": "/companies/kinder-morgan",
  kmi: "/companies/kinder-morgan",
  "kmi stock": "/companies/kinder-morgan",
  "kinder morgan stock": "/companies/kinder-morgan",
  /* kinder-morgan */

  /* murata-manufacturing */
  "murata-manufacturing": "/companies/murata-manufacturing",
  "murata manufacturing": "/companies/murata-manufacturing",
  "murata seisakusho": "/companies/murata-manufacturing",
  murata: "/companies/murata-manufacturing",
  "murata electronics": "/companies/murata-manufacturing",
  "murata capacitors": "/companies/murata-manufacturing",
  "murata sensors": "/companies/murata-manufacturing",
  "murata wireless": "/companies/murata-manufacturing",
  "6981.t": "/companies/murata-manufacturing",
  "murata stock": "/companies/murata-manufacturing",
  /* murata-manufacturing */

  /* nxp-semiconductors */
  "nxp-semiconductors": "/companies/nxp-semiconductors",
  "nxp semiconductors": "/companies/nxp-semiconductors",
  nxp: "/companies/nxp-semiconductors",
  "nxp chips": "/companies/nxp-semiconductors",
  "nxp automotive": "/companies/nxp-semiconductors",
  "nxp microcontrollers": "/companies/nxp-semiconductors",
  "nxp rf": "/companies/nxp-semiconductors",
  nxpi: "/companies/nxp-semiconductors",
  "nxpi stock": "/companies/nxp-semiconductors",
  "nxp stock": "/companies/nxp-semiconductors",
  /* nxp-semiconductors */

  /* deutsche-bank */
  "deutsche-bank": "/companies/deutsche-bank",
  "deutsche bank": "/companies/deutsche-bank",
  "db bank": "/companies/deutsche-bank",
  "deutsche investment bank": "/companies/deutsche-bank",
  "deutsche retail banking": "/companies/deutsche-bank",
  "deutsche asset management": "/companies/deutsche-bank",
  "frankfurt bank": "/companies/deutsche-bank",
  db: "/companies/deutsche-bank",
  "db stock": "/companies/deutsche-bank",
  "deutsche bank stock": "/companies/deutsche-bank",
  /* deutsche-bank */

  /* london-stock-exchange-group */
  "london-stock-exchange-group": "/companies/london-stock-exchange-group",
  "london stock exchange group": "/companies/london-stock-exchange-group",
  lseg: "/companies/london-stock-exchange-group",
  "lseg london": "/companies/london-stock-exchange-group",
  "lseg trading": "/companies/london-stock-exchange-group",
  "lseg market data": "/companies/london-stock-exchange-group",
  "lseg clearing": "/companies/london-stock-exchange-group",
  "lseg analytics": "/companies/london-stock-exchange-group",
  "lseg.l": "/companies/london-stock-exchange-group",
  "lseg stock": "/companies/london-stock-exchange-group",
  /* london-stock-exchange-group */

  /* natwest-group */
  "natwest-group": "/companies/natwest-group",
  "natwest group": "/companies/natwest-group",
  natwest: "/companies/natwest-group",
  "natwest bank": "/companies/natwest-group",
  "natwest uk": "/companies/natwest-group",
  "natwest personal banking": "/companies/natwest-group",
  "natwest business banking": "/companies/natwest-group",
  nwg: "/companies/natwest-group",
  "nwg stock": "/companies/natwest-group",
  "natwest stock": "/companies/natwest-group",
  /* natwest-group */

  /* coreweave */
  coreweave: "/companies/coreweave",
  "core weave": "/companies/coreweave",
  "coreweave gpu": "/companies/coreweave",
  "coreweave cloud": "/companies/coreweave",
  "coreweave ai": "/companies/coreweave",
  "coreweave hpc": "/companies/coreweave",
  crwv: "/companies/coreweave",
  "crwv stock": "/companies/coreweave",
  "coreweave stock": "/companies/coreweave",
  /* coreweave */
  /* te-connectivity */
  "te-connectivity": "/companies/te-connectivity",
  "te connectivity": "/companies/te-connectivity",
  "te connectors": "/companies/te-connectivity",
  "te sensors": "/companies/te-connectivity",
  "te industrial": "/companies/te-connectivity",
  "te automotive": "/companies/te-connectivity",
  // tel: "/companies/te-connectivity",
  "tel stock": "/companies/te-connectivity",
  "te connectivity stock": "/companies/te-connectivity",
  /* te-connectivity */

  /* credit-agricole */
  "credit-agricole": "/companies/credit-agricole",
  "crédit agricole": "/companies/credit-agricole",
  "credit agricole": "/companies/credit-agricole",
  "credit agricole bank": "/companies/credit-agricole",
  "credit agricole france": "/companies/credit-agricole",
  "credit agricole retail": "/companies/credit-agricole",
  "credit agricole corporate": "/companies/credit-agricole",
  aca: "/companies/credit-agricole",
  "aca.pa": "/companies/credit-agricole",
  "aca stock": "/companies/credit-agricole",
  "credit agricole stock": "/companies/credit-agricole",
  /* credit-agricole */
  /* sempra */
  sempra: "/companies/sempra",
  "sempra energy": "/companies/sempra",
  "sempra utilities": "/companies/sempra",
  "sempra gas": "/companies/sempra",
  "sempra electric": "/companies/sempra",
  "sempra infrastructure": "/companies/sempra",
  sre: "/companies/sempra",
  "sre stock": "/companies/sempra",
  "sempra stock": "/companies/sempra",
  /* sempra */
  /* dsv */
  dsv: "/companies/dsv",
  "dsv logistics": "/companies/dsv",
  "dsv transport": "/companies/dsv",
  "dsv freight": "/companies/dsv",
  "dsv forwarding": "/companies/dsv",
  "dsv supply chain": "/companies/dsv",
  "dsv air": "/companies/dsv",
  "dsv sea": "/companies/dsv",
  "dsv.vi": "/companies/dsv",
  "dsv stock": "/companies/dsv",
  /* dsv */
};
